const data = {
  'atlas_barriers--aerodrome--key': 'Flugplatztyp',
  'atlas_barriers--aerodrome=airsport': 'Luftsportgelände',
  'atlas_barriers--aerodrome=gliding': 'Segelflugplatz',
  'atlas_barriers--aerodrome=international': 'Internationaler Flughafen',
  'atlas_barriers--aerodrome=private': 'Privater Flugplatz',
  'atlas_barriers--aerodrome=regional': 'Regionaler Flugplatz',
  'atlas_barriers--area--key': 'Fläche',
  'atlas_barriers--bridge--key': 'Brücke',
  'atlas_barriers--bridge=aqueduct': 'Aquädukt',
  'atlas_barriers--bridge=boardwalk': 'Bohlensteg',
  'atlas_barriers--bridge=cantilever': 'Kragträgerbrücke',
  'atlas_barriers--bridge=covered': 'Überdachte Brücke',
  'atlas_barriers--bridge=low_water_crossing': 'Furtenartige Querung',
  'atlas_barriers--bridge=movable': 'Bewegliche Brücke',
  'atlas_barriers--bridge=viaduct': 'Viadukt',
  'atlas_barriers--bridge=yes': 'Brücke',
  'atlas_barriers--highway--key': 'Straßentyp',
  'atlas_barriers--highway=motorway': 'Autobahn',
  'atlas_barriers--highway=motorway_link': 'Autobahn-Anschluss',
  'atlas_barriers--highway=trunk': 'Kraftfahrstraße',
  'atlas_barriers--highway=trunk_link': 'Kraftfahrstraßen-Anschluss',
  'atlas_barriers--name--key': 'Name',
  'atlas_barriers--natural--key': 'Natürliche Barriere',
  'atlas_barriers--natural=water': 'Gewässer',
  'atlas_barriers--railway--key': 'Schienentyp',
  'atlas_barriers--railway=light_rail': 'Stadtbahn',
  'atlas_barriers--railway=rail': 'Bahnstrecke',
  'atlas_barriers--railway=subway': 'U-Bahn',
  'atlas_barriers--railway=tram': 'Straßenbahn',
  'atlas_barriers--title': 'Daten zu Linien-Barrieren',
  'atlas_barriers--tunnel--key': 'Tunnel',
  'atlas_barriers--tunnel=avalanche_protector': 'Lawinenschutzgalerie',
  'atlas_barriers--tunnel=building_passage': 'Gebäudedurchfahrt',
  'atlas_barriers--tunnel=culvert': 'Durchlass',
  'atlas_barriers--tunnel=flooded': 'Überflutet',
  'atlas_barriers--tunnel=yes': 'Tunnel',
  'atlas_barriers--usage--key': 'Schienennutzung',
  'atlas_barriers--usage=branch': 'Nebenstrecke',
  'atlas_barriers--usage=industrial': 'Industriegleis',
  'atlas_barriers--usage=leisure': 'Freizeitnutzung',
  'atlas_barriers--usage=main': 'Hauptstrecke',
  'atlas_barriers--usage=military': 'Militärisch',
  'atlas_barriers--usage=test': 'Teststrecke',
  'atlas_barriers--usage=tourism': 'Touristisch',
  'atlas_barriers--waterway--key': 'Gewässertyp',
  'atlas_barriers--waterway=canal': 'Kanal',
  'atlas_barriers--waterway=ditch': 'Graben',
  'atlas_barriers--waterway=drain': 'Entwässerungsgraben',
  'atlas_barriers--waterway=river': 'Fluss',
  'atlas_barriers--waterway=stream': 'Bach',
  'atlas_bicycleParking--access_cargo_bike--key': 'Zugang Lastenrad',
  'atlas_bicycleParking--access_cargo_bike=designated': 'Nur Lastenräder',
  'atlas_bicycleParking--access_cargo_bike=yes': 'Zugelassen',
  'atlas_bicycleParking--access--key': 'Zugang',
  'atlas_bicycleParking--access=customers': 'Kund:innen',
  'atlas_bicycleParking--access=members': 'Mitglieder',
  'atlas_bicycleParking--access=no': 'Kein Zugang',
  'atlas_bicycleParking--access=permissive': 'Öffentliche Nutzung geduldet',
  'atlas_bicycleParking--access=private': 'Privat',
  'atlas_bicycleParking--access=yes': 'Öffentlich',
  'atlas_bicycleParking--capacity--key': 'Anzahl Stellplätze',
  'atlas_bicycleParking--count--key': 'Anzahl Anlagen',
  'atlas_bicycleParking--covered--key': 'Überdacht',
  'atlas_bicycleParking--covered=implicit_no': 'Nicht überdacht (implizit)',
  'atlas_bicycleParking--covered=no': 'Nicht überdacht',
  'atlas_bicycleParking--covered=partial': 'Teilweise überdacht',
  'atlas_bicycleParking--covered=yes': 'Überdacht',
  'atlas_bicycleParking--description--key': 'Beschreibung',
  'atlas_bicycleParking--fee--key': 'Gebühren',
  'atlas_bicycleParking--fee=implicit_no': 'Kostenfrei (implizit)',
  'atlas_bicycleParking--fee=no': 'Kostenfrei',
  'atlas_bicycleParking--fee=yes': 'Gebührenpflichtig',
  'atlas_bicycleParking--geometry_transform--key': 'Geometrie geschätzt',
  'atlas_bicycleParking--geometry_transform=area_split': 'Fläche nach Stellplätzen geteilt',
  'atlas_bicycleParking--geometry_transform=line_halves': 'Linie in der Mitte geteilt',
  'atlas_bicycleParking--geometry_transform=point_offset': 'Nebeneinander gesetzt',
  'atlas_bicycleParking--in_mobility_hub--key': 'In Mobilitätsstation',
  'atlas_bicycleParking--in_mobility_hub=yes': 'Innerhalb einer Mobilitätsstation',
  'atlas_bicycleParking--indoor--key': 'Innenraum',
  'atlas_bicycleParking--indoor=yes': 'Innen',
  'atlas_bicycleParking--kind--key': 'Art',
  'atlas_bicycleParking--kind=bicycle_parking': 'Fahrradstellplätze',
  'atlas_bicycleParking--kind=bicycle_parking--description': '`amenity=bicycle_parking`',
  'atlas_bicycleParking--kind=bicycle_rental': 'Bikesharing-Stationen',
  'atlas_bicycleParking--kind=bicycle_rental--description':
    '`amenity=bicycle_rental`, ohne Fahrradverleih-Läden',
  'atlas_bicycleParking--kind=cargo_bike_parking': 'Lastenrad-Stellplätze',
  'atlas_bicycleParking--kind=cargo_bike_parking--description':
    '`amenity=bicycle_parking` mit `cargo_bike=designated` oder `capacity:cargo_bike`',
  'atlas_bicycleParking--kind=mobility_hub': 'Mobilitätsstationen',
  'atlas_bicycleParking--kind=mobility_hub--description':
    '`amenity=mobility_hub`. Eine Fläche, in der Stellplätze und Verleihstationen liegen; beim Summieren zählt sie nicht mit.',
  'atlas_bicycleParking--kind=small_electric_vehicle_parking':
    'E-Scooter- / Kleinstfahrzeug-Parkplätze',
  'atlas_bicycleParking--kind=small_electric_vehicle_parking--description':
    '`amenity=small_electric_vehicle_parking`, `amenity=kick-scooter_parking`',
  'atlas_bicycleParking--lit--key': 'Beleuchtung',
  'atlas_bicycleParking--lit=no': 'Nicht beleuchtet',
  'atlas_bicycleParking--lit=yes': 'Beleuchtet',
  'atlas_bicycleParking--mapillary--key': 'Mapillary',
  'atlas_bicycleParking--maxstay--key': 'Maximaldauer',
  'atlas_bicycleParking--name--key': 'Name',
  'atlas_bicycleParking--network--key': 'Netz / Verbund',
  'atlas_bicycleParking--operator_type--key': 'Betreibertyp',
  'atlas_bicycleParking--operator_type=private': 'Privat',
  'atlas_bicycleParking--operator_type=public': 'Öffentlich',
  'atlas_bicycleParking--operator--key': 'Betreiber',
  'atlas_bicycleParking--position--key': 'Lage',
  'atlas_bicycleParking--position=driveway': 'Zufahrt',
  'atlas_bicycleParking--position=grass_verge': 'Grünstreifen',
  'atlas_bicycleParking--position=kerb_extension': 'Gehwegvorstreckung',
  'atlas_bicycleParking--position=lane': 'Fahrbahn',
  'atlas_bicycleParking--position=park': 'Park',
  'atlas_bicycleParking--position=parking': 'Parkfläche',
  'atlas_bicycleParking--position=parking_lot': 'Parkplatz',
  'atlas_bicycleParking--position=parklet': 'Parklet',
  'atlas_bicycleParking--position=pedestrian_area': 'Fußgängerbereich',
  'atlas_bicycleParking--position=playground': 'Spielplatz',
  'atlas_bicycleParking--position=private_property': 'Privatgrund',
  'atlas_bicycleParking--position=public_property': 'Öffentliches Gelände',
  'atlas_bicycleParking--position=school_ground': 'Schulgelände',
  'atlas_bicycleParking--position=shoulder': 'Seitenstreifen',
  'atlas_bicycleParking--position=sidewalk': 'Gehweg',
  'atlas_bicycleParking--position=street_side': 'Straßenrand',
  'atlas_bicycleParking--position=traffic_island': 'Verkehrsinsel',
  'atlas_bicycleParking--rental_type--key': 'Art der Verleihstation',
  'atlas_bicycleParking--rental_type=docking_station': 'Station mit Andockpunkten',
  'atlas_bicycleParking--rental_type=dropoff_point': 'Abstellfläche (Free-Floating-Zone)',
  'atlas_bicycleParking--rental_type=key_dispensing_machine': 'Schlüsselautomat',
  'atlas_bicycleParking--stand_type--key': 'Art der Abstellanlage',
  'atlas_bicycleParking--stand_type=anchors': 'Bodenanker',
  'atlas_bicycleParking--stand_type=bollard': 'Poller',
  'atlas_bicycleParking--stand_type=building': 'Fahrradparkhaus',
  'atlas_bicycleParking--stand_type=floor': 'Abstellfläche ohne Halter',
  'atlas_bicycleParking--stand_type=ground_slots': 'Bodenschlitze',
  'atlas_bicycleParking--stand_type=handlebar_holder': 'Lenkerhalter',
  'atlas_bicycleParking--stand_type=lean_and_stick': 'Anlehnhilfe',
  'atlas_bicycleParking--stand_type=lockers': 'Fahrradboxen',
  'atlas_bicycleParking--stand_type=rack': 'Fahrradständer',
  'atlas_bicycleParking--stand_type=safe_loops': 'Sicherheitsbügel',
  'atlas_bicycleParking--stand_type=shed': 'Unterstand',
  'atlas_bicycleParking--stand_type=smart_dock': 'Smart-Dock',
  'atlas_bicycleParking--stand_type=stands': 'Anlehnbügel',
  'atlas_bicycleParking--stand_type=streetpod': 'Streetpod',
  'atlas_bicycleParking--stand_type=two-tier': 'Doppelstockparker',
  'atlas_bicycleParking--stand_type=upright_stands': 'Vertikalparker',
  'atlas_bicycleParking--stand_type=wall_loops': 'Wandhalter',
  'atlas_bicycleParking--stand_type=wide_stands': 'Breite Anlehnbügel',
  'atlas_bicycleParking--surface--key': 'Oberfläche',
  'atlas_bicycleParking--surface=asphalt': 'Asphalt',
  'atlas_bicycleParking--surface=bricks': 'Ziegel',
  'atlas_bicycleParking--surface=compacted': 'Verdichteter Untergrund',
  'atlas_bicycleParking--surface=concrete': 'Beton',
  'atlas_bicycleParking--surface=concrete:lanes': 'Betonstreifen / -bahnen',
  'atlas_bicycleParking--surface=concrete:plates': 'Betonplatten',
  'atlas_bicycleParking--surface=fine_gravel': 'Splitt',
  'atlas_bicycleParking--surface=grass': 'Gras',
  'atlas_bicycleParking--surface=grass_paver': 'Rasengitter / Grasgitter',
  'atlas_bicycleParking--surface=gravel': 'Schotter',
  'atlas_bicycleParking--surface=ground': 'Erde/Boden',
  'atlas_bicycleParking--surface=large_sett': 'Großpflaster',
  'atlas_bicycleParking--surface=metal': 'Metall',
  'atlas_bicycleParking--surface=metal_grid': 'Metallgitter',
  'atlas_bicycleParking--surface=mosaic_sett': 'Mosaikpflaster',
  'atlas_bicycleParking--surface=paved': 'Befestigt (unspezifisch)',
  'atlas_bicycleParking--surface=paving_stones': 'Verbund&shy;pflastersteine',
  'atlas_bicycleParking--surface=paving_stones:lanes': 'Pflasterstein&shy;bahnen',
  'atlas_bicycleParking--surface=pebblestone': 'Kieselsteine',
  'atlas_bicycleParking--surface=plastic': 'Kunststoff',
  'atlas_bicycleParking--surface=rubber': 'Gummi',
  'atlas_bicycleParking--surface=sand': 'Sand',
  'atlas_bicycleParking--surface=sett': 'Behauenes Pflaster / Natursteinpflaster',
  'atlas_bicycleParking--surface=small_sett': 'Kleinpflaster',
  'atlas_bicycleParking--surface=stone': 'Stein',
  'atlas_bicycleParking--surface=unpaved': 'Unbefestigt',
  'atlas_bicycleParking--surface=wood': 'Holz',
  'atlas_bicycleParking--surface=woodchips': 'Hackschnitzel',
  'atlas_bicycleParking--surveillance--key': 'Überwachung',
  'atlas_bicycleParking--surveillance=camera': 'Kamera',
  'atlas_bicycleParking--surveillance=indoor': 'Innen überwacht',
  'atlas_bicycleParking--surveillance=outdoor': 'Außenüberwachung',
  'atlas_bicycleParking--surveillance=private': 'Privat überwacht',
  'atlas_bicycleParking--surveillance=public': 'Öffentlich überwacht',
  'atlas_bicycleParking--surveillance=traffic': 'Verkehrsüberwachung',
  'atlas_bicycleParking--surveillance=webcam': 'Webcam',
  'atlas_bicycleParking--surveillance=yes': 'Überwacht',
  'atlas_bicycleParking--title': 'Fahrrad- & Mikromobilitätsparken',
  'atlas_bicycleParking--traffic_sign--key': 'Verkehrszeichen',
  'atlas_bikelanes--adjoining_maxspeed--key': 'Höchstgeschwindigkeit der angrenzenden Straße',
  'atlas_bikelanes--adjoining_road--key': 'Straßentyp der angrenzenden Straße',
  'atlas_bikelanes--adjoining_road=bicycle_road': 'Fahrradstraße',
  'atlas_bikelanes--adjoining_road=construction': 'Straße ist in Bau',
  'atlas_bikelanes--adjoining_road=cycleway': 'Radweg',
  'atlas_bikelanes--adjoining_road=cycleway_crossing': 'Straßenquerung (Radweg)',
  'atlas_bikelanes--adjoining_road=footway': 'Fußweg',
  'atlas_bikelanes--adjoining_road=footway_crossing': 'Straßenquerung (Fußweg)',
  'atlas_bikelanes--adjoining_road=footway_cycleway_crossing': 'Straßenquerung (Fuß- und Radweg)',
  'atlas_bikelanes--adjoining_road=footway_sidewalk': 'Gehweg',
  'atlas_bikelanes--adjoining_road=footway_steps': 'Treppe',
  'atlas_bikelanes--adjoining_road=living_street': 'Verkehrsberuhigter Bereich',
  'atlas_bikelanes--adjoining_road=motorway': 'Autobahn',
  'atlas_bikelanes--adjoining_road=motorway_link': 'Zufahrt einer Autobahn',
  'atlas_bikelanes--adjoining_road=path': 'Weg / Pfad',
  'atlas_bikelanes--adjoining_road=pedestrian': 'Fußgängerzone',
  'atlas_bikelanes--adjoining_road=primary': 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_bikelanes--adjoining_road=primary_link':
    'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_bikelanes--adjoining_road=residential': 'Anwohnerstraße',
  'atlas_bikelanes--adjoining_road=residential_priority_road': 'residential_priority_road',
  'atlas_bikelanes--adjoining_road=secondary': 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
  'atlas_bikelanes--adjoining_road=secondary_link':
    'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
  'atlas_bikelanes--adjoining_road=service_alley': 'Gasse',
  'atlas_bikelanes--adjoining_road=service_driveway': 'Grundstückszufahrt',
  'atlas_bikelanes--adjoining_road=service_emergency_access': 'Rettungsweg',
  'atlas_bikelanes--adjoining_road=service_parking_aisle': 'Parkplatzweg',
  'atlas_bikelanes--adjoining_road=service_road': 'Zufahrtsweg',
  'atlas_bikelanes--adjoining_road=service_uncategorized':
    'Zufahrtsweg (unbekannte Klassifizierung)',
  'atlas_bikelanes--adjoining_road=tertiary':
    'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
  'atlas_bikelanes--adjoining_road=tertiary_link':
    'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
  'atlas_bikelanes--adjoining_road=track': 'Wald- / Feldweg',
  'atlas_bikelanes--adjoining_road=unclassified': 'Nebenstraße mit Verbindungscharakter',
  'atlas_bikelanes--adjoining_road=unspecified_road': 'Unkategorisierte Straße',
  'atlas_bikelanes--bridge--key': 'Brücke',
  'atlas_bikelanes--bridge=yes': 'Ja',
  'atlas_bikelanes--buffer_left--key': 'Schutzraum (Links)',
  'atlas_bikelanes--buffer_right--key': 'Schutzraum (Rechts)',
  'atlas_bikelanes--category--key': 'Bauliche Führung',
  'atlas_bikelanes--category=bicycleRoad': 'Fahrradstraße',
  'atlas_bikelanes--category=bicycleRoad_vehicleDestination': 'Fahrradstraße mit Anlieger/Kfz frei',
  'atlas_bikelanes--category=crossing': 'Straßenquerung',
  'atlas_bikelanes--category=cycleway_adjoining': 'Radweg (straßenbegleitend)',
  'atlas_bikelanes--category=cycleway_adjoiningOrIsolated':
    'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanes--category=cycleway_isolated': 'Radweg, selbstständig geführt',
  'atlas_bikelanes--category=cyclewayLink': 'Radweg-Verbindungsstück',
  'atlas_bikelanes--category=cyclewayOnHighway_advisory': 'Schutzstreifen',
  'atlas_bikelanes--category=cyclewayOnHighway_advisoryOrExclusive':
    'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
  'atlas_bikelanes--category=cyclewayOnHighway_exclusive': 'Radfahrstreifen',
  'atlas_bikelanes--category=cyclewayOnHighwayBetweenLanes':
    'Radfahrstreifen in Mittellage (Fahrradweiche)',
  'atlas_bikelanes--category=cyclewayOnHighwayProtected': 'Geschützter Radfahrstreifen (PBL)',
  'atlas_bikelanes--category=footAndCyclewaySegregated_adjoining':
    'Getrennter Rad- und Gehweg, straßenbegleitend',
  'atlas_bikelanes--category=footAndCyclewaySegregated_adjoiningOrIsolated':
    'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanes--category=footAndCyclewaySegregated_isolated':
    'Getrennter Rad- und Gehweg, selbstständig geführt',
  'atlas_bikelanes--category=footAndCyclewayShared_adjoining':
    'Gemeinsamer Geh- und Radweg, straßenbegleitend',
  'atlas_bikelanes--category=footAndCyclewayShared_adjoiningOrIsolated':
    'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanes--category=footAndCyclewayShared_isolated':
    'Gemeinsamer Geh- und Radweg, selbstständig geführt',
  'atlas_bikelanes--category=footwayBicycleYes_adjoining':
    'Gehweg mit Radfahrer frei, straßenbegleitend',
  'atlas_bikelanes--category=footwayBicycleYes_adjoiningOrIsolated':
    'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanes--category=footwayBicycleYes_isolated':
    'Gehweg mit Radfahrer frei, selbstständig geführt',
  'atlas_bikelanes--category=needsClarification': 'Führungsform unklar',
  'atlas_bikelanes--category=pedestrianAreaBicycleYes': 'Fußgängerzone, Fahrrad frei',
  'atlas_bikelanes--category=sharedBusLaneBikeWithBus': 'Radfahrstreifen mit Freigabe Busverkehr',
  'atlas_bikelanes--category=sharedBusLaneBusWithBike': 'Bussonderfahrstreifen mit Fahrrad frei',
  'atlas_bikelanes--category=sharedMotorVehicleLane': 'Anteilig genutzter Fahrstreifen (Sharrows)',
  'atlas_bikelanes--covered--key': 'Überdacht',
  'atlas_bikelanes--covered=covered': 'Überdacht',
  'atlas_bikelanes--covered=covered--description':
    'Vollständig überdachte Wege (`covered=yes`) und Arkaden (`covered=arcade`, zur Seite hin offen).',
  'atlas_bikelanes--covered=indoor': 'In einem Gebäude',
  'atlas_bikelanes--covered=partial': 'Teilweise überdacht',
  'atlas_bikelanes--description--key': 'Hinweis aus OSM',
  'atlas_bikelanes--informal--key': 'Trampelpfad',
  'atlas_bikelanes--informal=yes': 'Weg als informeller Weg erfasst',
  'atlas_bikelanes--length--key': 'Länge',
  'atlas_bikelanes--lifecycle--key': 'Status',
  'atlas_bikelanes--lifecycle=blocked': 'Gesperrt (Sperrung)',
  'atlas_bikelanes--lifecycle=construction': 'In Bau',
  'atlas_bikelanes--lifecycle=construction_no_access': 'Gesperrt aufgrund einer Baustelle',
  'atlas_bikelanes--lifecycle=temporary': 'Temporärer Weg',
  'atlas_bikelanes--lit--key': 'Beleuchtung',
  'atlas_bikelanes--lit=no': 'Nicht beleuchtet',
  'atlas_bikelanes--lit=special': 'Spezielle Angaben',
  'atlas_bikelanes--lit=yes': 'Beleuchtet',
  'atlas_bikelanes--mapillary_backward--key': 'Mapillary gegen Linienrichtung',
  'atlas_bikelanes--mapillary_coverage--key': 'Mapillary-Abdeckung',
  'atlas_bikelanes--mapillary_coverage=pano': 'Panorama-Aufnahmen',
  'atlas_bikelanes--mapillary_coverage=regular': 'Standard-Aufnahmen',
  'atlas_bikelanes--mapillary_forward--key': 'Mapillary in Linienrichtung',
  'atlas_bikelanes--mapillary_traffic_sign--key': 'Mapillary für Verkehrszeichen',
  'atlas_bikelanes--mapillary--key': 'Straßenfotos (Mapillary)',
  'atlas_bikelanes--marking_left--key': 'Markierung (Links)',
  'atlas_bikelanes--marking_left=barred_area': 'Schraffur',
  'atlas_bikelanes--marking_left=dashed_line': 'Gestrichelte Linie',
  'atlas_bikelanes--marking_left=double_solid_line': 'Doppelte durchgezogene Linie',
  'atlas_bikelanes--marking_left=pictogram': 'Piktogramm',
  'atlas_bikelanes--marking_left=solid_line': 'Durchgezogene Linie',
  'atlas_bikelanes--marking_left=surface': 'Oberfläche',
  'atlas_bikelanes--marking_right--key': 'Markierung (Rechts)',
  'atlas_bikelanes--marking_right=barred_area': 'Schraffur',
  'atlas_bikelanes--marking_right=dashed_line': 'Gestrichelte Linie',
  'atlas_bikelanes--marking_right=double_solid_line': 'Doppelte durchgezogene Linie',
  'atlas_bikelanes--marking_right=pictogram': 'Piktogramm',
  'atlas_bikelanes--marking_right=solid_line': 'Durchgezogene Linie',
  'atlas_bikelanes--marking_right=surface': 'Oberfläche',
  'atlas_bikelanes--name--key': 'Name',
  'atlas_bikelanes--offset--key': 'Linien-Offset',
  'atlas_bikelanes--oneway--key': 'Verkehrsrichtung',
  'atlas_bikelanes--oneway=assumed_no': 'Wahrscheinlich beide Richtungen',
  'atlas_bikelanes--oneway=assumed_no--description':
    'Keine explizite OSM-Angabe zur Verkehrsrichtung vorhanden. Aus Führungsform und Umfeld wird hier beide Richtungen als wahrscheinlich angenommen.',
  'atlas_bikelanes--oneway=car_not_bike': 'Beide Richtungen für Fahrrad; Einbahnstraße für Kfz',
  'atlas_bikelanes--oneway=implicit_yes': 'Eine Richtung (abgeleitet)',
  'atlas_bikelanes--oneway=implicit_yes--description':
    'Keine explizite OSM-Angabe (`oneway` / `oneway:bicycle`). Aus der Führungsform abgeleitet (z. B. Schutzstreifen), nicht aus einem oneway-Tag gelesen.',
  'atlas_bikelanes--oneway=no': 'Beide Richtungen',
  'atlas_bikelanes--oneway=yes': 'Eine Richtung',
  'atlas_bikelanes--operator_type--key': 'Betreibertyp',
  'atlas_bikelanes--operator_type=private': 'Privat',
  'atlas_bikelanes--operator_type=public': 'Öffentlich',
  'atlas_bikelanes--parent_maxspeed--key': 'Höchstgeschwindigkeit der zugeordneten Straße',
  'atlas_bikelanes--parent_road--key': 'Straßentyp',
  'atlas_bikelanes--parent_road=bicycle_road': 'Fahrradstraße',
  'atlas_bikelanes--parent_road=construction': 'Straße ist in Bau',
  'atlas_bikelanes--parent_road=cycleway': 'Radweg',
  'atlas_bikelanes--parent_road=cycleway_crossing': 'Straßenquerung (Radweg)',
  'atlas_bikelanes--parent_road=footway': 'Fußweg',
  'atlas_bikelanes--parent_road=footway_crossing': 'Straßenquerung (Fußweg)',
  'atlas_bikelanes--parent_road=footway_cycleway_crossing': 'Straßenquerung (Fuß- und Radweg)',
  'atlas_bikelanes--parent_road=footway_sidewalk': 'Gehweg',
  'atlas_bikelanes--parent_road=footway_steps': 'Treppe',
  'atlas_bikelanes--parent_road=living_street': 'Verkehrsberuhigter Bereich',
  'atlas_bikelanes--parent_road=motorway': 'Autobahn',
  'atlas_bikelanes--parent_road=motorway_link': 'Zufahrt einer Autobahn',
  'atlas_bikelanes--parent_road=path': 'Weg / Pfad',
  'atlas_bikelanes--parent_road=pedestrian': 'Fußgängerzone',
  'atlas_bikelanes--parent_road=primary': 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_bikelanes--parent_road=primary_link':
    'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_bikelanes--parent_road=residential': 'Anwohnerstraße',
  'atlas_bikelanes--parent_road=residential_priority_road': 'residential_priority_road',
  'atlas_bikelanes--parent_road=secondary': 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
  'atlas_bikelanes--parent_road=secondary_link':
    'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
  'atlas_bikelanes--parent_road=service_alley': 'Gasse',
  'atlas_bikelanes--parent_road=service_driveway': 'Grundstückszufahrt',
  'atlas_bikelanes--parent_road=service_emergency_access': 'Rettungsweg',
  'atlas_bikelanes--parent_road=service_parking_aisle': 'Parkplatzweg',
  'atlas_bikelanes--parent_road=service_road': 'Zufahrtsweg',
  'atlas_bikelanes--parent_road=service_uncategorized': 'Zufahrtsweg (unbekannte Klassifizierung)',
  'atlas_bikelanes--parent_road=tertiary': 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
  'atlas_bikelanes--parent_road=tertiary_link':
    'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
  'atlas_bikelanes--parent_road=track': 'Wald- / Feldweg',
  'atlas_bikelanes--parent_road=unclassified': 'Nebenstraße mit Verbindungscharakter',
  'atlas_bikelanes--parent_road=unspecified_road': 'Unkategorisierte Straße',
  'atlas_bikelanes--prefix--key': 'Quellpräfix',
  'atlas_bikelanes--prefix=cycleway': 'Aus `cycleway:*`-Tags extrahiert',
  'atlas_bikelanes--prefix=sidewalk': 'Aus `sidewalk:*`-Tags extrahiert',
  'atlas_bikelanes--road--key': 'Straßentyp Fahrbahn',
  'atlas_bikelanes--road=bicycle_road': 'Fahrradstraße',
  'atlas_bikelanes--road=construction': 'Straße ist in Bau',
  'atlas_bikelanes--road=cycleway': 'Radweg',
  'atlas_bikelanes--road=cycleway_crossing': 'Straßenquerung (Radweg)',
  'atlas_bikelanes--road=footway': 'Fußweg',
  'atlas_bikelanes--road=footway_crossing': 'Straßenquerung (Fußweg)',
  'atlas_bikelanes--road=footway_cycleway_crossing': 'Straßenquerung (Fuß- und Radweg)',
  'atlas_bikelanes--road=footway_sidewalk': 'Gehweg',
  'atlas_bikelanes--road=footway_steps': 'Treppe',
  'atlas_bikelanes--road=living_street': 'Verkehrsberuhigter Bereich',
  'atlas_bikelanes--road=motorway': 'Autobahn',
  'atlas_bikelanes--road=motorway_link': 'Zufahrt einer Autobahn',
  'atlas_bikelanes--road=path': 'Weg / Pfad',
  'atlas_bikelanes--road=pedestrian': 'Fußgängerzone',
  'atlas_bikelanes--road=primary': 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_bikelanes--road=primary_link':
    'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_bikelanes--road=residential': 'Anwohnerstraße',
  'atlas_bikelanes--road=residential_priority_road': 'residential_priority_road',
  'atlas_bikelanes--road=secondary': 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
  'atlas_bikelanes--road=secondary_link':
    'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
  'atlas_bikelanes--road=service_alley': 'Gasse',
  'atlas_bikelanes--road=service_driveway': 'Grundstückszufahrt',
  'atlas_bikelanes--road=service_emergency_access': 'Rettungsweg',
  'atlas_bikelanes--road=service_parking_aisle': 'Parkplatzweg',
  'atlas_bikelanes--road=service_road': 'Zufahrtsweg',
  'atlas_bikelanes--road=service_uncategorized': 'Zufahrtsweg (unbekannte Klassifizierung)',
  'atlas_bikelanes--road=tertiary': 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
  'atlas_bikelanes--road=tertiary_link':
    'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
  'atlas_bikelanes--road=track': 'Wald- / Feldweg',
  'atlas_bikelanes--road=unclassified': 'Nebenstraße mit Verbindungscharakter',
  'atlas_bikelanes--road=unspecified_road': 'Unkategorisierte Straße',
  'atlas_bikelanes--route_relations--key': 'Routen',
  'atlas_bikelanes--separation_left--key': 'Abgrenzung (Links)',
  'atlas_bikelanes--separation_left=bollard': 'Poller',
  'atlas_bikelanes--separation_left=bump': 'Bodenschwelle',
  'atlas_bikelanes--separation_left=cone': 'Kegel',
  'atlas_bikelanes--separation_left=ditch': 'Graben',
  'atlas_bikelanes--separation_left=fence': 'Zaun',
  'atlas_bikelanes--separation_left=flex_post': 'Flexpfosten',
  'atlas_bikelanes--separation_left=greenery': 'Begrünung',
  'atlas_bikelanes--separation_left=guard_rail': 'Leitplanke',
  'atlas_bikelanes--separation_left=hedge': 'Hecke',
  'atlas_bikelanes--separation_left=jersey_barrier': 'Betonleitwand',
  'atlas_bikelanes--separation_left=kerb': 'Bordstein',
  'atlas_bikelanes--separation_left=kerb;bollard': 'Bordstein, dann Poller',
  'atlas_bikelanes--separation_left=kerb;parking_lane': 'Bordstein, dann Parkstreifen',
  'atlas_bikelanes--separation_left=no': 'Keine physische Abgrenzung',
  'atlas_bikelanes--separation_left=planter': 'Pflanzkübel',
  'atlas_bikelanes--separation_left=structure': 'Struktur',
  'atlas_bikelanes--separation_left=studs': 'Bodenmarkierungsnägel',
  'atlas_bikelanes--separation_left=tree_row': 'Baumreihe',
  'atlas_bikelanes--separation_left=vertical_panel': 'Vertikales Panel',
  'atlas_bikelanes--separation_left=yes': 'Unspezifische Abgrenzung',
  'atlas_bikelanes--separation_right--key': 'Abgrenzung (Rechts)',
  'atlas_bikelanes--separation_right=bollard': 'Poller',
  'atlas_bikelanes--separation_right=bump': 'Bodenschwelle',
  'atlas_bikelanes--separation_right=cone': 'Kegel',
  'atlas_bikelanes--separation_right=ditch': 'Graben',
  'atlas_bikelanes--separation_right=fence': 'Zaun',
  'atlas_bikelanes--separation_right=flex_post': 'Flexpfosten',
  'atlas_bikelanes--separation_right=greenery': 'Begrünung',
  'atlas_bikelanes--separation_right=guard_rail': 'Leitplanke',
  'atlas_bikelanes--separation_right=hedge': 'Hecke',
  'atlas_bikelanes--separation_right=jersey_barrier': 'Betonleitwand',
  'atlas_bikelanes--separation_right=kerb': 'Bordstein',
  'atlas_bikelanes--separation_right=kerb;bollard': 'Bordstein, dann Poller',
  'atlas_bikelanes--separation_right=kerb;parking_lane': 'Bordstein, dann Parkstreifen',
  'atlas_bikelanes--separation_right=no': 'Keine physische Abgrenzung',
  'atlas_bikelanes--separation_right=planter': 'Pflanzkübel',
  'atlas_bikelanes--separation_right=structure': 'Struktur',
  'atlas_bikelanes--separation_right=studs': 'Bodenmarkierungsnägel',
  'atlas_bikelanes--separation_right=tree_row': 'Baumreihe',
  'atlas_bikelanes--separation_right=vertical_panel': 'Vertikales Panel',
  'atlas_bikelanes--separation_right=yes': 'Unspezifische Abgrenzung',
  'atlas_bikelanes--smoothness_confidence--key': 'Konfidenz Ober&shy;flächen&shy;qualität',
  'atlas_bikelanes--smoothness_confidence=high': 'Hoch',
  'atlas_bikelanes--smoothness_confidence=medium': 'Mittel',
  'atlas_bikelanes--smoothness_source--key': 'Herkunft der Ober&shy;flächen&shy;qualität',
  'atlas_bikelanes--smoothness_source=mtb:scale_to_smoothness': 'Abgeleitet von `mtb:scale`',
  'atlas_bikelanes--smoothness_source=parent_highway_mtb:scale_to_smoothness':
    'Von `mtb:scale` der zugeordneten Straße abgeleitet',
  'atlas_bikelanes--smoothness_source=parent_highway_surface_to_smoothness':
    'Von Oberfläche der zugeordneten Straße abgeleitet',
  'atlas_bikelanes--smoothness_source=parent_highway_tag': 'Von zugeordneter Straße (OSM)',
  'atlas_bikelanes--smoothness_source=parent_highway_tag_normalized':
    'Von zugeordneter Straße (normalisiert)',
  'atlas_bikelanes--smoothness_source=parent_highway_tracktype_to_smoothness':
    'Von `tracktype` der zugeordneten Straße abgeleitet',
  'atlas_bikelanes--smoothness_source=surface_to_smoothness': 'Abgeleitet von `surface`',
  'atlas_bikelanes--smoothness_source=tag': 'OSM-Tag `smoothness`',
  'atlas_bikelanes--smoothness_source=tag_normalized': 'OSM-Tag `smoothness` (normalisiert)',
  'atlas_bikelanes--smoothness_source=tracktype_to_smoothness': 'Abgeleitet von `tracktype`',
  'atlas_bikelanes--smoothness--key': 'Ober&shy;flächen&shy;qualität',
  'atlas_bikelanes--smoothness=bad': 'Schlecht',
  'atlas_bikelanes--smoothness=excellent': 'Sehr gut',
  'atlas_bikelanes--smoothness=good': 'Gut',
  'atlas_bikelanes--smoothness=intermediate': 'Mittel gut',
  'atlas_bikelanes--smoothness=very_bad': 'Sehr schlecht',
  'atlas_bikelanes--surface_color--key': 'Ober&shy;flächen&shy;farbe',
  'atlas_bikelanes--surface_color=green': 'Grün',
  'atlas_bikelanes--surface_color=no': 'Keine besondere Farbe',
  'atlas_bikelanes--surface_color=red': 'Rot',
  'atlas_bikelanes--surface_color=red;green': 'Rot und Grün',
  'atlas_bikelanes--surface_confidence--key': 'Konfidenz der Oberfläche',
  'atlas_bikelanes--surface_confidence=high': 'Hoch',
  'atlas_bikelanes--surface_confidence=low': 'Niedrig',
  'atlas_bikelanes--surface_confidence=medium': 'Mittel',
  'atlas_bikelanes--surface_source--key': 'Herkunft der Oberfläche',
  'atlas_bikelanes--surface_source=parent_highway_tag': 'Von zugeordneter Straße (OSM)',
  'atlas_bikelanes--surface_source=parent_highway_tag_transformed':
    'Von zugeordneter Straße, normalisiert',
  'atlas_bikelanes--surface_source=tag': 'Explizite Angabe aus OSM',
  'atlas_bikelanes--surface_source=tag_transformed': 'Aus OSM-Tag normalisiert',
  'atlas_bikelanes--surface--key': 'Oberfläche',
  'atlas_bikelanes--surface=asphalt': 'Asphalt',
  'atlas_bikelanes--surface=bricks': 'Ziegel',
  'atlas_bikelanes--surface=compacted': 'Verdichteter Untergrund',
  'atlas_bikelanes--surface=concrete': 'Beton',
  'atlas_bikelanes--surface=concrete:lanes': 'Betonstreifen / -bahnen',
  'atlas_bikelanes--surface=concrete:plates': 'Betonplatten',
  'atlas_bikelanes--surface=fine_gravel': 'Splitt',
  'atlas_bikelanes--surface=grass': 'Gras',
  'atlas_bikelanes--surface=grass_paver': 'Rasengitter / Grasgitter',
  'atlas_bikelanes--surface=gravel': 'Schotter',
  'atlas_bikelanes--surface=ground': 'Erde/Boden',
  'atlas_bikelanes--surface=large_sett': 'Großpflaster',
  'atlas_bikelanes--surface=metal': 'Metall',
  'atlas_bikelanes--surface=metal_grid': 'Metallgitter',
  'atlas_bikelanes--surface=mosaic_sett': 'Mosaikpflaster',
  'atlas_bikelanes--surface=paved': 'Befestigt (unspezifisch)',
  'atlas_bikelanes--surface=paving_stones': 'Verbund&shy;pflastersteine',
  'atlas_bikelanes--surface=paving_stones:lanes': 'Pflasterstein&shy;bahnen',
  'atlas_bikelanes--surface=pebblestone': 'Kieselsteine',
  'atlas_bikelanes--surface=plastic': 'Kunststoff',
  'atlas_bikelanes--surface=rubber': 'Gummi',
  'atlas_bikelanes--surface=sand': 'Sand',
  'atlas_bikelanes--surface=sett': 'Behauenes Pflaster / Natursteinpflaster',
  'atlas_bikelanes--surface=small_sett': 'Kleinpflaster',
  'atlas_bikelanes--surface=stone': 'Stein',
  'atlas_bikelanes--surface=unpaved': 'Unbefestigt',
  'atlas_bikelanes--surface=wood': 'Holz',
  'atlas_bikelanes--surface=woodchips': 'Hackschnitzel',
  'atlas_bikelanes--title': 'Daten zur Radinfrastruktur',
  'atlas_bikelanes--todos--key': 'Todo-Liste',
  'atlas_bikelanes--traffic_mode_left--key': 'Verkehrsform (Links)',
  'atlas_bikelanes--traffic_mode_left=bicycle': 'Fahrrad',
  'atlas_bikelanes--traffic_mode_left=foot': 'Fußgänger',
  'atlas_bikelanes--traffic_mode_left=motor_vehicle': 'Kraftfahrzeuge',
  'atlas_bikelanes--traffic_mode_left=no': 'Kein Verkehr',
  'atlas_bikelanes--traffic_mode_left=parking': 'Parken',
  'atlas_bikelanes--traffic_mode_left=psv': 'ÖPNV (Bus/Tram)',
  'atlas_bikelanes--traffic_mode_right--key': 'Verkehrsform (Rechts)',
  'atlas_bikelanes--traffic_mode_right=bicycle': 'Fahrrad',
  'atlas_bikelanes--traffic_mode_right=foot': 'Fußgänger',
  'atlas_bikelanes--traffic_mode_right=motor_vehicle': 'Kraftfahrzeuge',
  'atlas_bikelanes--traffic_mode_right=no': 'Kein Verkehr',
  'atlas_bikelanes--traffic_mode_right=parking': 'Parken',
  'atlas_bikelanes--traffic_mode_right=psv': 'ÖPNV (Bus/Tram)',
  'atlas_bikelanes--traffic_sign--key': 'Beschilderung',
  'atlas_bikelanes--traffic_sign:backward--key': 'Beschilderung in Gegenrichtung',
  'atlas_bikelanes--traffic_sign:backward=never': 'Kein Verkehrszeichen erwartet',
  'atlas_bikelanes--traffic_sign:backward=never--description':
    'Wird aktuell intern für `category=cyclewayOnHighwayBetweenLanes` verwendet um klarzustellen, dass hier nie ein Verkehrszeichen zu erwarten ist.',
  'atlas_bikelanes--traffic_sign:backward=none': 'Unbeschildert',
  'atlas_bikelanes--traffic_sign:forward--key': 'Beschilderung in Verkehrsrichtung',
  'atlas_bikelanes--traffic_sign:forward=never': 'Kein Verkehrszeichen erwartet',
  'atlas_bikelanes--traffic_sign:forward=never--description':
    'Wird aktuell intern für `category=cyclewayOnHighwayBetweenLanes` verwendet um klarzustellen, dass hier nie ein Verkehrszeichen zu erwarten ist.',
  'atlas_bikelanes--traffic_sign:forward=none': 'Unbeschildert',
  'atlas_bikelanes--traffic_sign=never': 'Kein Verkehrszeichen erwartet',
  'atlas_bikelanes--traffic_sign=never--description':
    'Wird aktuell intern für `category=cyclewayOnHighwayBetweenLanes` verwendet um klarzustellen, dass hier nie ein Verkehrszeichen zu erwarten ist.',
  'atlas_bikelanes--traffic_sign=none': 'Unbeschildert',
  'atlas_bikelanes--tunnel--key': 'Tunnel',
  'atlas_bikelanes--tunnel=yes': 'Ja',
  'atlas_bikelanes--tunnel=yes--description':
    'Wege mit `tunnel=yes` und Gebäudedurchgänge mit `tunnel=building_passage`.',
  'atlas_bikelanes--width_effective--key': 'Effektive Breite',
  'atlas_bikelanes--width_source--key': 'Quelle Breite',
  'atlas_bikelanes--width_source=ALKIS': 'Aus ALKIS Daten ausgemessen',
  'atlas_bikelanes--width_source=ARCore': 'Mit dem Handy-Metermaß von StreetComplete gemessen',
  'atlas_bikelanes--width--key': 'Breite',
  'atlas_bikelanesPresence--bikelane_left--key': 'Radinfrastruktur links',
  'atlas_bikelanesPresence--bikelane_left=assumed_no': 'Vermutlich vollständig',
  'atlas_bikelanesPresence--bikelane_left=bicycleRoad': 'Fahrradstraße',
  'atlas_bikelanesPresence--bikelane_left=bicycleRoad_vehicleDestination':
    'Fahrradstraße mit Anlieger/Kfz frei',
  'atlas_bikelanesPresence--bikelane_left=crossing': 'Straßenquerung',
  'atlas_bikelanesPresence--bikelane_left=cycleway_adjoining': 'Radweg (straßenbegleitend)',
  'atlas_bikelanesPresence--bikelane_left=cycleway_adjoiningOrIsolated':
    'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_left=cycleway_isolated': 'Radweg, selbstständig geführt',
  'atlas_bikelanesPresence--bikelane_left=cyclewayLink': 'Radweg-Verbindungsstück',
  'atlas_bikelanesPresence--bikelane_left=cyclewayOnHighway_advisory': 'Schutzstreifen',
  'atlas_bikelanesPresence--bikelane_left=cyclewayOnHighway_advisoryOrExclusive':
    'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_left=cyclewayOnHighway_exclusive': 'Radfahrstreifen',
  'atlas_bikelanesPresence--bikelane_left=cyclewayOnHighwayBetweenLanes':
    'Radfahrstreifen in Mittellage (Fahrradweiche)',
  'atlas_bikelanesPresence--bikelane_left=cyclewayOnHighwayProtected':
    'Geschützter Radfahrstreifen (PBL)',
  'atlas_bikelanesPresence--bikelane_left=data_no': 'Vollständig (explizit keine)',
  'atlas_bikelanesPresence--bikelane_left=footAndCyclewaySegregated_adjoining':
    'Getrennter Rad- und Gehweg, straßenbegleitend',
  'atlas_bikelanesPresence--bikelane_left=footAndCyclewaySegregated_adjoiningOrIsolated':
    'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_left=footAndCyclewaySegregated_isolated':
    'Getrennter Rad- und Gehweg, selbstständig geführt',
  'atlas_bikelanesPresence--bikelane_left=footAndCyclewayShared_adjoining':
    'Gemeinsamer Geh- und Radweg, straßenbegleitend',
  'atlas_bikelanesPresence--bikelane_left=footAndCyclewayShared_adjoiningOrIsolated':
    'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_left=footAndCyclewayShared_isolated':
    'Gemeinsamer Geh- und Radweg, selbstständig geführt',
  'atlas_bikelanesPresence--bikelane_left=footwayBicycleYes_adjoining':
    'Gehweg mit Radfahrer frei, straßenbegleitend',
  'atlas_bikelanesPresence--bikelane_left=footwayBicycleYes_adjoiningOrIsolated':
    'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_left=footwayBicycleYes_isolated':
    'Gehweg mit Radfahrer frei, selbstständig geführt',
  'atlas_bikelanesPresence--bikelane_left=missing': 'Unvollständig',
  'atlas_bikelanesPresence--bikelane_left=needsClarification': 'Führungsform unklar',
  'atlas_bikelanesPresence--bikelane_left=not_expected': 'Keine Infrastruktur erwartet',
  'atlas_bikelanesPresence--bikelane_left=pedestrianAreaBicycleYes': 'Fußgängerzone, Fahrrad frei',
  'atlas_bikelanesPresence--bikelane_left=separate_geometry': 'RVA als separate Geometrie erfasst',
  'atlas_bikelanesPresence--bikelane_left=sharedBusLaneBikeWithBus':
    'Radfahrstreifen mit Freigabe Busverkehr',
  'atlas_bikelanesPresence--bikelane_left=sharedBusLaneBusWithBike':
    'Bussonderfahrstreifen mit Fahrrad frei',
  'atlas_bikelanesPresence--bikelane_left=sharedMotorVehicleLane':
    'Anteilig genutzter Fahrstreifen (Sharrows)',
  'atlas_bikelanesPresence--bikelane_right--key': 'Radinfrastruktur rechts',
  'atlas_bikelanesPresence--bikelane_right=assumed_no': 'Vermutlich vollständig',
  'atlas_bikelanesPresence--bikelane_right=bicycleRoad': 'Fahrradstraße',
  'atlas_bikelanesPresence--bikelane_right=bicycleRoad_vehicleDestination':
    'Fahrradstraße mit Anlieger/Kfz frei',
  'atlas_bikelanesPresence--bikelane_right=crossing': 'Straßenquerung',
  'atlas_bikelanesPresence--bikelane_right=cycleway_adjoining': 'Radweg (straßenbegleitend)',
  'atlas_bikelanesPresence--bikelane_right=cycleway_adjoiningOrIsolated':
    'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_right=cycleway_isolated': 'Radweg, selbstständig geführt',
  'atlas_bikelanesPresence--bikelane_right=cyclewayLink': 'Radweg-Verbindungsstück',
  'atlas_bikelanesPresence--bikelane_right=cyclewayOnHighway_advisory': 'Schutzstreifen',
  'atlas_bikelanesPresence--bikelane_right=cyclewayOnHighway_advisoryOrExclusive':
    'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_right=cyclewayOnHighway_exclusive': 'Radfahrstreifen',
  'atlas_bikelanesPresence--bikelane_right=cyclewayOnHighwayBetweenLanes':
    'Radfahrstreifen in Mittellage (Fahrradweiche)',
  'atlas_bikelanesPresence--bikelane_right=cyclewayOnHighwayProtected':
    'Geschützter Radfahrstreifen (PBL)',
  'atlas_bikelanesPresence--bikelane_right=data_no': 'Vollständig (explizit keine)',
  'atlas_bikelanesPresence--bikelane_right=footAndCyclewaySegregated_adjoining':
    'Getrennter Rad- und Gehweg, straßenbegleitend',
  'atlas_bikelanesPresence--bikelane_right=footAndCyclewaySegregated_adjoiningOrIsolated':
    'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_right=footAndCyclewaySegregated_isolated':
    'Getrennter Rad- und Gehweg, selbstständig geführt',
  'atlas_bikelanesPresence--bikelane_right=footAndCyclewayShared_adjoining':
    'Gemeinsamer Geh- und Radweg, straßenbegleitend',
  'atlas_bikelanesPresence--bikelane_right=footAndCyclewayShared_adjoiningOrIsolated':
    'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_right=footAndCyclewayShared_isolated':
    'Gemeinsamer Geh- und Radweg, selbstständig geführt',
  'atlas_bikelanesPresence--bikelane_right=footwayBicycleYes_adjoining':
    'Gehweg mit Radfahrer frei, straßenbegleitend',
  'atlas_bikelanesPresence--bikelane_right=footwayBicycleYes_adjoiningOrIsolated':
    'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_right=footwayBicycleYes_isolated':
    'Gehweg mit Radfahrer frei, selbstständig geführt',
  'atlas_bikelanesPresence--bikelane_right=missing': 'Unvollständig',
  'atlas_bikelanesPresence--bikelane_right=needsClarification': 'Führungsform unklar',
  'atlas_bikelanesPresence--bikelane_right=not_expected': 'Keine Infrastruktur erwartet',
  'atlas_bikelanesPresence--bikelane_right=pedestrianAreaBicycleYes': 'Fußgängerzone, Fahrrad frei',
  'atlas_bikelanesPresence--bikelane_right=separate_geometry': 'RVA als separate Geometrie erfasst',
  'atlas_bikelanesPresence--bikelane_right=sharedBusLaneBikeWithBus':
    'Radfahrstreifen mit Freigabe Busverkehr',
  'atlas_bikelanesPresence--bikelane_right=sharedBusLaneBusWithBike':
    'Bussonderfahrstreifen mit Fahrrad frei',
  'atlas_bikelanesPresence--bikelane_right=sharedMotorVehicleLane':
    'Anteilig genutzter Fahrstreifen (Sharrows)',
  'atlas_bikelanesPresence--bikelane_self--key': 'Radinfrastruktur mittig',
  'atlas_bikelanesPresence--bikelane_self=assumed_no': 'Vermutlich vollständig',
  'atlas_bikelanesPresence--bikelane_self=bicycleRoad': 'Fahrradstraße',
  'atlas_bikelanesPresence--bikelane_self=bicycleRoad_vehicleDestination':
    'Fahrradstraße mit Anlieger/Kfz frei',
  'atlas_bikelanesPresence--bikelane_self=crossing': 'Straßenquerung',
  'atlas_bikelanesPresence--bikelane_self=cycleway_adjoining': 'Radweg (straßenbegleitend)',
  'atlas_bikelanesPresence--bikelane_self=cycleway_adjoiningOrIsolated':
    'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_self=cycleway_isolated': 'Radweg, selbstständig geführt',
  'atlas_bikelanesPresence--bikelane_self=cyclewayLink': 'Radweg-Verbindungsstück',
  'atlas_bikelanesPresence--bikelane_self=cyclewayOnHighway_advisory': 'Schutzstreifen',
  'atlas_bikelanesPresence--bikelane_self=cyclewayOnHighway_advisoryOrExclusive':
    'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_self=cyclewayOnHighway_exclusive': 'Radfahrstreifen',
  'atlas_bikelanesPresence--bikelane_self=cyclewayOnHighwayBetweenLanes':
    'Radfahrstreifen in Mittellage (Fahrradweiche)',
  'atlas_bikelanesPresence--bikelane_self=cyclewayOnHighwayProtected':
    'Geschützter Radfahrstreifen (PBL)',
  'atlas_bikelanesPresence--bikelane_self=data_no': 'Vollständig (explizit keine)',
  'atlas_bikelanesPresence--bikelane_self=footAndCyclewaySegregated_adjoining':
    'Getrennter Rad- und Gehweg, straßenbegleitend',
  'atlas_bikelanesPresence--bikelane_self=footAndCyclewaySegregated_adjoiningOrIsolated':
    'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_self=footAndCyclewaySegregated_isolated':
    'Getrennter Rad- und Gehweg, selbstständig geführt',
  'atlas_bikelanesPresence--bikelane_self=footAndCyclewayShared_adjoining':
    'Gemeinsamer Geh- und Radweg, straßenbegleitend',
  'atlas_bikelanesPresence--bikelane_self=footAndCyclewayShared_adjoiningOrIsolated':
    'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_self=footAndCyclewayShared_isolated':
    'Gemeinsamer Geh- und Radweg, selbstständig geführt',
  'atlas_bikelanesPresence--bikelane_self=footwayBicycleYes_adjoining':
    'Gehweg mit Radfahrer frei, straßenbegleitend',
  'atlas_bikelanesPresence--bikelane_self=footwayBicycleYes_adjoiningOrIsolated':
    'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_bikelanesPresence--bikelane_self=footwayBicycleYes_isolated':
    'Gehweg mit Radfahrer frei, selbstständig geführt',
  'atlas_bikelanesPresence--bikelane_self=missing': 'Unvollständig',
  'atlas_bikelanesPresence--bikelane_self=needsClarification': 'Führungsform unklar',
  'atlas_bikelanesPresence--bikelane_self=not_expected': 'Keine Infrastruktur erwartet',
  'atlas_bikelanesPresence--bikelane_self=pedestrianAreaBicycleYes': 'Fußgängerzone, Fahrrad frei',
  'atlas_bikelanesPresence--bikelane_self=separate_geometry': 'RVA als separate Geometrie erfasst',
  'atlas_bikelanesPresence--bikelane_self=sharedBusLaneBikeWithBus':
    'Radfahrstreifen mit Freigabe Busverkehr',
  'atlas_bikelanesPresence--bikelane_self=sharedBusLaneBusWithBike':
    'Bussonderfahrstreifen mit Fahrrad frei',
  'atlas_bikelanesPresence--bikelane_self=sharedMotorVehicleLane':
    'Anteilig genutzter Fahrstreifen (Sharrows)',
  'atlas_bikelanesPresence--title': 'Daten zu Radinfrastruktur an Straßen',
  'atlas_bikeroutes--colours--key': 'Farben',
  'atlas_bikeroutes--cycle_highway--key': 'Radschnellverbindung',
  'atlas_bikeroutes--cycle_highway=yes': 'Diese Route repräsentiert eine RSV.',
  'atlas_bikeroutes--cycle_network_key--key': 'Netzwerk-Schlüssel',
  'atlas_bikeroutes--distance--key': 'Angabe Gesamtlänge',
  'atlas_bikeroutes--name--key': 'Name',
  'atlas_bikeroutes--network_type--key': 'Netzwerkart',
  'atlas_bikeroutes--network_type=basic_network': 'Start-Ziel Route',
  'atlas_bikeroutes--network_type=node_network': 'Teil eines Knotennetzwerks',
  'atlas_bikeroutes--network--key': 'Netzwerkhierarchie',
  'atlas_bikeroutes--network=icn': 'Internationales Radverkehrsnetz (`icn`)',
  'atlas_bikeroutes--network=lcn': 'Lokale Radverkehrsnetze (`lcn`)',
  'atlas_bikeroutes--network=ncn': 'Nationales Radverkehrsnetz (`ncn`)',
  'atlas_bikeroutes--network=rcn': 'Regionale Radverkehrsnetze (`rcn`)',
  'atlas_bikeroutes--operator--key': 'Betreiber/Baulastträger',
  'atlas_bikeroutes--ref--key': 'Referenz',
  'atlas_bikeroutes--roundtrip--key': 'Rundfahrt',
  'atlas_bikeroutes--roundtrip=no': 'Nein',
  'atlas_bikeroutes--roundtrip=yes': 'Ja',
  'atlas_bikeroutes--route_description--key': 'Freitext zur Route',
  'atlas_bikeroutes--symbol_description--key': 'Symbolbeschreibung',
  'atlas_bikeroutes--title': 'Fahrradrouten',
  'atlas_bikeroutes--website--key': 'Website',
  'atlas_bikeroutes--wikipedia--key': 'Wikipedia',
  'atlas_bikeSuitability--bikeSuitability--key':
    'Eignung des Weges für Radverkehr, Radnetze und Radrouten',
  'atlas_bikeSuitability--bikeSuitability=goodSurface':
    'Potentiell geeignet aufgrund einer guten Oberfläche',
  'atlas_bikeSuitability--bikeSuitability=livingStreet':
    'Geeignet durch verkehrsberuhigten Bereich',
  'atlas_bikeSuitability--bikeSuitability=noMotorizedVehicle':
    'Potentiell geeignet aufgrund des Verbots von Kfz',
  'atlas_bikeSuitability--bikeSuitability=noOvertaking':
    'Potentiell geeignet aufgrund Verkehrszeichen 277.1',
  'atlas_bikeSuitability--covered--key': 'Überdacht',
  'atlas_bikeSuitability--covered=covered': 'Überdacht',
  'atlas_bikeSuitability--covered=covered--description':
    'Vollständig überdachte Wege (`covered=yes`) und Arkaden (`covered=arcade`, zur Seite hin offen).',
  'atlas_bikeSuitability--covered=indoor': 'In einem Gebäude',
  'atlas_bikeSuitability--covered=partial': 'Teilweise überdacht',
  'atlas_bikeSuitability--description--key': 'Hinweis aus OSM',
  'atlas_bikeSuitability--informal--key': 'Trampelpfad',
  'atlas_bikeSuitability--informal=yes': 'Weg als informeller Weg erfasst',
  'atlas_bikeSuitability--length--key': 'Länge',
  'atlas_bikeSuitability--lifecycle--key': 'Status',
  'atlas_bikeSuitability--lifecycle=blocked': 'Gesperrt (Sperrung)',
  'atlas_bikeSuitability--lifecycle=construction': 'In Bau',
  'atlas_bikeSuitability--lifecycle=construction_no_access': 'Gesperrt aufgrund einer Baustelle',
  'atlas_bikeSuitability--lifecycle=temporary': 'Temporärer Weg',
  'atlas_bikeSuitability--mapillary_backward--key': 'Mapillary gegen Linienrichtung',
  'atlas_bikeSuitability--mapillary_coverage--key': 'Mapillary-Abdeckung',
  'atlas_bikeSuitability--mapillary_coverage=pano': 'Panorama-Aufnahmen',
  'atlas_bikeSuitability--mapillary_coverage=regular': 'Standard-Aufnahmen',
  'atlas_bikeSuitability--mapillary_forward--key': 'Mapillary in Linienrichtung',
  'atlas_bikeSuitability--mapillary_traffic_sign--key': 'Mapillary für Verkehrszeichen',
  'atlas_bikeSuitability--mapillary--key': 'Straßenfotos (Mapillary)',
  'atlas_bikeSuitability--name--key': 'Name',
  'atlas_bikeSuitability--operator_type--key': 'Betreibertyp',
  'atlas_bikeSuitability--operator_type=private': 'Privat',
  'atlas_bikeSuitability--operator_type=public': 'Öffentlich',
  'atlas_bikeSuitability--road--key': 'Straßentyp',
  'atlas_bikeSuitability--road=bicycle_road': 'Fahrradstraße',
  'atlas_bikeSuitability--road=construction': 'Straße ist in Bau',
  'atlas_bikeSuitability--road=cycleway': 'Radweg',
  'atlas_bikeSuitability--road=cycleway_crossing': 'Straßenquerung (Radweg)',
  'atlas_bikeSuitability--road=footway': 'Fußweg',
  'atlas_bikeSuitability--road=footway_crossing': 'Straßenquerung (Fußweg)',
  'atlas_bikeSuitability--road=footway_cycleway_crossing': 'Straßenquerung (Fuß- und Radweg)',
  'atlas_bikeSuitability--road=footway_sidewalk': 'Gehweg',
  'atlas_bikeSuitability--road=footway_steps': 'Treppe',
  'atlas_bikeSuitability--road=living_street': 'Verkehrsberuhigter Bereich',
  'atlas_bikeSuitability--road=motorway': 'Autobahn',
  'atlas_bikeSuitability--road=motorway_link': 'Zufahrt einer Autobahn',
  'atlas_bikeSuitability--road=path': 'Weg / Pfad',
  'atlas_bikeSuitability--road=pedestrian': 'Fußgängerzone',
  'atlas_bikeSuitability--road=primary': 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_bikeSuitability--road=primary_link':
    'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_bikeSuitability--road=residential': 'Anwohnerstraße',
  'atlas_bikeSuitability--road=residential_priority_road': 'residential_priority_road',
  'atlas_bikeSuitability--road=secondary': 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
  'atlas_bikeSuitability--road=secondary_link':
    'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
  'atlas_bikeSuitability--road=service_alley': 'Gasse',
  'atlas_bikeSuitability--road=service_driveway': 'Grundstückszufahrt',
  'atlas_bikeSuitability--road=service_emergency_access': 'Rettungsweg',
  'atlas_bikeSuitability--road=service_parking_aisle': 'Parkplatzweg',
  'atlas_bikeSuitability--road=service_road': 'Zufahrtsweg',
  'atlas_bikeSuitability--road=service_uncategorized': 'Zufahrtsweg (unbekannte Klassifizierung)',
  'atlas_bikeSuitability--road=tertiary': 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
  'atlas_bikeSuitability--road=tertiary_link':
    'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
  'atlas_bikeSuitability--road=track': 'Wald- / Feldweg',
  'atlas_bikeSuitability--road=unclassified': 'Nebenstraße mit Verbindungscharakter',
  'atlas_bikeSuitability--road=unspecified_road': 'Unkategorisierte Straße',
  'atlas_bikeSuitability--smoothness--key': 'Ober&shy;flächen&shy;qualität',
  'atlas_bikeSuitability--smoothness=bad': 'Schlecht',
  'atlas_bikeSuitability--smoothness=excellent': 'Sehr gut',
  'atlas_bikeSuitability--smoothness=good': 'Gut',
  'atlas_bikeSuitability--smoothness=intermediate': 'Mittel gut',
  'atlas_bikeSuitability--smoothness=very_bad': 'Sehr schlecht',
  'atlas_bikeSuitability--surface--key': 'Oberfläche',
  'atlas_bikeSuitability--surface=asphalt': 'Asphalt',
  'atlas_bikeSuitability--surface=bricks': 'Ziegel',
  'atlas_bikeSuitability--surface=compacted': 'Verdichteter Untergrund',
  'atlas_bikeSuitability--surface=concrete': 'Beton',
  'atlas_bikeSuitability--surface=concrete:lanes': 'Betonstreifen / -bahnen',
  'atlas_bikeSuitability--surface=concrete:plates': 'Betonplatten',
  'atlas_bikeSuitability--surface=fine_gravel': 'Splitt',
  'atlas_bikeSuitability--surface=grass': 'Gras',
  'atlas_bikeSuitability--surface=grass_paver': 'Rasengitter / Grasgitter',
  'atlas_bikeSuitability--surface=gravel': 'Schotter',
  'atlas_bikeSuitability--surface=ground': 'Erde/Boden',
  'atlas_bikeSuitability--surface=large_sett': 'Großpflaster',
  'atlas_bikeSuitability--surface=metal': 'Metall',
  'atlas_bikeSuitability--surface=metal_grid': 'Metallgitter',
  'atlas_bikeSuitability--surface=mosaic_sett': 'Mosaikpflaster',
  'atlas_bikeSuitability--surface=paved': 'Befestigt (unspezifisch)',
  'atlas_bikeSuitability--surface=paving_stones': 'Verbund&shy;pflastersteine',
  'atlas_bikeSuitability--surface=paving_stones:lanes': 'Pflasterstein&shy;bahnen',
  'atlas_bikeSuitability--surface=pebblestone': 'Kieselsteine',
  'atlas_bikeSuitability--surface=plastic': 'Kunststoff',
  'atlas_bikeSuitability--surface=rubber': 'Gummi',
  'atlas_bikeSuitability--surface=sand': 'Sand',
  'atlas_bikeSuitability--surface=sett': 'Behauenes Pflaster / Natursteinpflaster',
  'atlas_bikeSuitability--surface=small_sett': 'Kleinpflaster',
  'atlas_bikeSuitability--surface=stone': 'Stein',
  'atlas_bikeSuitability--surface=unpaved': 'Unbefestigt',
  'atlas_bikeSuitability--surface=wood': 'Holz',
  'atlas_bikeSuitability--surface=woodchips': 'Hackschnitzel',
  'atlas_bikeSuitability--title': 'Radeignung',
  'atlas_bikeSuitability--traffic_sign--key': 'Beschilderung',
  'atlas_bikeSuitability--traffic_sign=none': 'Unbeschildert',
  'atlas_boundaries--admin_level--key': 'Grenzen Level',
  'atlas_boundaries--admin_level=7': 'Level 7 — Meistens Verwaltungsgemeinschaft, Amt',
  'atlas_boundaries--admin_level=8': 'Level 8 — Meistens (Kreisangehörige) Gemeinde / Stadt',
  'atlas_boundaries--category_district--key': 'Kreiskategorie',
  'atlas_boundaries--category_municipality--key': 'Gemeindekategorie',
  'atlas_boundaries--name_prefix--key': 'Namenspräfix',
  'atlas_boundaries--name--key': 'Name',
  'atlas_boundaries--population_date--key': 'Bevölkerungsstand',
  'atlas_boundaries--population--key': 'Bevölkerung',
  'atlas_boundaries--regionalschluessel--key': 'Regionalschlüssel',
  'atlas_boundaries--title': 'Grenzen',
  'atlas_boundaries--wikidata--key': 'Wikidata',
  'atlas_boundaries--wikipedia--key': 'Wikipedia',
  'atlas_landuse--access--key': 'Zugang',
  'atlas_landuse--access=customers': 'Kund:innen',
  'atlas_landuse--access=no': 'Kein Zugang',
  'atlas_landuse--access=permissive': 'Öffentliche Nutzung geduldet',
  'atlas_landuse--access=private': 'Privat',
  'atlas_landuse--access=public': 'Öffentlich (explizit)',
  'atlas_landuse--access=yes': 'Öffentlich',
  'atlas_landuse--landuse--key': 'Landnutzung',
  'atlas_landuse--landuse=allotments': 'Kleingartenanlage',
  'atlas_landuse--landuse=brownfield': 'Brachfläche',
  'atlas_landuse--landuse=cemetery': 'Friedhofsgelände',
  'atlas_landuse--landuse=civic': 'Fläche für öffentliche Einrichtungen',
  'atlas_landuse--landuse=civic_admin': 'Verwaltungsfläche',
  'atlas_landuse--landuse=clinic': 'Klinikgelände',
  'atlas_landuse--landuse=college': 'Hochschul-/College-Gelände',
  'atlas_landuse--landuse=commercial': 'Gewerbliche Nutzung',
  'atlas_landuse--landuse=construction': 'Baufläche (im Bau)',
  'atlas_landuse--landuse=dog_park': 'Hundeauslaufgebiet',
  'atlas_landuse--landuse=education': 'Bildungsfläche',
  'atlas_landuse--landuse=farmyard': 'Landwirtschaftliche Nutzung',
  'atlas_landuse--landuse=garages': 'Garagen',
  'atlas_landuse--landuse=garden': 'Garten',
  'atlas_landuse--landuse=hospital': 'Krankenhausgelände',
  'atlas_landuse--landuse=industrial': 'Industrielle Nutzung',
  'atlas_landuse--landuse=kindergarten': 'Kindertagesstätte',
  'atlas_landuse--landuse=park': 'Park',
  'atlas_landuse--landuse=prison': 'Justizvollzugsanstalt',
  'atlas_landuse--landuse=religious': 'Religiöse Nutzung',
  'atlas_landuse--landuse=residential': 'Wohngebiet',
  'atlas_landuse--landuse=retail': 'Gewerbliche Nutzung (Einzelhandel/Geschäfte)',
  'atlas_landuse--landuse=school': 'Schulgelände',
  'atlas_landuse--landuse=sports_centre': 'Sportzentrum',
  'atlas_landuse--landuse=stadium': 'Stadion',
  'atlas_landuse--landuse=university': 'Universitätsgelände',
  'atlas_landuse--name--key': 'Name',
  'atlas_landuse--operator--key': 'Betreiber',
  'atlas_landuse--title': 'Daten zur Landnutzung',
  'atlas_places--admin_level--key': 'Admin-Level',
  'atlas_places--capital--key': 'Hauptstadtstatus',
  'atlas_places--name--key': 'Name',
  'atlas_places--place--key': 'Ortskategorie',
  'atlas_places--place=borough': 'Stadtteil/Stadtbezirk',
  'atlas_places--place=city': 'Stadt',
  'atlas_places--place=hamlet': 'Siedlung',
  'atlas_places--place=suburb': 'Stadtteil',
  'atlas_places--place=town': 'Stadt oder große Gemeinde',
  'atlas_places--place=village': 'Dorf',
  'atlas_places--population_date--key': 'Datum der Quelle der Einwohner:innen-Anzahl',
  'atlas_places--population--key': 'Einwohner:innen-Anzahl',
  'atlas_places--title': 'Daten zu Orten',
  'atlas_places--website--key': 'Website',
  'atlas_places--wikidata--key': 'Wikidata',
  'atlas_places--wikipedia--key': 'Wikipedia',
  'atlas_poiClassification--addr_city--key': 'Ort',
  'atlas_poiClassification--addr_number--key': 'Hausnummer',
  'atlas_poiClassification--addr_street--key': 'Straße',
  'atlas_poiClassification--addr_zip--key': 'Postleitzahl',
  'atlas_poiClassification--category--key': 'Kategorisierung des POI',
  'atlas_poiClassification--category=Bildung': 'Bildung',
  'atlas_poiClassification--category=Einkauf': 'Einkauf',
  'atlas_poiClassification--category=Freizeit': 'Freizeit',
  'atlas_poiClassification--category=Grundversorgung': 'Grundversorgung',
  'atlas_poiClassification--formalEducation--key': 'Bildungseinrichtung',
  'atlas_poiClassification--formalEducation=childcare': 'Kinderbetreuung',
  'atlas_poiClassification--formalEducation=college':
    'Berufsfachschule / Weiterbildungseinrichtung',
  'atlas_poiClassification--formalEducation=kindergarten': 'Kindergarten',
  'atlas_poiClassification--formalEducation=research_institute': 'Forschungsinstitut',
  'atlas_poiClassification--formalEducation=school': 'Schule',
  'atlas_poiClassification--formalEducation=university': 'Universität',
  'atlas_poiClassification--name--key': 'Name POI',
  'atlas_poiClassification--title': 'Daten zu Start-Ziel-Punkten',
  'atlas_poiClassification--type--key': 'Detail-Kategorie',
  'atlas_poiClassification--type=amenity-animal_boarding': 'Tierpension',
  'atlas_poiClassification--type=amenity-animal_training': 'Tiertraining',
  'atlas_poiClassification--type=amenity-arts_centre': 'Kunstzentrum',
  'atlas_poiClassification--type=amenity-bank': 'Bank-Filiale',
  'atlas_poiClassification--type=amenity-bar': 'Bar',
  'atlas_poiClassification--type=amenity-bbq': 'Grill',
  'atlas_poiClassification--type=amenity-bicycle_rental': 'Fahrradverleih',
  'atlas_poiClassification--type=amenity-biergarten': 'Biergarten',
  'atlas_poiClassification--type=amenity-boat_rental': 'Bootsvermietung',
  'atlas_poiClassification--type=amenity-boat_storage': 'Bootslagerplatz',
  'atlas_poiClassification--type=amenity-cafe': 'Café',
  'atlas_poiClassification--type=amenity-canteen': 'Kantine',
  'atlas_poiClassification--type=amenity-car_rental': 'Autovermietung',
  'atlas_poiClassification--type=amenity-car_wash': 'Autowäsche',
  'atlas_poiClassification--type=amenity-casino': 'Kasino',
  'atlas_poiClassification--type=amenity-childcare': 'Kinderbetreuung',
  'atlas_poiClassification--type=amenity-cinema': 'Kino',
  'atlas_poiClassification--type=amenity-clinic': 'Ärztezentrum',
  'atlas_poiClassification--type=amenity-college': 'Hochschule',
  'atlas_poiClassification--type=amenity-community_centre': 'Gemeindezentrum',
  'atlas_poiClassification--type=amenity-conference_centre': 'Kongresszentrum',
  'atlas_poiClassification--type=amenity-courthouse': 'Gericht',
  'atlas_poiClassification--type=amenity-dancing_school': 'Tanzschule',
  'atlas_poiClassification--type=amenity-dentist': 'Zahnarzt',
  'atlas_poiClassification--type=amenity-doctors': 'Arzt',
  'atlas_poiClassification--type=amenity-dojo': 'Kampfsportstudio',
  'atlas_poiClassification--type=amenity-driving_school': 'Fahrschule',
  'atlas_poiClassification--type=amenity-events_venue': 'Veranstaltungsstätte',
  'atlas_poiClassification--type=amenity-fallback': 'Einrichtung (Auffangkategorie)',
  'atlas_poiClassification--type=amenity-fallback--description':
    'Auffangkategorie für seltene oder uneinheitliche amenity-Werte unterhalb des Volumen-Schwellenwertes.',
  'atlas_poiClassification--type=amenity-fast_food': 'Schnellimbiss',
  'atlas_poiClassification--type=amenity-fuel': 'Tankstelle',
  'atlas_poiClassification--type=amenity-gambling': 'Spielhalle',
  'atlas_poiClassification--type=amenity-hospital': 'Krankenhaus',
  'atlas_poiClassification--type=amenity-ice_cream': 'Eisgeschäft',
  'atlas_poiClassification--type=amenity-internet_cafe': 'Internetcafé',
  'atlas_poiClassification--type=amenity-kindergarten': 'Kindergarten',
  'atlas_poiClassification--type=amenity-language_school': 'Sprachschule',
  'atlas_poiClassification--type=amenity-library': 'Bibliothek',
  'atlas_poiClassification--type=amenity-marketplace': 'Marktplatz',
  'atlas_poiClassification--type=amenity-money_transfer': 'Geldtransferstation',
  'atlas_poiClassification--type=amenity-music_school': 'Musikschule',
  'atlas_poiClassification--type=amenity-nightclub': 'Diskothek',
  'atlas_poiClassification--type=amenity-pharmacy': 'Apotheke',
  'atlas_poiClassification--type=amenity-place_of_worship': 'Andachtsstätte',
  'atlas_poiClassification--type=amenity-post_depot': 'Postverteilzentrum',
  'atlas_poiClassification--type=amenity-post_office': 'Postfiliale',
  'atlas_poiClassification--type=amenity-prep_school': 'Vorschule',
  'atlas_poiClassification--type=amenity-prison': 'Gefängnisanlage',
  'atlas_poiClassification--type=amenity-pub': 'Kneipe',
  'atlas_poiClassification--type=amenity-public_building': 'Öffentliches Gebäude',
  'atlas_poiClassification--type=amenity-research_institute': 'Forschungseinrichtung',
  'atlas_poiClassification--type=amenity-restaurant': 'Restaurant',
  'atlas_poiClassification--type=amenity-school': 'Schule',
  'atlas_poiClassification--type=amenity-social_centre': 'Sozialzentrum',
  'atlas_poiClassification--type=amenity-social_facility': 'Sozialeinrichtung',
  'atlas_poiClassification--type=amenity-stables': 'Reitstall',
  'atlas_poiClassification--type=amenity-theatre': 'Theater',
  'atlas_poiClassification--type=amenity-townhall': 'Rathaus, Gemeindeamt',
  'atlas_poiClassification--type=amenity-traffic_park': 'Verkehrsübungsplatz',
  'atlas_poiClassification--type=amenity-university': 'Universität',
  'atlas_poiClassification--type=amenity-vehicle_inspection': 'Fahrzeuginspektion',
  'atlas_poiClassification--type=amenity-vending_machine': 'Verkaufsautomat',
  'atlas_poiClassification--type=amenity-veterinary': 'Tierarztpraxis',
  'atlas_poiClassification--type=leisure-adult_gaming_centre': 'Spielothek für Erwachsene',
  'atlas_poiClassification--type=leisure-bathing_place': 'Badeplatz',
  'atlas_poiClassification--type=leisure-beach_resort': 'Strandresort',
  'atlas_poiClassification--type=leisure-bird_hide': 'Vogelbeobachtungsstation',
  'atlas_poiClassification--type=leisure-fallback': 'Freizeit (Auffangkategorie)',
  'atlas_poiClassification--type=leisure-fallback--description':
    'Auffangkategorie für seltene oder uneinheitliche leisure-Werte unterhalb des Volumen-Schwellenwertes.',
  'atlas_poiClassification--type=leisure-firepit': 'Feuerstelle',
  'atlas_poiClassification--type=leisure-fitness_centre': 'Fitness-Studio',
  'atlas_poiClassification--type=leisure-garden': 'Garten',
  'atlas_poiClassification--type=leisure-golf_course': 'Golfplatz',
  'atlas_poiClassification--type=leisure-horse_riding': 'Reitanlage',
  'atlas_poiClassification--type=leisure-outdoor_seating': 'Außengastronomie',
  'atlas_poiClassification--type=leisure-park': 'Park',
  'atlas_poiClassification--type=leisure-picnic_table': 'Picknicktisch',
  'atlas_poiClassification--type=leisure-pitch': 'Sportplatz',
  'atlas_poiClassification--type=leisure-playground': 'Spielplatz',
  'atlas_poiClassification--type=leisure-sports_centre': 'Sportzentrum / -komplex',
  'atlas_poiClassification--type=leisure-sports_hall': 'Sporthalle',
  'atlas_poiClassification--type=leisure-stadium': 'Stadion',
  'atlas_poiClassification--type=leisure-swimming_area': 'Natürlicher Badebereich',
  'atlas_poiClassification--type=leisure-swimming_pool': 'Schwimmbecken',
  'atlas_poiClassification--type=leisure-water_park': 'Erlebnisbad',
  'atlas_poiClassification--type=shop-agrarian': 'Agrarmarkt',
  'atlas_poiClassification--type=shop-alcohol': 'Spirituosenladen',
  'atlas_poiClassification--type=shop-antiques': 'Antiquitätenhändler',
  'atlas_poiClassification--type=shop-appliance': 'Haushaltselektrogerätegeschäft',
  'atlas_poiClassification--type=shop-art': 'Kunsthandlung',
  'atlas_poiClassification--type=shop-baby_goods': 'Babyausstattung',
  'atlas_poiClassification--type=shop-bag': 'Taschen / Koffergeschäft',
  'atlas_poiClassification--type=shop-bakery': 'Bäckerei',
  'atlas_poiClassification--type=shop-bathroom_furnishing': 'Badeinrichtungsgeschäft',
  'atlas_poiClassification--type=shop-beauty': 'Schönheitssalon',
  'atlas_poiClassification--type=shop-bed': 'Betten- / Matratzengeschäft',
  'atlas_poiClassification--type=shop-beverages': 'Getränkehandel',
  'atlas_poiClassification--type=shop-bicycle': 'Fahrradladen',
  'atlas_poiClassification--type=shop-boat': 'Bootsgeschäft',
  'atlas_poiClassification--type=shop-bookmaker': 'Wettbüro',
  'atlas_poiClassification--type=shop-books': 'Buchhandlung',
  'atlas_poiClassification--type=shop-boutique': 'Boutique',
  'atlas_poiClassification--type=shop-butcher': 'Metzgerei',
  'atlas_poiClassification--type=shop-cannabis': 'Cannabisgeschäft',
  'atlas_poiClassification--type=shop-car': 'Autohändler',
  'atlas_poiClassification--type=shop-car_parts': 'Autoteilehandel',
  'atlas_poiClassification--type=shop-car_repair': 'Autowerkstatt',
  'atlas_poiClassification--type=shop-caravan': 'Wohnwagengeschäft',
  'atlas_poiClassification--type=shop-carpet': 'Teppichgeschäft',
  'atlas_poiClassification--type=shop-charity': 'Sozialkaufhaus',
  'atlas_poiClassification--type=shop-cheese': 'Käseladen',
  'atlas_poiClassification--type=shop-chemist': 'Drogerie',
  'atlas_poiClassification--type=shop-chocolate': 'Schokoladenladen',
  'atlas_poiClassification--type=shop-clothes': 'Bekleidungsgeschäft',
  'atlas_poiClassification--type=shop-coffee': 'Kaffeegeschäft',
  'atlas_poiClassification--type=shop-collector': 'Sammlergeschäft',
  'atlas_poiClassification--type=shop-computer': 'Fachgeschäft für Computer',
  'atlas_poiClassification--type=shop-confectionery': 'Süßwarenladen',
  'atlas_poiClassification--type=shop-convenience': 'Minimarkt',
  'atlas_poiClassification--type=shop-copyshop': 'Kopierladen',
  'atlas_poiClassification--type=shop-cosmetics': 'Kosmetikladen',
  'atlas_poiClassification--type=shop-country_store': 'Dorfladen',
  'atlas_poiClassification--type=shop-craft': 'Geschäft für Künstlerbedarf',
  'atlas_poiClassification--type=shop-curtain': 'Vorhanggeschäft',
  'atlas_poiClassification--type=shop-deli': 'Feinkostladen',
  'atlas_poiClassification--type=shop-department_store': 'Kaufhaus',
  'atlas_poiClassification--type=shop-doityourself': 'Heimwerkerladen',
  'atlas_poiClassification--type=shop-doors': 'Türgeschäft',
  'atlas_poiClassification--type=shop-dry_cleaning': 'Chemische Reinigung',
  'atlas_poiClassification--type=shop-e-cigarette': 'E-Zigarettenladen',
  'atlas_poiClassification--type=shop-electrical': 'Elektrofachgeschaft',
  'atlas_poiClassification--type=shop-electronics': 'Elektronikfachgeschäft',
  'atlas_poiClassification--type=shop-erotic': 'Erotikgeschäft',
  'atlas_poiClassification--type=shop-estate_agent': 'Immobilienbüro',
  'atlas_poiClassification--type=shop-fabric': 'Stoffgeschäft',
  'atlas_poiClassification--type=shop-fallback': 'Geschäft (Auffangkategorie)',
  'atlas_poiClassification--type=shop-fallback--description':
    'Auffangkategorie für seltene oder uneinheitliche shop-Werte unterhalb des Volumen-Schwellenwertes.',
  'atlas_poiClassification--type=shop-farm': 'Hofladen',
  'atlas_poiClassification--type=shop-fashion_accessories': 'Geschäft für Modeaccessoires',
  'atlas_poiClassification--type=shop-fireplace': 'Kachelofenladen',
  'atlas_poiClassification--type=shop-fishing': 'Angelgeschäft',
  'atlas_poiClassification--type=shop-flooring': 'Fußbodengeschäft',
  'atlas_poiClassification--type=shop-florist': 'Blumenhändler',
  'atlas_poiClassification--type=shop-food': 'Lebensmittelgeschäft',
  'atlas_poiClassification--type=shop-frame': 'Bilderrahmengeschäft',
  'atlas_poiClassification--type=shop-fuel': 'Tankstelle',
  'atlas_poiClassification--type=shop-funeral_directors': 'Beerdigungsinstitut',
  'atlas_poiClassification--type=shop-furniture': 'Möbelhaus',
  'atlas_poiClassification--type=shop-games': 'Brettspielgeschäft',
  'atlas_poiClassification--type=shop-garden_centre': 'Gartenzentrum',
  'atlas_poiClassification--type=shop-gas': 'Gasflaschenverkauf',
  'atlas_poiClassification--type=shop-general': 'Gemischtwarenhandlung',
  'atlas_poiClassification--type=shop-gift': 'Geschenkeladen',
  'atlas_poiClassification--type=shop-glaziery': 'Glaserei',
  'atlas_poiClassification--type=shop-gold_buyer': 'Goldankauf',
  'atlas_poiClassification--type=shop-greengrocer': 'Obst- und Gemüseladen',
  'atlas_poiClassification--type=shop-groundskeeping': 'Geschäft für Gartengeräte',
  'atlas_poiClassification--type=shop-hairdresser': 'Friseur',
  'atlas_poiClassification--type=shop-hairdresser_supply': 'Friseurbedarf',
  'atlas_poiClassification--type=shop-hardware': 'Eisenwarenhandel',
  'atlas_poiClassification--type=shop-health_food': 'Reformhaus',
  'atlas_poiClassification--type=shop-hearing_aids': 'Hörgerätegeschäft',
  'atlas_poiClassification--type=shop-hifi': 'HiFi-Laden',
  'atlas_poiClassification--type=shop-honey': 'Honiggeschäft',
  'atlas_poiClassification--type=shop-hookah': 'Shisha-Shop',
  'atlas_poiClassification--type=shop-houseware': 'Haushaltswarengeschäft',
  'atlas_poiClassification--type=shop-interior_decoration': 'Innenausstattungsgeschäft',
  'atlas_poiClassification--type=shop-jewelry': 'Juwelier',
  'atlas_poiClassification--type=shop-kiosk': 'Kiosk',
  'atlas_poiClassification--type=shop-kitchen': 'Küchenfachmarkt',
  'atlas_poiClassification--type=shop-laundry': 'Wäscherei',
  'atlas_poiClassification--type=shop-leather': 'Lederwarengeschäft',
  'atlas_poiClassification--type=shop-lighting': 'Leuchten- und Lampengeschäft',
  'atlas_poiClassification--type=shop-locksmith': 'Schlüsseldienst',
  'atlas_poiClassification--type=shop-lottery': 'Lottoannahmestelle',
  'atlas_poiClassification--type=shop-mall': 'Einkaufszentrum',
  'atlas_poiClassification--type=shop-massage': 'Massagesalon',
  'atlas_poiClassification--type=shop-medical_supply': 'Sanitätshaus',
  'atlas_poiClassification--type=shop-mobile_phone': 'Mobiltelefonladen',
  'atlas_poiClassification--type=shop-model': 'Modellbaugeschäft',
  'atlas_poiClassification--type=shop-motorcycle': 'Motorradhändler',
  'atlas_poiClassification--type=shop-motorcycle_repair': 'Motorradwerkstatt',
  'atlas_poiClassification--type=shop-music': 'Musikgeschäft',
  'atlas_poiClassification--type=shop-musical_instrument': 'Musikinstrumentegeschäft',
  'atlas_poiClassification--type=shop-newsagent': 'Zeitschriftenhandel',
  'atlas_poiClassification--type=shop-nutrition_supplements': 'Nahrungsergänzungsmittelgeschäft',
  'atlas_poiClassification--type=shop-optician': 'Optiker',
  'atlas_poiClassification--type=shop-outdoor': 'Outdoorgeschäft',
  'atlas_poiClassification--type=shop-outpost': 'Abholstelle eines Onlinehändlers',
  'atlas_poiClassification--type=shop-paint': 'Farbengeschäft',
  'atlas_poiClassification--type=shop-party': 'Partyzubehör',
  'atlas_poiClassification--type=shop-pastry': 'Konditorei',
  'atlas_poiClassification--type=shop-pawnbroker': 'Pfandleihe',
  'atlas_poiClassification--type=shop-perfumery': 'Parfümerie',
  'atlas_poiClassification--type=shop-pet': 'Zoofachgeschäft',
  'atlas_poiClassification--type=shop-pet_grooming': 'Tierfriseur',
  'atlas_poiClassification--type=shop-photo': 'Fotofachgeschäft',
  'atlas_poiClassification--type=shop-plant_hire': 'Maschinenvermietung',
  'atlas_poiClassification--type=shop-pottery': 'Keramikladen',
  'atlas_poiClassification--type=shop-printing': 'Druckerei',
  'atlas_poiClassification--type=shop-radiotechnics': 'Radio / Elektronik-Geschäft',
  'atlas_poiClassification--type=shop-rental': 'Verleih',
  'atlas_poiClassification--type=shop-repair': 'Reparaturgeschäft',
  'atlas_poiClassification--type=shop-scuba_diving': 'Tauchwarengeschäft',
  'atlas_poiClassification--type=shop-seafood': 'Fischgeschäft',
  'atlas_poiClassification--type=shop-second_hand': 'Second-Hand-Laden',
  'atlas_poiClassification--type=shop-security': 'Sicherheitsfachgeschäft',
  'atlas_poiClassification--type=shop-sewing': 'Geschäft für Nähzubehör',
  'atlas_poiClassification--type=shop-shoe_repair': 'Schuhreparatur',
  'atlas_poiClassification--type=shop-shoes': 'Schuhgeschäft',
  'atlas_poiClassification--type=shop-spices': 'Gewürzladen',
  'atlas_poiClassification--type=shop-sports': 'Sportgeschäft',
  'atlas_poiClassification--type=shop-stationery': 'Schreibwarengeschäft',
  'atlas_poiClassification--type=shop-storage_rental': 'Lagerraumvermieter',
  'atlas_poiClassification--type=shop-supermarket': 'Supermarkt',
  'atlas_poiClassification--type=shop-tailor': 'Schneider',
  'atlas_poiClassification--type=shop-tattoo': 'Tätowierer',
  'atlas_poiClassification--type=shop-tea': 'Teegeschäft',
  'atlas_poiClassification--type=shop-telecommunication': 'Telekommunikationsfachgeschäft',
  'atlas_poiClassification--type=shop-ticket': 'Eintrittskartenverkäufer',
  'atlas_poiClassification--type=shop-tiles': 'Fliesenhändler',
  'atlas_poiClassification--type=shop-tobacco': 'Tabakwarengeschäft',
  'atlas_poiClassification--type=shop-tool_hire': 'Werkzeugverleih',
  'atlas_poiClassification--type=shop-toys': 'Spielwarengeschäft',
  'atlas_poiClassification--type=shop-trade': 'Baustoffhandel',
  'atlas_poiClassification--type=shop-travel_agency': 'Reisebüro',
  'atlas_poiClassification--type=shop-truck': 'Lkw-Handel',
  'atlas_poiClassification--type=shop-truck_repair': 'Lkw-Werkstatt',
  'atlas_poiClassification--type=shop-tyres': 'Reifenhandel',
  'atlas_poiClassification--type=shop-vacant': 'Leerstehendes Geschäft',
  'atlas_poiClassification--type=shop-vacuum_cleaner': 'Staubsaugergeschäft',
  'atlas_poiClassification--type=shop-variety_store': 'Sonderpostenmarkt',
  'atlas_poiClassification--type=shop-video': 'Videothek',
  'atlas_poiClassification--type=shop-video_games': 'Videospielgeschäft',
  'atlas_poiClassification--type=shop-watches': 'Uhrengeschäft',
  'atlas_poiClassification--type=shop-weapons': 'Waffengeschäft',
  'atlas_poiClassification--type=shop-wholesale': 'Großhandel',
  'atlas_poiClassification--type=shop-wigs': 'Perückenladen',
  'atlas_poiClassification--type=shop-window_blind': 'Fensterladengeschäft',
  'atlas_poiClassification--type=shop-wine': 'Weinhandel',
  'atlas_poiClassification--type=shop-wool': 'Wollladen',
  'atlas_poiClassification--type=shop-yes': 'Geschäft (nicht spezifizierter Typ)',
  'atlas_poiClassification--type=tourism-alpine_hut': 'Berghütte',
  'atlas_poiClassification--type=tourism-apartment': 'Ferienwohnung',
  'atlas_poiClassification--type=tourism-artwork': 'Kunst',
  'atlas_poiClassification--type=tourism-attraction': 'Sehenswürdigkeit',
  'atlas_poiClassification--type=tourism-camp_pitch': 'Zeltplatz/Wohnwagenplatz',
  'atlas_poiClassification--type=tourism-camp_site': 'Campingplatz',
  'atlas_poiClassification--type=tourism-caravan_site': 'Wohnmobil-Stellplatz',
  'atlas_poiClassification--type=tourism-chalet': 'Ferienhaus',
  'atlas_poiClassification--type=tourism-fallback': 'Tourismus (Auffangkategorie)',
  'atlas_poiClassification--type=tourism-fallback--description':
    'Auffangkategorie für seltene oder uneinheitliche tourism-Werte unterhalb des Volumen-Schwellenwertes.',
  'atlas_poiClassification--type=tourism-gallery': 'Kunstgalerie',
  'atlas_poiClassification--type=tourism-guest_house': 'Pension',
  'atlas_poiClassification--type=tourism-hostel': 'Hostel',
  'atlas_poiClassification--type=tourism-hotel': 'Hotel',
  'atlas_poiClassification--type=tourism-information': 'Information',
  'atlas_poiClassification--type=tourism-motel': 'Motel',
  'atlas_poiClassification--type=tourism-museum': 'Museum',
  'atlas_poiClassification--type=tourism-picnic_site': 'Picknickplatz',
  'atlas_poiClassification--type=tourism-theme_park': 'Themenpark',
  'atlas_poiClassification--type=tourism-trail_riding_station': 'Reitstation',
  'atlas_poiClassification--type=tourism-viewpoint': 'Aussichtspunkt',
  'atlas_poiClassification--type=tourism-zoo': 'Zoo',
  'atlas_publicTransport--category--key': 'Art',
  'atlas_publicTransport--category=ferry_station': 'Fähranleger',
  'atlas_publicTransport--category=light_rail_station': 'S-Bahn-Station',
  'atlas_publicTransport--category=railway_station': 'Bahnhof regional / überregional',
  'atlas_publicTransport--category=subway_station': 'U-Bahn-Station',
  'atlas_publicTransport--category=tram_station': 'Tramstation',
  'atlas_publicTransport--category=undefined': 'Nicht kategorisiert',
  'atlas_publicTransport--description--key': 'Beschreibung',
  'atlas_publicTransport--name--key': 'Name',
  'atlas_publicTransport--network_short--key': 'Verkehrsnetz (Kurzname)',
  'atlas_publicTransport--network--key': 'Verkehrsnetz',
  'atlas_publicTransport--operator--key': 'Betreiber',
  'atlas_publicTransport--title': 'ÖPNV-Haltepunkte und Fähranleger',
  'atlas_publicTransport--wikidata--key': 'Wikidata',
  'atlas_publicTransport--wikipedia--key': 'Wikipedia',
  'atlas_roads--bikelane_left--key': 'Radinfrastruktur links',
  'atlas_roads--bikelane_left=assumed_no': 'Vermutlich vollständig',
  'atlas_roads--bikelane_left=bicycleRoad': 'Fahrradstraße',
  'atlas_roads--bikelane_left=bicycleRoad_vehicleDestination':
    'Fahrradstraße mit Anlieger/Kfz frei',
  'atlas_roads--bikelane_left=crossing': 'Straßenquerung',
  'atlas_roads--bikelane_left=cycleway_adjoining': 'Radweg (straßenbegleitend)',
  'atlas_roads--bikelane_left=cycleway_adjoiningOrIsolated':
    'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roads--bikelane_left=cycleway_isolated': 'Radweg, selbstständig geführt',
  'atlas_roads--bikelane_left=cyclewayLink': 'Radweg-Verbindungsstück',
  'atlas_roads--bikelane_left=cyclewayOnHighway_advisory': 'Schutzstreifen',
  'atlas_roads--bikelane_left=cyclewayOnHighway_advisoryOrExclusive':
    'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
  'atlas_roads--bikelane_left=cyclewayOnHighway_exclusive': 'Radfahrstreifen',
  'atlas_roads--bikelane_left=cyclewayOnHighwayBetweenLanes':
    'Radfahrstreifen in Mittellage (Fahrradweiche)',
  'atlas_roads--bikelane_left=cyclewayOnHighwayProtected': 'Geschützter Radfahrstreifen (PBL)',
  'atlas_roads--bikelane_left=data_no': 'Vollständig (explizit keine)',
  'atlas_roads--bikelane_left=footAndCyclewaySegregated_adjoining':
    'Getrennter Rad- und Gehweg, straßenbegleitend',
  'atlas_roads--bikelane_left=footAndCyclewaySegregated_adjoiningOrIsolated':
    'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roads--bikelane_left=footAndCyclewaySegregated_isolated':
    'Getrennter Rad- und Gehweg, selbstständig geführt',
  'atlas_roads--bikelane_left=footAndCyclewayShared_adjoining':
    'Gemeinsamer Geh- und Radweg, straßenbegleitend',
  'atlas_roads--bikelane_left=footAndCyclewayShared_adjoiningOrIsolated':
    'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roads--bikelane_left=footAndCyclewayShared_isolated':
    'Gemeinsamer Geh- und Radweg, selbstständig geführt',
  'atlas_roads--bikelane_left=footwayBicycleYes_adjoining':
    'Gehweg mit Radfahrer frei, straßenbegleitend',
  'atlas_roads--bikelane_left=footwayBicycleYes_adjoiningOrIsolated':
    'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roads--bikelane_left=footwayBicycleYes_isolated':
    'Gehweg mit Radfahrer frei, selbstständig geführt',
  'atlas_roads--bikelane_left=missing': 'Unvollständig',
  'atlas_roads--bikelane_left=needsClarification': 'Führungsform unklar',
  'atlas_roads--bikelane_left=not_expected': 'Keine Infrastruktur erwartet',
  'atlas_roads--bikelane_left=pedestrianAreaBicycleYes': 'Fußgängerzone, Fahrrad frei',
  'atlas_roads--bikelane_left=separate_geometry': 'RVA als separate Geometrie erfasst',
  'atlas_roads--bikelane_left=sharedBusLaneBikeWithBus': 'Radfahrstreifen mit Freigabe Busverkehr',
  'atlas_roads--bikelane_left=sharedBusLaneBusWithBike': 'Bussonderfahrstreifen mit Fahrrad frei',
  'atlas_roads--bikelane_left=sharedMotorVehicleLane': 'Anteilig genutzter Fahrstreifen (Sharrows)',
  'atlas_roads--bikelane_right--key': 'Radinfrastruktur rechts',
  'atlas_roads--bikelane_right=assumed_no': 'Vermutlich vollständig',
  'atlas_roads--bikelane_right=bicycleRoad': 'Fahrradstraße',
  'atlas_roads--bikelane_right=bicycleRoad_vehicleDestination':
    'Fahrradstraße mit Anlieger/Kfz frei',
  'atlas_roads--bikelane_right=crossing': 'Straßenquerung',
  'atlas_roads--bikelane_right=cycleway_adjoining': 'Radweg (straßenbegleitend)',
  'atlas_roads--bikelane_right=cycleway_adjoiningOrIsolated':
    'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roads--bikelane_right=cycleway_isolated': 'Radweg, selbstständig geführt',
  'atlas_roads--bikelane_right=cyclewayLink': 'Radweg-Verbindungsstück',
  'atlas_roads--bikelane_right=cyclewayOnHighway_advisory': 'Schutzstreifen',
  'atlas_roads--bikelane_right=cyclewayOnHighway_advisoryOrExclusive':
    'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
  'atlas_roads--bikelane_right=cyclewayOnHighway_exclusive': 'Radfahrstreifen',
  'atlas_roads--bikelane_right=cyclewayOnHighwayBetweenLanes':
    'Radfahrstreifen in Mittellage (Fahrradweiche)',
  'atlas_roads--bikelane_right=cyclewayOnHighwayProtected': 'Geschützter Radfahrstreifen (PBL)',
  'atlas_roads--bikelane_right=data_no': 'Vollständig (explizit keine)',
  'atlas_roads--bikelane_right=footAndCyclewaySegregated_adjoining':
    'Getrennter Rad- und Gehweg, straßenbegleitend',
  'atlas_roads--bikelane_right=footAndCyclewaySegregated_adjoiningOrIsolated':
    'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roads--bikelane_right=footAndCyclewaySegregated_isolated':
    'Getrennter Rad- und Gehweg, selbstständig geführt',
  'atlas_roads--bikelane_right=footAndCyclewayShared_adjoining':
    'Gemeinsamer Geh- und Radweg, straßenbegleitend',
  'atlas_roads--bikelane_right=footAndCyclewayShared_adjoiningOrIsolated':
    'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roads--bikelane_right=footAndCyclewayShared_isolated':
    'Gemeinsamer Geh- und Radweg, selbstständig geführt',
  'atlas_roads--bikelane_right=footwayBicycleYes_adjoining':
    'Gehweg mit Radfahrer frei, straßenbegleitend',
  'atlas_roads--bikelane_right=footwayBicycleYes_adjoiningOrIsolated':
    'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roads--bikelane_right=footwayBicycleYes_isolated':
    'Gehweg mit Radfahrer frei, selbstständig geführt',
  'atlas_roads--bikelane_right=missing': 'Unvollständig',
  'atlas_roads--bikelane_right=needsClarification': 'Führungsform unklar',
  'atlas_roads--bikelane_right=not_expected': 'Keine Infrastruktur erwartet',
  'atlas_roads--bikelane_right=pedestrianAreaBicycleYes': 'Fußgängerzone, Fahrrad frei',
  'atlas_roads--bikelane_right=separate_geometry': 'RVA als separate Geometrie erfasst',
  'atlas_roads--bikelane_right=sharedBusLaneBikeWithBus': 'Radfahrstreifen mit Freigabe Busverkehr',
  'atlas_roads--bikelane_right=sharedBusLaneBusWithBike': 'Bussonderfahrstreifen mit Fahrrad frei',
  'atlas_roads--bikelane_right=sharedMotorVehicleLane':
    'Anteilig genutzter Fahrstreifen (Sharrows)',
  'atlas_roads--bikelane_self--key': 'Radinfrastruktur mittig',
  'atlas_roads--bikelane_self=assumed_no': 'Vermutlich vollständig',
  'atlas_roads--bikelane_self=bicycleRoad': 'Fahrradstraße',
  'atlas_roads--bikelane_self=bicycleRoad_vehicleDestination':
    'Fahrradstraße mit Anlieger/Kfz frei',
  'atlas_roads--bikelane_self=crossing': 'Straßenquerung',
  'atlas_roads--bikelane_self=cycleway_adjoining': 'Radweg (straßenbegleitend)',
  'atlas_roads--bikelane_self=cycleway_adjoiningOrIsolated':
    'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roads--bikelane_self=cycleway_isolated': 'Radweg, selbstständig geführt',
  'atlas_roads--bikelane_self=cyclewayLink': 'Radweg-Verbindungsstück',
  'atlas_roads--bikelane_self=cyclewayOnHighway_advisory': 'Schutzstreifen',
  'atlas_roads--bikelane_self=cyclewayOnHighway_advisoryOrExclusive':
    'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
  'atlas_roads--bikelane_self=cyclewayOnHighway_exclusive': 'Radfahrstreifen',
  'atlas_roads--bikelane_self=cyclewayOnHighwayBetweenLanes':
    'Radfahrstreifen in Mittellage (Fahrradweiche)',
  'atlas_roads--bikelane_self=cyclewayOnHighwayProtected': 'Geschützter Radfahrstreifen (PBL)',
  'atlas_roads--bikelane_self=data_no': 'Vollständig (explizit keine)',
  'atlas_roads--bikelane_self=footAndCyclewaySegregated_adjoining':
    'Getrennter Rad- und Gehweg, straßenbegleitend',
  'atlas_roads--bikelane_self=footAndCyclewaySegregated_adjoiningOrIsolated':
    'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roads--bikelane_self=footAndCyclewaySegregated_isolated':
    'Getrennter Rad- und Gehweg, selbstständig geführt',
  'atlas_roads--bikelane_self=footAndCyclewayShared_adjoining':
    'Gemeinsamer Geh- und Radweg, straßenbegleitend',
  'atlas_roads--bikelane_self=footAndCyclewayShared_adjoiningOrIsolated':
    'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roads--bikelane_self=footAndCyclewayShared_isolated':
    'Gemeinsamer Geh- und Radweg, selbstständig geführt',
  'atlas_roads--bikelane_self=footwayBicycleYes_adjoining':
    'Gehweg mit Radfahrer frei, straßenbegleitend',
  'atlas_roads--bikelane_self=footwayBicycleYes_adjoiningOrIsolated':
    'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roads--bikelane_self=footwayBicycleYes_isolated':
    'Gehweg mit Radfahrer frei, selbstständig geführt',
  'atlas_roads--bikelane_self=missing': 'Unvollständig',
  'atlas_roads--bikelane_self=needsClarification': 'Führungsform unklar',
  'atlas_roads--bikelane_self=not_expected': 'Keine Infrastruktur erwartet',
  'atlas_roads--bikelane_self=pedestrianAreaBicycleYes': 'Fußgängerzone, Fahrrad frei',
  'atlas_roads--bikelane_self=separate_geometry': 'RVA als separate Geometrie erfasst',
  'atlas_roads--bikelane_self=sharedBusLaneBikeWithBus': 'Radfahrstreifen mit Freigabe Busverkehr',
  'atlas_roads--bikelane_self=sharedBusLaneBusWithBike': 'Bussonderfahrstreifen mit Fahrrad frei',
  'atlas_roads--bikelane_self=sharedMotorVehicleLane': 'Anteilig genutzter Fahrstreifen (Sharrows)',
  'atlas_roads--bridge--key': 'Brücke',
  'atlas_roads--bridge=yes': 'Ja',
  'atlas_roads--covered--key': 'Überdacht',
  'atlas_roads--covered=covered': 'Überdacht',
  'atlas_roads--covered=covered--description':
    'Vollständig überdachte Wege (`covered=yes`) und Arkaden (`covered=arcade`, zur Seite hin offen).',
  'atlas_roads--covered=indoor': 'In einem Gebäude',
  'atlas_roads--covered=partial': 'Teilweise überdacht',
  'atlas_roads--description--key': 'Hinweis aus OSM',
  'atlas_roads--highway--key': 'OSM-Straßentyp',
  'atlas_roads--highway=cycleway': 'Radweg',
  'atlas_roads--highway=footway': 'Fußweg',
  'atlas_roads--highway=living_street': 'Verkehrsberuhigter Bereich',
  'atlas_roads--highway=motorway': 'Autobahn',
  'atlas_roads--highway=motorway_link': 'Zufahrt einer Autobahn',
  'atlas_roads--highway=path': 'Weg / Pfad',
  'atlas_roads--highway=pedestrian': 'Fußgängerzone',
  'atlas_roads--highway=primary': 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_roads--highway=primary_link':
    'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_roads--highway=residential': 'Anwohnerstraße',
  'atlas_roads--highway=road': 'Unkategorisierte Straße',
  'atlas_roads--highway=secondary': 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
  'atlas_roads--highway=secondary_link':
    'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
  'atlas_roads--highway=service': 'Zufahrtsweg',
  'atlas_roads--highway=steps': 'Stufen',
  'atlas_roads--highway=tertiary': 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
  'atlas_roads--highway=tertiary_link':
    'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
  'atlas_roads--highway=track': 'Wald- / Feldweg',
  'atlas_roads--highway=trunk': 'Kraftfahrstraße',
  'atlas_roads--highway=trunk_link': 'Kraftfahrstraßen-Anschluss',
  'atlas_roads--highway=unclassified': 'Nebenstraße mit Verbindungscharakter',
  'atlas_roads--informal--key': 'Trampelpfad',
  'atlas_roads--informal=yes': 'Weg als informeller Weg erfasst',
  'atlas_roads--length--key': 'Länge',
  'atlas_roads--lifecycle--key': 'Status',
  'atlas_roads--lifecycle=blocked': 'Gesperrt (Sperrung)',
  'atlas_roads--lifecycle=construction': 'In Bau',
  'atlas_roads--lifecycle=construction_no_access': 'Gesperrt aufgrund einer Baustelle',
  'atlas_roads--lifecycle=temporary': 'Temporärer Weg',
  'atlas_roads--lit--key': 'Beleuchtung',
  'atlas_roads--lit=no': 'Nicht beleuchtet',
  'atlas_roads--lit=special': 'Spezielle Angaben',
  'atlas_roads--lit=yes': 'Beleuchtet',
  'atlas_roads--mapillary_backward--key': 'Mapillary gegen Linienrichtung',
  'atlas_roads--mapillary_coverage--key': 'Mapillary-Abdeckung',
  'atlas_roads--mapillary_coverage=pano': 'Panorama-Aufnahmen',
  'atlas_roads--mapillary_coverage=regular': 'Standard-Aufnahmen',
  'atlas_roads--mapillary_forward--key': 'Mapillary in Linienrichtung',
  'atlas_roads--mapillary_traffic_sign--key': 'Mapillary für Verkehrszeichen',
  'atlas_roads--mapillary--key': 'Straßenfotos (Mapillary)',
  'atlas_roads--maxspeed_confidence--key': 'Konfidenz Höchstgeschwindigkeit',
  'atlas_roads--maxspeed_confidence=high': 'Hoch',
  'atlas_roads--maxspeed_confidence=low': 'Niedrig',
  'atlas_roads--maxspeed_confidence=medium': 'Mittel',
  'atlas_roads--maxspeed_source--key': 'Höchstgeschwindigkeit Quelle',
  'atlas_roads--maxspeed_source=inferred_from_highway': 'Abgeleitet vom `highway`-Tag',
  'atlas_roads--maxspeed_source=maxspeed': 'In OSM erfasst als Tag `maxspeed`',
  'atlas_roads--maxspeed_source=maxspeed_tag': 'In OSM erfasst über einen `maxspeed`-Kategorie-Tag',
  'atlas_roads--maxspeed_source=zone': 'OSM-Zonen-Tag',
  'atlas_roads--maxspeed--key': 'Höchstgeschwindigkeit',
  'atlas_roads--name_ref--key': 'Referenzname',
  'atlas_roads--name--key': 'Name',
  'atlas_roads--oneway_bicycle--key': 'Verkehrsrichtung Fahrrad',
  'atlas_roads--oneway_bicycle=no': 'Beide Richtungen für Radverkehr',
  'atlas_roads--oneway_bicycle=yes': 'Eine Richtung (auch für Radverkehr)',
  'atlas_roads--oneway--key': 'Verkehrsrichtung',
  'atlas_roads--oneway=no': 'Beide Richtungen',
  'atlas_roads--oneway=yes': 'Einbahnstraße',
  'atlas_roads--oneway=yes_dual_carriageway': 'Einbahnstraße da separate Geometrie pro Seite',
  'atlas_roads--operator_type--key': 'Betreibertyp',
  'atlas_roads--operator_type=private': 'Privat',
  'atlas_roads--operator_type=public': 'Öffentlich',
  'atlas_roads--osm_maxspeed:backward--key':
    'Spezielle Höchstgeschwindigkeit gegen die Linienrichtung',
  'atlas_roads--osm_maxspeed:conditional--key':
    'Spezielle Höchstgeschwindigkeit mit Einschränkungen',
  'atlas_roads--osm_maxspeed:forward--key':
    'Spezielle Höchstgeschwindigkeit mit der Linienrichtung',
  'atlas_roads--road--key': 'Straßentyp',
  'atlas_roads--road=bicycle_road': 'Fahrradstraße',
  'atlas_roads--road=construction': 'Straße ist in Bau',
  'atlas_roads--road=cycleway': 'Radweg',
  'atlas_roads--road=cycleway_crossing': 'Straßenquerung (Radweg)',
  'atlas_roads--road=footway': 'Fußweg',
  'atlas_roads--road=footway_crossing': 'Straßenquerung (Fußweg)',
  'atlas_roads--road=footway_cycleway_crossing': 'Straßenquerung (Fuß- und Radweg)',
  'atlas_roads--road=footway_sidewalk': 'Gehweg',
  'atlas_roads--road=footway_steps': 'Treppe',
  'atlas_roads--road=living_street': 'Verkehrsberuhigter Bereich',
  'atlas_roads--road=motorway': 'Autobahn',
  'atlas_roads--road=motorway_link': 'Zufahrt einer Autobahn',
  'atlas_roads--road=path': 'Weg / Pfad',
  'atlas_roads--road=pedestrian': 'Fußgängerzone',
  'atlas_roads--road=primary': 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_roads--road=primary_link':
    'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_roads--road=residential': 'Anwohnerstraße',
  'atlas_roads--road=residential_priority_road': 'residential_priority_road',
  'atlas_roads--road=secondary': 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
  'atlas_roads--road=secondary_link':
    'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
  'atlas_roads--road=service_alley': 'Gasse',
  'atlas_roads--road=service_driveway': 'Grundstückszufahrt',
  'atlas_roads--road=service_emergency_access': 'Rettungsweg',
  'atlas_roads--road=service_parking_aisle': 'Parkplatzweg',
  'atlas_roads--road=service_road': 'Zufahrtsweg',
  'atlas_roads--road=service_uncategorized': 'Zufahrtsweg (unbekannte Klassifizierung)',
  'atlas_roads--road=tertiary': 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
  'atlas_roads--road=tertiary_link':
    'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
  'atlas_roads--road=track': 'Wald- / Feldweg',
  'atlas_roads--road=unclassified': 'Nebenstraße mit Verbindungscharakter',
  'atlas_roads--road=unspecified_road': 'Unkategorisierte Straße',
  'atlas_roads--route_relations--key': 'Routen',
  'atlas_roads--smoothness_confidence--key': 'Konfidenz Ober&shy;flächen&shy;qualität',
  'atlas_roads--smoothness_confidence=high': 'Hoch',
  'atlas_roads--smoothness_confidence=medium': 'Mittel',
  'atlas_roads--smoothness_source--key': 'Herkunft der Ober&shy;flächen&shy;qualität',
  'atlas_roads--smoothness_source=mtb:scale_to_smoothness': 'Abgeleitet von `mtb:scale`',
  'atlas_roads--smoothness_source=surface_to_smoothness': 'Abgeleitet von `surface`',
  'atlas_roads--smoothness_source=tag': 'OSM-Tag `smoothness`',
  'atlas_roads--smoothness_source=tag_normalized': 'OSM-Tag `smoothness` (normalisiert)',
  'atlas_roads--smoothness_source=tracktype_to_smoothness': 'Abgeleitet von `tracktype`',
  'atlas_roads--smoothness--key': 'Ober&shy;flächen&shy;qualität',
  'atlas_roads--smoothness=bad': 'Schlecht',
  'atlas_roads--smoothness=excellent': 'Sehr gut',
  'atlas_roads--smoothness=good': 'Gut',
  'atlas_roads--smoothness=intermediate': 'Mittel gut',
  'atlas_roads--smoothness=very_bad': 'Sehr schlecht',
  'atlas_roads--surface_color--key': 'Ober&shy;flächen&shy;farbe',
  'atlas_roads--surface_color=green': 'Grün',
  'atlas_roads--surface_color=no': 'Keine besondere Farbe',
  'atlas_roads--surface_color=red': 'Rot',
  'atlas_roads--surface_color=red;green': 'Rot und Grün',
  'atlas_roads--surface_confidence--key': 'Konfidenz der Oberfläche',
  'atlas_roads--surface_confidence=high': 'Hoch',
  'atlas_roads--surface_confidence=low': 'Niedrig',
  'atlas_roads--surface_confidence=medium': 'Mittel',
  'atlas_roads--surface_source--key': 'Herkunft der Oberfläche',
  'atlas_roads--surface_source=parent_highway_tag': 'Von zugeordneter Straße (OSM)',
  'atlas_roads--surface_source=parent_highway_tag_transformed':
    'Von zugeordneter Straße, normalisiert',
  'atlas_roads--surface_source=tag': 'Explizite Angabe aus OSM',
  'atlas_roads--surface_source=tag_transformed': 'Aus OSM-Tag normalisiert',
  'atlas_roads--surface--key': 'Oberfläche',
  'atlas_roads--surface=asphalt': 'Asphalt',
  'atlas_roads--surface=bricks': 'Ziegel',
  'atlas_roads--surface=compacted': 'Verdichteter Untergrund',
  'atlas_roads--surface=concrete': 'Beton',
  'atlas_roads--surface=concrete:lanes': 'Betonstreifen / -bahnen',
  'atlas_roads--surface=concrete:plates': 'Betonplatten',
  'atlas_roads--surface=fine_gravel': 'Splitt',
  'atlas_roads--surface=grass': 'Gras',
  'atlas_roads--surface=grass_paver': 'Rasengitter / Grasgitter',
  'atlas_roads--surface=gravel': 'Schotter',
  'atlas_roads--surface=ground': 'Erde/Boden',
  'atlas_roads--surface=large_sett': 'Großpflaster',
  'atlas_roads--surface=metal': 'Metall',
  'atlas_roads--surface=metal_grid': 'Metallgitter',
  'atlas_roads--surface=mosaic_sett': 'Mosaikpflaster',
  'atlas_roads--surface=paved': 'Befestigt (unspezifisch)',
  'atlas_roads--surface=paving_stones': 'Verbund&shy;pflastersteine',
  'atlas_roads--surface=paving_stones:lanes': 'Pflasterstein&shy;bahnen',
  'atlas_roads--surface=pebblestone': 'Kieselsteine',
  'atlas_roads--surface=plastic': 'Kunststoff',
  'atlas_roads--surface=rubber': 'Gummi',
  'atlas_roads--surface=sand': 'Sand',
  'atlas_roads--surface=sett': 'Behauenes Pflaster / Natursteinpflaster',
  'atlas_roads--surface=small_sett': 'Kleinpflaster',
  'atlas_roads--surface=stone': 'Stein',
  'atlas_roads--surface=unpaved': 'Unbefestigt',
  'atlas_roads--surface=wood': 'Holz',
  'atlas_roads--surface=woodchips': 'Hackschnitzel',
  'atlas_roads--title': 'Daten zur Straße',
  'atlas_roads--todos--key': 'Todo-Liste',
  'atlas_roads--traffic_sign--key': 'Beschilderung',
  'atlas_roads--traffic_sign:backward--key': 'Beschilderung in Gegenrichtung',
  'atlas_roads--traffic_sign:backward=none': 'Unbeschildert',
  'atlas_roads--traffic_sign:forward--key': 'Beschilderung in Verkehrsrichtung',
  'atlas_roads--traffic_sign:forward=none': 'Unbeschildert',
  'atlas_roads--traffic_sign=none': 'Unbeschildert',
  'atlas_roads--tunnel--key': 'Tunnel',
  'atlas_roads--tunnel=yes': 'Ja',
  'atlas_roads--tunnel=yes--description':
    'Wege mit `tunnel=yes` und Gebäudedurchgänge mit `tunnel=building_passage`.',
  'atlas_roads--width_effective--key': 'Effektive Breite',
  'atlas_roads--width_source--key': 'Quelle Breite',
  'atlas_roads--width_source=ALKIS': 'Aus ALKIS Daten ausgemessen',
  'atlas_roads--width_source=ARCore': 'Mit dem Handy-Metermaß von StreetComplete gemessen',
  'atlas_roads--width--key': 'Breite',
  'atlas_roadsPathClasses--adjoining_maxspeed--key':
    'Höchstgeschwindigkeit der angrenzenden Straße',
  'atlas_roadsPathClasses--adjoining_road--key': 'Straßentyp der angrenzenden Straße',
  'atlas_roadsPathClasses--adjoining_road=bicycle_road': 'Fahrradstraße',
  'atlas_roadsPathClasses--adjoining_road=construction': 'Straße ist in Bau',
  'atlas_roadsPathClasses--adjoining_road=cycleway': 'Radweg',
  'atlas_roadsPathClasses--adjoining_road=cycleway_crossing': 'Straßenquerung (Radweg)',
  'atlas_roadsPathClasses--adjoining_road=footway': 'Fußweg',
  'atlas_roadsPathClasses--adjoining_road=footway_crossing': 'Straßenquerung (Fußweg)',
  'atlas_roadsPathClasses--adjoining_road=footway_cycleway_crossing':
    'Straßenquerung (Fuß- und Radweg)',
  'atlas_roadsPathClasses--adjoining_road=footway_sidewalk': 'Gehweg',
  'atlas_roadsPathClasses--adjoining_road=footway_steps': 'Treppe',
  'atlas_roadsPathClasses--adjoining_road=living_street': 'Verkehrsberuhigter Bereich',
  'atlas_roadsPathClasses--adjoining_road=motorway': 'Autobahn',
  'atlas_roadsPathClasses--adjoining_road=motorway_link': 'Zufahrt einer Autobahn',
  'atlas_roadsPathClasses--adjoining_road=path': 'Weg / Pfad',
  'atlas_roadsPathClasses--adjoining_road=pedestrian': 'Fußgängerzone',
  'atlas_roadsPathClasses--adjoining_road=primary':
    'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_roadsPathClasses--adjoining_road=primary_link':
    'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_roadsPathClasses--adjoining_road=residential': 'Anwohnerstraße',
  'atlas_roadsPathClasses--adjoining_road=residential_priority_road': 'residential_priority_road',
  'atlas_roadsPathClasses--adjoining_road=secondary':
    'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
  'atlas_roadsPathClasses--adjoining_road=secondary_link':
    'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
  'atlas_roadsPathClasses--adjoining_road=service_alley': 'Gasse',
  'atlas_roadsPathClasses--adjoining_road=service_driveway': 'Grundstückszufahrt',
  'atlas_roadsPathClasses--adjoining_road=service_emergency_access': 'Rettungsweg',
  'atlas_roadsPathClasses--adjoining_road=service_parking_aisle': 'Parkplatzweg',
  'atlas_roadsPathClasses--adjoining_road=service_road': 'Zufahrtsweg',
  'atlas_roadsPathClasses--adjoining_road=service_uncategorized':
    'Zufahrtsweg (unbekannte Klassifizierung)',
  'atlas_roadsPathClasses--adjoining_road=tertiary':
    'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
  'atlas_roadsPathClasses--adjoining_road=tertiary_link':
    'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
  'atlas_roadsPathClasses--adjoining_road=track': 'Wald- / Feldweg',
  'atlas_roadsPathClasses--adjoining_road=unclassified': 'Nebenstraße mit Verbindungscharakter',
  'atlas_roadsPathClasses--adjoining_road=unspecified_road': 'Unkategorisierte Straße',
  'atlas_roadsPathClasses--bikelane_left--key': 'Radinfrastruktur links',
  'atlas_roadsPathClasses--bikelane_left=assumed_no': 'Vermutlich vollständig',
  'atlas_roadsPathClasses--bikelane_left=bicycleRoad': 'Fahrradstraße',
  'atlas_roadsPathClasses--bikelane_left=bicycleRoad_vehicleDestination':
    'Fahrradstraße mit Anlieger/Kfz frei',
  'atlas_roadsPathClasses--bikelane_left=crossing': 'Straßenquerung',
  'atlas_roadsPathClasses--bikelane_left=cycleway_adjoining': 'Radweg (straßenbegleitend)',
  'atlas_roadsPathClasses--bikelane_left=cycleway_adjoiningOrIsolated':
    'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_left=cycleway_isolated': 'Radweg, selbstständig geführt',
  'atlas_roadsPathClasses--bikelane_left=cyclewayLink': 'Radweg-Verbindungsstück',
  'atlas_roadsPathClasses--bikelane_left=cyclewayOnHighway_advisory': 'Schutzstreifen',
  'atlas_roadsPathClasses--bikelane_left=cyclewayOnHighway_advisoryOrExclusive':
    'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_left=cyclewayOnHighway_exclusive': 'Radfahrstreifen',
  'atlas_roadsPathClasses--bikelane_left=cyclewayOnHighwayBetweenLanes':
    'Radfahrstreifen in Mittellage (Fahrradweiche)',
  'atlas_roadsPathClasses--bikelane_left=cyclewayOnHighwayProtected':
    'Geschützter Radfahrstreifen (PBL)',
  'atlas_roadsPathClasses--bikelane_left=data_no': 'Vollständig (explizit keine)',
  'atlas_roadsPathClasses--bikelane_left=footAndCyclewaySegregated_adjoining':
    'Getrennter Rad- und Gehweg, straßenbegleitend',
  'atlas_roadsPathClasses--bikelane_left=footAndCyclewaySegregated_adjoiningOrIsolated':
    'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_left=footAndCyclewaySegregated_isolated':
    'Getrennter Rad- und Gehweg, selbstständig geführt',
  'atlas_roadsPathClasses--bikelane_left=footAndCyclewayShared_adjoining':
    'Gemeinsamer Geh- und Radweg, straßenbegleitend',
  'atlas_roadsPathClasses--bikelane_left=footAndCyclewayShared_adjoiningOrIsolated':
    'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_left=footAndCyclewayShared_isolated':
    'Gemeinsamer Geh- und Radweg, selbstständig geführt',
  'atlas_roadsPathClasses--bikelane_left=footwayBicycleYes_adjoining':
    'Gehweg mit Radfahrer frei, straßenbegleitend',
  'atlas_roadsPathClasses--bikelane_left=footwayBicycleYes_adjoiningOrIsolated':
    'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_left=footwayBicycleYes_isolated':
    'Gehweg mit Radfahrer frei, selbstständig geführt',
  'atlas_roadsPathClasses--bikelane_left=missing': 'Unvollständig',
  'atlas_roadsPathClasses--bikelane_left=needsClarification': 'Führungsform unklar',
  'atlas_roadsPathClasses--bikelane_left=not_expected': 'Keine Infrastruktur erwartet',
  'atlas_roadsPathClasses--bikelane_left=pedestrianAreaBicycleYes': 'Fußgängerzone, Fahrrad frei',
  'atlas_roadsPathClasses--bikelane_left=separate_geometry': 'RVA als separate Geometrie erfasst',
  'atlas_roadsPathClasses--bikelane_left=sharedBusLaneBikeWithBus':
    'Radfahrstreifen mit Freigabe Busverkehr',
  'atlas_roadsPathClasses--bikelane_left=sharedBusLaneBusWithBike':
    'Bussonderfahrstreifen mit Fahrrad frei',
  'atlas_roadsPathClasses--bikelane_left=sharedMotorVehicleLane':
    'Anteilig genutzter Fahrstreifen (Sharrows)',
  'atlas_roadsPathClasses--bikelane_right--key': 'Radinfrastruktur rechts',
  'atlas_roadsPathClasses--bikelane_right=assumed_no': 'Vermutlich vollständig',
  'atlas_roadsPathClasses--bikelane_right=bicycleRoad': 'Fahrradstraße',
  'atlas_roadsPathClasses--bikelane_right=bicycleRoad_vehicleDestination':
    'Fahrradstraße mit Anlieger/Kfz frei',
  'atlas_roadsPathClasses--bikelane_right=crossing': 'Straßenquerung',
  'atlas_roadsPathClasses--bikelane_right=cycleway_adjoining': 'Radweg (straßenbegleitend)',
  'atlas_roadsPathClasses--bikelane_right=cycleway_adjoiningOrIsolated':
    'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_right=cycleway_isolated': 'Radweg, selbstständig geführt',
  'atlas_roadsPathClasses--bikelane_right=cyclewayLink': 'Radweg-Verbindungsstück',
  'atlas_roadsPathClasses--bikelane_right=cyclewayOnHighway_advisory': 'Schutzstreifen',
  'atlas_roadsPathClasses--bikelane_right=cyclewayOnHighway_advisoryOrExclusive':
    'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_right=cyclewayOnHighway_exclusive': 'Radfahrstreifen',
  'atlas_roadsPathClasses--bikelane_right=cyclewayOnHighwayBetweenLanes':
    'Radfahrstreifen in Mittellage (Fahrradweiche)',
  'atlas_roadsPathClasses--bikelane_right=cyclewayOnHighwayProtected':
    'Geschützter Radfahrstreifen (PBL)',
  'atlas_roadsPathClasses--bikelane_right=data_no': 'Vollständig (explizit keine)',
  'atlas_roadsPathClasses--bikelane_right=footAndCyclewaySegregated_adjoining':
    'Getrennter Rad- und Gehweg, straßenbegleitend',
  'atlas_roadsPathClasses--bikelane_right=footAndCyclewaySegregated_adjoiningOrIsolated':
    'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_right=footAndCyclewaySegregated_isolated':
    'Getrennter Rad- und Gehweg, selbstständig geführt',
  'atlas_roadsPathClasses--bikelane_right=footAndCyclewayShared_adjoining':
    'Gemeinsamer Geh- und Radweg, straßenbegleitend',
  'atlas_roadsPathClasses--bikelane_right=footAndCyclewayShared_adjoiningOrIsolated':
    'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_right=footAndCyclewayShared_isolated':
    'Gemeinsamer Geh- und Radweg, selbstständig geführt',
  'atlas_roadsPathClasses--bikelane_right=footwayBicycleYes_adjoining':
    'Gehweg mit Radfahrer frei, straßenbegleitend',
  'atlas_roadsPathClasses--bikelane_right=footwayBicycleYes_adjoiningOrIsolated':
    'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_right=footwayBicycleYes_isolated':
    'Gehweg mit Radfahrer frei, selbstständig geführt',
  'atlas_roadsPathClasses--bikelane_right=missing': 'Unvollständig',
  'atlas_roadsPathClasses--bikelane_right=needsClarification': 'Führungsform unklar',
  'atlas_roadsPathClasses--bikelane_right=not_expected': 'Keine Infrastruktur erwartet',
  'atlas_roadsPathClasses--bikelane_right=pedestrianAreaBicycleYes': 'Fußgängerzone, Fahrrad frei',
  'atlas_roadsPathClasses--bikelane_right=separate_geometry': 'RVA als separate Geometrie erfasst',
  'atlas_roadsPathClasses--bikelane_right=sharedBusLaneBikeWithBus':
    'Radfahrstreifen mit Freigabe Busverkehr',
  'atlas_roadsPathClasses--bikelane_right=sharedBusLaneBusWithBike':
    'Bussonderfahrstreifen mit Fahrrad frei',
  'atlas_roadsPathClasses--bikelane_right=sharedMotorVehicleLane':
    'Anteilig genutzter Fahrstreifen (Sharrows)',
  'atlas_roadsPathClasses--bikelane_self--key': 'Radinfrastruktur mittig',
  'atlas_roadsPathClasses--bikelane_self=assumed_no': 'Vermutlich vollständig',
  'atlas_roadsPathClasses--bikelane_self=bicycleRoad': 'Fahrradstraße',
  'atlas_roadsPathClasses--bikelane_self=bicycleRoad_vehicleDestination':
    'Fahrradstraße mit Anlieger/Kfz frei',
  'atlas_roadsPathClasses--bikelane_self=crossing': 'Straßenquerung',
  'atlas_roadsPathClasses--bikelane_self=cycleway_adjoining': 'Radweg (straßenbegleitend)',
  'atlas_roadsPathClasses--bikelane_self=cycleway_adjoiningOrIsolated':
    'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_self=cycleway_isolated': 'Radweg, selbstständig geführt',
  'atlas_roadsPathClasses--bikelane_self=cyclewayLink': 'Radweg-Verbindungsstück',
  'atlas_roadsPathClasses--bikelane_self=cyclewayOnHighway_advisory': 'Schutzstreifen',
  'atlas_roadsPathClasses--bikelane_self=cyclewayOnHighway_advisoryOrExclusive':
    'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_self=cyclewayOnHighway_exclusive': 'Radfahrstreifen',
  'atlas_roadsPathClasses--bikelane_self=cyclewayOnHighwayBetweenLanes':
    'Radfahrstreifen in Mittellage (Fahrradweiche)',
  'atlas_roadsPathClasses--bikelane_self=cyclewayOnHighwayProtected':
    'Geschützter Radfahrstreifen (PBL)',
  'atlas_roadsPathClasses--bikelane_self=data_no': 'Vollständig (explizit keine)',
  'atlas_roadsPathClasses--bikelane_self=footAndCyclewaySegregated_adjoining':
    'Getrennter Rad- und Gehweg, straßenbegleitend',
  'atlas_roadsPathClasses--bikelane_self=footAndCyclewaySegregated_adjoiningOrIsolated':
    'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_self=footAndCyclewaySegregated_isolated':
    'Getrennter Rad- und Gehweg, selbstständig geführt',
  'atlas_roadsPathClasses--bikelane_self=footAndCyclewayShared_adjoining':
    'Gemeinsamer Geh- und Radweg, straßenbegleitend',
  'atlas_roadsPathClasses--bikelane_self=footAndCyclewayShared_adjoiningOrIsolated':
    'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_self=footAndCyclewayShared_isolated':
    'Gemeinsamer Geh- und Radweg, selbstständig geführt',
  'atlas_roadsPathClasses--bikelane_self=footwayBicycleYes_adjoining':
    'Gehweg mit Radfahrer frei, straßenbegleitend',
  'atlas_roadsPathClasses--bikelane_self=footwayBicycleYes_adjoiningOrIsolated':
    'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'atlas_roadsPathClasses--bikelane_self=footwayBicycleYes_isolated':
    'Gehweg mit Radfahrer frei, selbstständig geführt',
  'atlas_roadsPathClasses--bikelane_self=missing': 'Unvollständig',
  'atlas_roadsPathClasses--bikelane_self=needsClarification': 'Führungsform unklar',
  'atlas_roadsPathClasses--bikelane_self=not_expected': 'Keine Infrastruktur erwartet',
  'atlas_roadsPathClasses--bikelane_self=pedestrianAreaBicycleYes': 'Fußgängerzone, Fahrrad frei',
  'atlas_roadsPathClasses--bikelane_self=separate_geometry': 'RVA als separate Geometrie erfasst',
  'atlas_roadsPathClasses--bikelane_self=sharedBusLaneBikeWithBus':
    'Radfahrstreifen mit Freigabe Busverkehr',
  'atlas_roadsPathClasses--bikelane_self=sharedBusLaneBusWithBike':
    'Bussonderfahrstreifen mit Fahrrad frei',
  'atlas_roadsPathClasses--bikelane_self=sharedMotorVehicleLane':
    'Anteilig genutzter Fahrstreifen (Sharrows)',
  'atlas_roadsPathClasses--covered--key': 'Überdacht',
  'atlas_roadsPathClasses--covered=covered': 'Überdacht',
  'atlas_roadsPathClasses--covered=covered--description':
    'Vollständig überdachte Wege (`covered=yes`) und Arkaden (`covered=arcade`, zur Seite hin offen).',
  'atlas_roadsPathClasses--covered=indoor': 'In einem Gebäude',
  'atlas_roadsPathClasses--covered=partial': 'Teilweise überdacht',
  'atlas_roadsPathClasses--description--key': 'Hinweis aus OSM',
  'atlas_roadsPathClasses--informal--key': 'Trampelpfad',
  'atlas_roadsPathClasses--informal=yes': 'Weg als informeller Weg erfasst',
  'atlas_roadsPathClasses--length--key': 'Länge',
  'atlas_roadsPathClasses--lifecycle--key': 'Status',
  'atlas_roadsPathClasses--lifecycle=blocked': 'Gesperrt (Sperrung)',
  'atlas_roadsPathClasses--lifecycle=construction': 'In Bau',
  'atlas_roadsPathClasses--lifecycle=construction_no_access': 'Gesperrt aufgrund einer Baustelle',
  'atlas_roadsPathClasses--lifecycle=temporary': 'Temporärer Weg',
  'atlas_roadsPathClasses--lit--key': 'Beleuchtung',
  'atlas_roadsPathClasses--lit=no': 'Nicht beleuchtet',
  'atlas_roadsPathClasses--lit=special': 'Spezielle Angaben',
  'atlas_roadsPathClasses--lit=yes': 'Beleuchtet',
  'atlas_roadsPathClasses--mapillary_backward--key': 'Mapillary gegen Linienrichtung',
  'atlas_roadsPathClasses--mapillary_coverage--key': 'Mapillary-Abdeckung',
  'atlas_roadsPathClasses--mapillary_coverage=pano': 'Panorama-Aufnahmen',
  'atlas_roadsPathClasses--mapillary_coverage=regular': 'Standard-Aufnahmen',
  'atlas_roadsPathClasses--mapillary_forward--key': 'Mapillary in Linienrichtung',
  'atlas_roadsPathClasses--mapillary_traffic_sign--key': 'Mapillary für Verkehrszeichen',
  'atlas_roadsPathClasses--mapillary--key': 'Straßenfotos (Mapillary)',
  'atlas_roadsPathClasses--name--key': 'Name',
  'atlas_roadsPathClasses--oneway_bicycle--key': 'Verkehrsrichtung Fahrrad',
  'atlas_roadsPathClasses--oneway_bicycle=no': 'Beide Richtungen für Radverkehr',
  'atlas_roadsPathClasses--oneway_bicycle=yes': 'Eine Richtung (auch für Radverkehr)',
  'atlas_roadsPathClasses--oneway--key': 'Verkehrsrichtung',
  'atlas_roadsPathClasses--oneway=no': 'Beide Richtungen',
  'atlas_roadsPathClasses--oneway=yes': 'Einbahnstraße',
  'atlas_roadsPathClasses--oneway=yes_dual_carriageway':
    'Einbahnstraße da separate Geometrie pro Seite',
  'atlas_roadsPathClasses--operator_type--key': 'Betreibertyp',
  'atlas_roadsPathClasses--operator_type=private': 'Privat',
  'atlas_roadsPathClasses--operator_type=public': 'Öffentlich',
  'atlas_roadsPathClasses--road--key': 'Straßentyp',
  'atlas_roadsPathClasses--road=bicycle_road': 'Fahrradstraße',
  'atlas_roadsPathClasses--road=construction': 'Straße ist in Bau',
  'atlas_roadsPathClasses--road=cycleway': 'Radweg',
  'atlas_roadsPathClasses--road=cycleway_crossing': 'Straßenquerung (Radweg)',
  'atlas_roadsPathClasses--road=footway': 'Fußweg',
  'atlas_roadsPathClasses--road=footway_crossing': 'Straßenquerung (Fußweg)',
  'atlas_roadsPathClasses--road=footway_cycleway_crossing': 'Straßenquerung (Fuß- und Radweg)',
  'atlas_roadsPathClasses--road=footway_sidewalk': 'Gehweg',
  'atlas_roadsPathClasses--road=footway_steps': 'Treppe',
  'atlas_roadsPathClasses--road=living_street': 'Verkehrsberuhigter Bereich',
  'atlas_roadsPathClasses--road=motorway': 'Autobahn',
  'atlas_roadsPathClasses--road=motorway_link': 'Zufahrt einer Autobahn',
  'atlas_roadsPathClasses--road=path': 'Weg / Pfad',
  'atlas_roadsPathClasses--road=pedestrian': 'Fußgängerzone',
  'atlas_roadsPathClasses--road=primary': 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_roadsPathClasses--road=primary_link':
    'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'atlas_roadsPathClasses--road=residential': 'Anwohnerstraße',
  'atlas_roadsPathClasses--road=residential_priority_road': 'residential_priority_road',
  'atlas_roadsPathClasses--road=secondary': 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
  'atlas_roadsPathClasses--road=secondary_link':
    'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
  'atlas_roadsPathClasses--road=service_alley': 'Gasse',
  'atlas_roadsPathClasses--road=service_driveway': 'Grundstückszufahrt',
  'atlas_roadsPathClasses--road=service_emergency_access': 'Rettungsweg',
  'atlas_roadsPathClasses--road=service_parking_aisle': 'Parkplatzweg',
  'atlas_roadsPathClasses--road=service_road': 'Zufahrtsweg',
  'atlas_roadsPathClasses--road=service_uncategorized': 'Zufahrtsweg (unbekannte Klassifizierung)',
  'atlas_roadsPathClasses--road=tertiary': 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
  'atlas_roadsPathClasses--road=tertiary_link':
    'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
  'atlas_roadsPathClasses--road=track': 'Wald- / Feldweg',
  'atlas_roadsPathClasses--road=unclassified': 'Nebenstraße mit Verbindungscharakter',
  'atlas_roadsPathClasses--road=unspecified_road': 'Unkategorisierte Straße',
  'atlas_roadsPathClasses--route_relations--key': 'Routen',
  'atlas_roadsPathClasses--smoothness_confidence--key': 'Konfidenz Ober&shy;flächen&shy;qualität',
  'atlas_roadsPathClasses--smoothness_confidence=high': 'Hoch',
  'atlas_roadsPathClasses--smoothness_confidence=medium': 'Mittel',
  'atlas_roadsPathClasses--smoothness_source--key': 'Herkunft der Ober&shy;flächen&shy;qualität',
  'atlas_roadsPathClasses--smoothness_source=mtb:scale_to_smoothness': 'Abgeleitet von `mtb:scale`',
  'atlas_roadsPathClasses--smoothness_source=surface_to_smoothness': 'Abgeleitet von `surface`',
  'atlas_roadsPathClasses--smoothness_source=tag': 'OSM-Tag `smoothness`',
  'atlas_roadsPathClasses--smoothness_source=tag_normalized': 'OSM-Tag `smoothness` (normalisiert)',
  'atlas_roadsPathClasses--smoothness_source=tracktype_to_smoothness': 'Abgeleitet von `tracktype`',
  'atlas_roadsPathClasses--smoothness--key': 'Ober&shy;flächen&shy;qualität',
  'atlas_roadsPathClasses--smoothness=bad': 'Schlecht',
  'atlas_roadsPathClasses--smoothness=excellent': 'Sehr gut',
  'atlas_roadsPathClasses--smoothness=good': 'Gut',
  'atlas_roadsPathClasses--smoothness=intermediate': 'Mittel gut',
  'atlas_roadsPathClasses--smoothness=very_bad': 'Sehr schlecht',
  'atlas_roadsPathClasses--surface_color--key': 'Ober&shy;flächen&shy;farbe',
  'atlas_roadsPathClasses--surface_color=green': 'Grün',
  'atlas_roadsPathClasses--surface_color=no': 'Keine besondere Farbe',
  'atlas_roadsPathClasses--surface_color=red': 'Rot',
  'atlas_roadsPathClasses--surface_color=red;green': 'Rot und Grün',
  'atlas_roadsPathClasses--surface_confidence--key': 'Konfidenz der Oberfläche',
  'atlas_roadsPathClasses--surface_confidence=high': 'Hoch',
  'atlas_roadsPathClasses--surface_confidence=low': 'Niedrig',
  'atlas_roadsPathClasses--surface_confidence=medium': 'Mittel',
  'atlas_roadsPathClasses--surface_source--key': 'Herkunft der Oberfläche',
  'atlas_roadsPathClasses--surface_source=parent_highway_tag': 'Von zugeordneter Straße (OSM)',
  'atlas_roadsPathClasses--surface_source=parent_highway_tag_transformed':
    'Von zugeordneter Straße, normalisiert',
  'atlas_roadsPathClasses--surface_source=tag': 'Explizite Angabe aus OSM',
  'atlas_roadsPathClasses--surface_source=tag_transformed': 'Aus OSM-Tag normalisiert',
  'atlas_roadsPathClasses--surface--key': 'Oberfläche',
  'atlas_roadsPathClasses--surface=asphalt': 'Asphalt',
  'atlas_roadsPathClasses--surface=bricks': 'Ziegel',
  'atlas_roadsPathClasses--surface=compacted': 'Verdichteter Untergrund',
  'atlas_roadsPathClasses--surface=concrete': 'Beton',
  'atlas_roadsPathClasses--surface=concrete:lanes': 'Betonstreifen / -bahnen',
  'atlas_roadsPathClasses--surface=concrete:plates': 'Betonplatten',
  'atlas_roadsPathClasses--surface=fine_gravel': 'Splitt',
  'atlas_roadsPathClasses--surface=grass': 'Gras',
  'atlas_roadsPathClasses--surface=grass_paver': 'Rasengitter / Grasgitter',
  'atlas_roadsPathClasses--surface=gravel': 'Schotter',
  'atlas_roadsPathClasses--surface=ground': 'Erde/Boden',
  'atlas_roadsPathClasses--surface=large_sett': 'Großpflaster',
  'atlas_roadsPathClasses--surface=metal': 'Metall',
  'atlas_roadsPathClasses--surface=metal_grid': 'Metallgitter',
  'atlas_roadsPathClasses--surface=mosaic_sett': 'Mosaikpflaster',
  'atlas_roadsPathClasses--surface=paved': 'Befestigt (unspezifisch)',
  'atlas_roadsPathClasses--surface=paving_stones': 'Verbund&shy;pflastersteine',
  'atlas_roadsPathClasses--surface=paving_stones:lanes': 'Pflasterstein&shy;bahnen',
  'atlas_roadsPathClasses--surface=pebblestone': 'Kieselsteine',
  'atlas_roadsPathClasses--surface=plastic': 'Kunststoff',
  'atlas_roadsPathClasses--surface=rubber': 'Gummi',
  'atlas_roadsPathClasses--surface=sand': 'Sand',
  'atlas_roadsPathClasses--surface=sett': 'Behauenes Pflaster / Natursteinpflaster',
  'atlas_roadsPathClasses--surface=small_sett': 'Kleinpflaster',
  'atlas_roadsPathClasses--surface=stone': 'Stein',
  'atlas_roadsPathClasses--surface=unpaved': 'Unbefestigt',
  'atlas_roadsPathClasses--surface=wood': 'Holz',
  'atlas_roadsPathClasses--surface=woodchips': 'Hackschnitzel',
  'atlas_roadsPathClasses--title': 'Daten zu Wegen',
  'atlas_roadsPathClasses--todos--key': 'Todo-Liste',
  'atlas_roadsPathClasses--traffic_sign--key': 'Beschilderung',
  'atlas_roadsPathClasses--traffic_sign=none': 'Unbeschildert',
  'atlas_roadsPathClasses--width_source--key': 'Quelle Breite',
  'atlas_roadsPathClasses--width_source=ALKIS': 'Aus ALKIS Daten ausgemessen',
  'atlas_roadsPathClasses--width_source=ARCore':
    'Mit dem Handy-Metermaß von StreetComplete gemessen',
  'atlas_roadsPathClasses--width--key': 'Breite',
  'atlas_todos_lines--length--key': 'Länge',
  'atlas_todos_lines--source_table--key': 'Quelle',
  'atlas_todos_lines--source_table=bikelanes': 'Radinfrastruktur',
  'atlas_todos_lines--source_table=roads': 'Straßen',
  'atlas_todos_lines--title': 'Kampagnen',
  'atlas_todos_lines--todos--key': 'Todo-Liste',
  'atlas_trafficSigns--description--key': 'Beschreibung',
  'atlas_trafficSigns--direction_source--key': 'Herkunft der Ausrichtung',
  'atlas_trafficSigns--direction_source=tag_cardinal': 'Aus OSM-Tag als Himmelsrichtung',
  'atlas_trafficSigns--direction_source=tag_degrees': 'Aus OSM-Tag als Winkel',
  'atlas_trafficSigns--direction--key': 'Ausrichtung',
  'atlas_trafficSigns--mapillary--key': 'Straßenfotos (Mapillary)',
  'atlas_trafficSigns--offset--key': 'Offset entlang der Linie',
  'atlas_trafficSigns--osm_direction--key': 'OSM `direction`',
  'atlas_trafficSigns--osm_traffic_sign:backward--key': 'OSM `traffic_sign:backward`',
  'atlas_trafficSigns--osm_traffic_sign:both--key': 'OSM `traffic_sign:both`',
  'atlas_trafficSigns--osm_traffic_sign:direction--key': 'OSM `traffic_sign:direction`',
  'atlas_trafficSigns--osm_traffic_sign:forward--key': 'OSM `traffic_sign:forward`',
  'atlas_trafficSigns--title': 'Beschilderung',
  'atlas_trafficSigns--traffic_sign--key': 'Verkehrszeichen',
  'tilda_highwayAreas--area--key': 'Fläche',
  'tilda_highwayAreas--bridge--key': 'Brücke',
  'tilda_highwayAreas--bridge=yes': 'Ja',
  'tilda_highwayAreas--covered--key': 'Überdacht',
  'tilda_highwayAreas--covered=covered': 'Überdacht',
  'tilda_highwayAreas--covered=covered--description':
    'Vollständig überdachte Wege (`covered=yes`) und Arkaden (`covered=arcade`, zur Seite hin offen).',
  'tilda_highwayAreas--covered=indoor': 'In einem Gebäude',
  'tilda_highwayAreas--covered=partial': 'Teilweise überdacht',
  'tilda_highwayAreas--description--key': 'Hinweis aus OSM',
  'tilda_highwayAreas--informal--key': 'Trampelpfad',
  'tilda_highwayAreas--informal=yes': 'Weg als informeller Weg erfasst',
  'tilda_highwayAreas--lifecycle--key': 'Status',
  'tilda_highwayAreas--lifecycle=blocked': 'Gesperrt (Sperrung)',
  'tilda_highwayAreas--lifecycle=construction': 'In Bau',
  'tilda_highwayAreas--lifecycle=construction_no_access': 'Gesperrt aufgrund einer Baustelle',
  'tilda_highwayAreas--lifecycle=temporary': 'Temporärer Weg',
  'tilda_highwayAreas--lit--key': 'Beleuchtung',
  'tilda_highwayAreas--lit=no': 'Nicht beleuchtet',
  'tilda_highwayAreas--lit=special': 'Spezielle Angaben',
  'tilda_highwayAreas--lit=yes': 'Beleuchtet',
  'tilda_highwayAreas--mapillary_backward--key': 'Mapillary gegen Linienrichtung',
  'tilda_highwayAreas--mapillary_coverage--key': 'Mapillary-Abdeckung',
  'tilda_highwayAreas--mapillary_coverage=pano': 'Panorama-Aufnahmen',
  'tilda_highwayAreas--mapillary_coverage=regular': 'Standard-Aufnahmen',
  'tilda_highwayAreas--mapillary_forward--key': 'Mapillary in Linienrichtung',
  'tilda_highwayAreas--mapillary_traffic_sign--key': 'Mapillary für Verkehrszeichen',
  'tilda_highwayAreas--mapillary--key': 'Straßenfotos (Mapillary)',
  'tilda_highwayAreas--name--key': 'Name',
  'tilda_highwayAreas--oneway_bicycle--key': 'Verkehrsrichtung Fahrrad',
  'tilda_highwayAreas--oneway_bicycle=no': 'Beide Richtungen für Radverkehr',
  'tilda_highwayAreas--oneway_bicycle=yes': 'Eine Richtung (auch für Radverkehr)',
  'tilda_highwayAreas--oneway--key': 'Verkehrsrichtung',
  'tilda_highwayAreas--oneway=no': 'Beide Richtungen',
  'tilda_highwayAreas--oneway=yes': 'Einbahnstraße',
  'tilda_highwayAreas--oneway=yes_dual_carriageway':
    'Einbahnstraße da separate Geometrie pro Seite',
  'tilda_highwayAreas--operator_type--key': 'Betreibertyp',
  'tilda_highwayAreas--operator_type=private': 'Privat',
  'tilda_highwayAreas--operator_type=public': 'Öffentlich',
  'tilda_highwayAreas--road--key': 'Straßentyp',
  'tilda_highwayAreas--road=bicycle_road': 'Fahrradstraße',
  'tilda_highwayAreas--road=construction': 'Straße ist in Bau',
  'tilda_highwayAreas--road=cycleway': 'Radweg',
  'tilda_highwayAreas--road=cycleway_crossing': 'Straßenquerung (Radweg)',
  'tilda_highwayAreas--road=footway': 'Fußweg',
  'tilda_highwayAreas--road=footway_crossing': 'Straßenquerung (Fußweg)',
  'tilda_highwayAreas--road=footway_cycleway_crossing': 'Straßenquerung (Fuß- und Radweg)',
  'tilda_highwayAreas--road=footway_sidewalk': 'Gehweg',
  'tilda_highwayAreas--road=footway_steps': 'Treppe',
  'tilda_highwayAreas--road=living_street': 'Verkehrsberuhigter Bereich',
  'tilda_highwayAreas--road=motorway': 'Autobahn',
  'tilda_highwayAreas--road=motorway_link': 'Zufahrt einer Autobahn',
  'tilda_highwayAreas--road=path': 'Weg / Pfad',
  'tilda_highwayAreas--road=pedestrian': 'Fußgängerzone',
  'tilda_highwayAreas--road=primary': 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'tilda_highwayAreas--road=primary_link':
    'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'tilda_highwayAreas--road=residential': 'Anwohnerstraße',
  'tilda_highwayAreas--road=residential_priority_road': 'residential_priority_road',
  'tilda_highwayAreas--road=secondary': 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
  'tilda_highwayAreas--road=secondary_link':
    'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
  'tilda_highwayAreas--road=service_alley': 'Gasse',
  'tilda_highwayAreas--road=service_driveway': 'Grundstückszufahrt',
  'tilda_highwayAreas--road=service_emergency_access': 'Rettungsweg',
  'tilda_highwayAreas--road=service_parking_aisle': 'Parkplatzweg',
  'tilda_highwayAreas--road=service_road': 'Zufahrtsweg',
  'tilda_highwayAreas--road=service_uncategorized': 'Zufahrtsweg (unbekannte Klassifizierung)',
  'tilda_highwayAreas--road=tertiary': 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
  'tilda_highwayAreas--road=tertiary_link':
    'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
  'tilda_highwayAreas--road=track': 'Wald- / Feldweg',
  'tilda_highwayAreas--road=unclassified': 'Nebenstraße mit Verbindungscharakter',
  'tilda_highwayAreas--road=unspecified_road': 'Unkategorisierte Straße',
  'tilda_highwayAreas--smoothness_confidence--key': 'Konfidenz Ober&shy;flächen&shy;qualität',
  'tilda_highwayAreas--smoothness_confidence=high': 'Hoch',
  'tilda_highwayAreas--smoothness_confidence=medium': 'Mittel',
  'tilda_highwayAreas--smoothness_source--key': 'Herkunft der Ober&shy;flächen&shy;qualität',
  'tilda_highwayAreas--smoothness_source=mtb:scale_to_smoothness': 'Abgeleitet von `mtb:scale`',
  'tilda_highwayAreas--smoothness_source=surface_to_smoothness': 'Abgeleitet von `surface`',
  'tilda_highwayAreas--smoothness_source=tag': 'OSM-Tag `smoothness`',
  'tilda_highwayAreas--smoothness_source=tag_normalized': 'OSM-Tag `smoothness` (normalisiert)',
  'tilda_highwayAreas--smoothness_source=tracktype_to_smoothness': 'Abgeleitet von `tracktype`',
  'tilda_highwayAreas--smoothness--key': 'Ober&shy;flächen&shy;qualität',
  'tilda_highwayAreas--smoothness=bad': 'Schlecht',
  'tilda_highwayAreas--smoothness=excellent': 'Sehr gut',
  'tilda_highwayAreas--smoothness=good': 'Gut',
  'tilda_highwayAreas--smoothness=intermediate': 'Mittel gut',
  'tilda_highwayAreas--smoothness=very_bad': 'Sehr schlecht',
  'tilda_highwayAreas--surface_confidence--key': 'Konfidenz der Oberfläche',
  'tilda_highwayAreas--surface_confidence=high': 'Hoch',
  'tilda_highwayAreas--surface_confidence=low': 'Niedrig',
  'tilda_highwayAreas--surface_confidence=medium': 'Mittel',
  'tilda_highwayAreas--surface_source--key': 'Herkunft der Oberfläche',
  'tilda_highwayAreas--surface_source=parent_highway_tag': 'Von zugeordneter Straße (OSM)',
  'tilda_highwayAreas--surface_source=parent_highway_tag_transformed':
    'Von zugeordneter Straße, normalisiert',
  'tilda_highwayAreas--surface_source=tag': 'Explizite Angabe aus OSM',
  'tilda_highwayAreas--surface_source=tag_transformed': 'Aus OSM-Tag normalisiert',
  'tilda_highwayAreas--surface--key': 'Oberfläche',
  'tilda_highwayAreas--surface=asphalt': 'Asphalt',
  'tilda_highwayAreas--surface=bricks': 'Ziegel',
  'tilda_highwayAreas--surface=compacted': 'Verdichteter Untergrund',
  'tilda_highwayAreas--surface=concrete': 'Beton',
  'tilda_highwayAreas--surface=concrete:lanes': 'Betonstreifen / -bahnen',
  'tilda_highwayAreas--surface=concrete:plates': 'Betonplatten',
  'tilda_highwayAreas--surface=fine_gravel': 'Splitt',
  'tilda_highwayAreas--surface=grass': 'Gras',
  'tilda_highwayAreas--surface=grass_paver': 'Rasengitter / Grasgitter',
  'tilda_highwayAreas--surface=gravel': 'Schotter',
  'tilda_highwayAreas--surface=ground': 'Erde/Boden',
  'tilda_highwayAreas--surface=large_sett': 'Großpflaster',
  'tilda_highwayAreas--surface=metal': 'Metall',
  'tilda_highwayAreas--surface=metal_grid': 'Metallgitter',
  'tilda_highwayAreas--surface=mosaic_sett': 'Mosaikpflaster',
  'tilda_highwayAreas--surface=paved': 'Befestigt (unspezifisch)',
  'tilda_highwayAreas--surface=paving_stones': 'Verbund&shy;pflastersteine',
  'tilda_highwayAreas--surface=paving_stones:lanes': 'Pflasterstein&shy;bahnen',
  'tilda_highwayAreas--surface=pebblestone': 'Kieselsteine',
  'tilda_highwayAreas--surface=plastic': 'Kunststoff',
  'tilda_highwayAreas--surface=rubber': 'Gummi',
  'tilda_highwayAreas--surface=sand': 'Sand',
  'tilda_highwayAreas--surface=sett': 'Behauenes Pflaster / Natursteinpflaster',
  'tilda_highwayAreas--surface=small_sett': 'Kleinpflaster',
  'tilda_highwayAreas--surface=stone': 'Stein',
  'tilda_highwayAreas--surface=unpaved': 'Unbefestigt',
  'tilda_highwayAreas--surface=wood': 'Holz',
  'tilda_highwayAreas--surface=woodchips': 'Hackschnitzel',
  'tilda_highwayAreas--title': 'Daten zu Straßenflächen',
  'tilda_highwayAreas--traffic_sign--key': 'Beschilderung',
  'tilda_highwayAreas--traffic_sign=none': 'Unbeschildert',
  'tilda_highwayAreas--tunnel--key': 'Tunnel',
  'tilda_highwayAreas--tunnel=yes': 'Ja',
  'tilda_highwayAreas--tunnel=yes--description':
    'Wege mit `tunnel=yes` und Gebäudedurchgänge mit `tunnel=building_passage`.',
  'tilda_highwayAreas--width_source--key': 'Quelle Breite',
  'tilda_highwayAreas--width_source=ALKIS': 'Aus ALKIS Daten ausgemessen',
  'tilda_highwayAreas--width_source=ARCore': 'Mit dem Handy-Metermaß von StreetComplete gemessen',
  'tilda_highwayAreas--width--key': 'Breite',
  'tilda_parkings_cutouts--amenity--key': 'OSM-Kategorie "amenity"',
  'tilda_parkings_cutouts--barrier--key': 'OSM-Kategorie "barrier"',
  'tilda_parkings_cutouts--buffer_radius--key': 'Radius der Stanzung',
  'tilda_parkings_cutouts--capacity--key': 'Kapazität (OSM / Zwischenwert)',
  'tilda_parkings_cutouts--capacity:cargo_bike--key': 'Kapazität Lastenrad (OSM)',
  'tilda_parkings_cutouts--category--key': 'Stanzungen',
  'tilda_parkings_cutouts--category=advertising': 'Werbeträger',
  'tilda_parkings_cutouts--category=barrier': 'Barriere',
  'tilda_parkings_cutouts--category=bicycle_parking': 'Fahrradparkplatz',
  'tilda_parkings_cutouts--category=bicycle_rental': 'Fahrradverleih',
  'tilda_parkings_cutouts--category=bollard': 'Poller',
  'tilda_parkings_cutouts--category=bus_stop': 'Bushaltestelle',
  'tilda_parkings_cutouts--category=bus_stop_centerline': 'Bushaltestelle (Mittellinie)',
  'tilda_parkings_cutouts--category=bus_stop_conditional':
    'Bushaltestelle mit zeitlichen Einschränkungen (Nachtbusse, Schulbusse)',
  'tilda_parkings_cutouts--category=bus_stop_kerb': 'Bushaltestelle (Bordstein)',
  'tilda_parkings_cutouts--category=collision_protection': 'Baumschutzbügel',
  'tilda_parkings_cutouts--category=crossing_buffer_marking':
    'Markierung (Sperrfläche u.ä.) an Querungsstelle',
  'tilda_parkings_cutouts--category=crossing_continuous': 'Durchgängige Querung',
  'tilda_parkings_cutouts--category=crossing_kerb_extension':
    'Gehwegvorstreckung an Querungsstelle',
  'tilda_parkings_cutouts--category=crossing_marked': 'Markierte Querungsstelle',
  'tilda_parkings_cutouts--category=crossing_traffic_signals': 'Ampelquerung',
  'tilda_parkings_cutouts--category=crossing_zebra': 'Fußgängerüberweg (Zebrastreifen)',
  'tilda_parkings_cutouts--category=driveway': 'Einfahrt',
  'tilda_parkings_cutouts--category=driveway_corner_kerb':
    'Implizites Halteverbot am Beginn einer Einfahrt',
  'tilda_parkings_cutouts--category=fire_hydrant': 'Hydrant',
  'tilda_parkings_cutouts--category=intersection_corner': 'Implizites Halteverbot an Straßenecke',
  'tilda_parkings_cutouts--category=kerb_extension': 'Gehwegvorstreckung',
  'tilda_parkings_cutouts--category=kerb_lowered': 'Abgesenkter Bordstein',
  'tilda_parkings_cutouts--category=loading_ramp': 'Transportüberweg',
  'tilda_parkings_cutouts--category=mobility_hub': 'Mobilitätsstation',
  'tilda_parkings_cutouts--category=motorcycle_parking': 'Motorradparkplatz',
  'tilda_parkings_cutouts--category=other': 'Sonstiges Hindernis',
  'tilda_parkings_cutouts--category=parklet': 'Parklet',
  'tilda_parkings_cutouts--category=recycling': 'Recyclingstation',
  'tilda_parkings_cutouts--category=road_marking_restricted_area': 'Sperrfläche (Markierung)',
  'tilda_parkings_cutouts--category=small_electric_vehicle_parking':
    'Abstellfläche für Elektrokleinstfahrzeuge',
  'tilda_parkings_cutouts--category=street_cabinet': 'Schaltkasten, Straßenkasten, u.ä.',
  'tilda_parkings_cutouts--category=street_lamp': 'Straßenlaterne',
  'tilda_parkings_cutouts--category=traffic_calming_choker': 'Angelegte Fahrbahnverengung',
  'tilda_parkings_cutouts--category=traffic_sign': 'Verkehrszeichen',
  'tilda_parkings_cutouts--category=tram_stop': 'Straßenbahnhaltestelle',
  'tilda_parkings_cutouts--category=tree': 'Baum',
  'tilda_parkings_cutouts--category=tree_pit': 'Baumscheibe',
  'tilda_parkings_cutouts--category=vending_parking_tickets': 'Parkscheinautomat',
  'tilda_parkings_cutouts--category=water_well': 'Straßenbrunnen / Wasserstelle',
  'tilda_parkings_cutouts--direction--key': 'Richtung (OSM)',
  'tilda_parkings_cutouts--emergency--key': 'OSM-Kategorie "emergency"',
  'tilda_parkings_cutouts--geom_sources--key': 'Geometrie-Quellen',
  'tilda_parkings_cutouts--geometry_source--key': 'Geometrieherkunft',
  'tilda_parkings_cutouts--kerb--key': 'Bordstein (OSM-Kategorie "kerb")',
  'tilda_parkings_cutouts--landuse--key': 'Flächennutzung (OSM-Kategorie "landuse")',
  'tilda_parkings_cutouts--man_made--key': 'Künstliche Objekte (OSM-Kategorie "man_made")',
  'tilda_parkings_cutouts--name--key': 'Name (OSM)',
  'tilda_parkings_cutouts--natural--key': 'Natur (OSM-Kategorie "natural")',
  'tilda_parkings_cutouts--no_cutout_for_restrictions--key':
    'Gilt nicht bei Park-/Halteverbot entlang der Linie',
  'tilda_parkings_cutouts--no_cutout_for_restrictions=true':
    'Ja (Stanzung wird bei echten Verbotssegmenten nicht angewendet)',
  'tilda_parkings_cutouts--operator--key': 'Betreiber (OSM)',
  'tilda_parkings_cutouts--radius--key': 'Pufferradius',
  'tilda_parkings_cutouts--ref--key': 'Referenz (OSM-Kategorie "ref")',
  'tilda_parkings_cutouts--road--key': 'Fahrbahn-Referenz (Einfahrt)',
  'tilda_parkings_cutouts--separate_parking--key': 'Separater Parkplatz (OSM-Bezug)',
  'tilda_parkings_cutouts--side--key': 'Seite relativ zur Fahrbahn',
  'tilda_parkings_cutouts--side=left': 'Links',
  'tilda_parkings_cutouts--side=platform': 'Bahnsteig / ohne Kerb-Seite',
  'tilda_parkings_cutouts--side=right': 'Rechts',
  'tilda_parkings_cutouts--source--key': 'Datenquelle',
  'tilda_parkings_cutouts--source=crossing': 'Überwege',
  'tilda_parkings_cutouts--source=driveway_corner_kerbs':
    'Implizites Halteverbot am Beginn einer Einfahrt',
  'tilda_parkings_cutouts--source=driveways': 'Einfahrten',
  'tilda_parkings_cutouts--source=external_cutouts_euvm': 'Externe Hindernisdaten (eUVM)',
  'tilda_parkings_cutouts--source=intersections': 'Kreuzungen',
  'tilda_parkings_cutouts--source=obstacle_areas': 'Flächige Hindernisse',
  'tilda_parkings_cutouts--source=obstacle_lines': 'Linienhafte Hindernisse',
  'tilda_parkings_cutouts--source=obstacle_points': 'Punktuelle Hindernisse',
  'tilda_parkings_cutouts--source=public_transport_stops': 'ÖPNV-Haltestellen',
  'tilda_parkings_cutouts--source=separate_parking_areas':
    'Parkplätze die separat als Fläche erfasst sind',
  'tilda_parkings_cutouts--source=separate_parking_points':
    'Parkplätze die separat als Punkt erfasst sind',
  'tilda_parkings_cutouts--street:name--key': 'Straßenname (Einfahrt)',
  'tilda_parkings_cutouts--tag_sources--key': 'Tag-Quellen',
  'tilda_parkings_cutouts--title': 'Parkraumstanzungen',
  'tilda_parkings_cutouts--traffic_calming--key':
    'Verkehrsberuhigung (OSM-Kategorie "traffic_calming")',
  'tilda_parkings_cutouts--width--key': 'Breite',
  'tilda_parkings_no--_staggered_maneuvering_loss--key':
    '(Intern) Manövrierraumverlust (alternierendes Parken)',
  'tilda_parkings_no--_staggered_original_capacity--key':
    '(Intern) Ursprüngliche Kapazität (vor Staggered-Anpassung)',
  'tilda_parkings_no--access--key': 'Zugang',
  'tilda_parkings_no--access=customers': 'Kund:innen',
  'tilda_parkings_no--access=delivery': 'Lieferverkehr',
  'tilda_parkings_no--access=destination': 'Anlieger frei (Nicht-Durchgangsverkehr erlaubt)',
  'tilda_parkings_no--access=employees': 'Mitarbeiter',
  'tilda_parkings_no--access=no': 'Kein Zugang',
  'tilda_parkings_no--access=permissive': 'Öffentliche Nutzung geduldet',
  'tilda_parkings_no--access=permit': 'Mit Genehmigung',
  'tilda_parkings_no--access=private': 'Privat',
  'tilda_parkings_no--access=public': 'Öffentlich (explizit)',
  'tilda_parkings_no--access=residents': 'Nur mit Bewohnerparkausweis',
  'tilda_parkings_no--area_confidence--key': 'Konfidenz der Flächenangabe',
  'tilda_parkings_no--area_confidence=high': 'Hoch',
  'tilda_parkings_no--area_confidence=low': 'Niedrig',
  'tilda_parkings_no--area_confidence=medium': 'Mittel',
  'tilda_parkings_no--area_source--key': 'Herkunft der Flächenangabe',
  'tilda_parkings_no--area_source=estimated':
    'Berechnet auf Basis der Länge der Liniengeometrie und Fahrzeugausrichtung.',
  'tilda_parkings_no--area_source=geometry': 'Basiert auf dem Flächeninhalt der Geometrie aus OSM.',
  'tilda_parkings_no--area--key': 'Fläche',
  'tilda_parkings_no--capacity_confidence--key': 'Konfidenz der Stellplatzanzahl',
  'tilda_parkings_no--capacity_confidence=high': 'Hoch',
  'tilda_parkings_no--capacity_confidence=low': 'Niedrig',
  'tilda_parkings_no--capacity_confidence=medium': 'Mittel',
  'tilda_parkings_no--capacity_source--key': 'Herkunft der Stellplatzanzahl',
  'tilda_parkings_no--capacity_source=area_and_orientation_diagonal':
    'Berechnet auf Basis der Fläche und Parkausrichtung.',
  'tilda_parkings_no--capacity_source=area_and_orientation_diagonal_redistributed':
    'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings_no--capacity_source=area_and_orientation_fallback_parallel':
    'Berechnet auf Basis der Fläche und Parkausrichtung. Allerdings war die Parkausrichtung unbekannt, so dass Parallelparken angenommen wurde.',
  'tilda_parkings_no--capacity_source=area_and_orientation_parallel':
    'Berechnet auf Basis der Fläche und Parkausrichtung.',
  'tilda_parkings_no--capacity_source=area_and_orientation_parallel_redistributed':
    'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings_no--capacity_source=area_and_orientation_perpendicular':
    'Berechnet auf Basis der Fläche und Parkausrichtung.',
  'tilda_parkings_no--capacity_source=area_and_orientation_perpendicular_redistributed':
    'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings_no--capacity_source=assumed_default':
    'Keine explizite Angabe vorgefunden; dieser Wert ist eine Annahme.',
  'tilda_parkings_no--capacity_source=estimated': 'Berechnung',
  'tilda_parkings_no--capacity_source=estimated_from_area':
    'Berechnet auf Basis der Fläche und Ausrichtung.',
  'tilda_parkings_no--capacity_source=estimated_from_length':
    'Berechnet auf Basis der Linien-Länge und Ausrichtung.',
  'tilda_parkings_no--capacity_source=estimated_redistributed': 'Geschätzt, Kapazität umverteilt',
  'tilda_parkings_no--capacity_source=tag': 'Explizite Angabe aus OSM.',
  'tilda_parkings_no--capacity_source=tag_estimation': 'Explizite Angabe einer Schätzung aus OSM.',
  'tilda_parkings_no--capacity_source=tag_estimation_redistributed':
    'Explizite Angabe einer Schätzung aus OSM, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings_no--capacity_source=tag_redistributed':
    'Explizite Angabe aus OSM, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings_no--capacity--key': 'Stellplatzanzahl',
  'tilda_parkings_no--condition_category_primary--key': 'Primäre Parkbeschränkung',
  'tilda_parkings_no--condition_category_primary=access_restriction': 'Zugangsbeschränkung',
  'tilda_parkings_no--condition_category_primary=assumed_free':
    'Wahrscheinlich keine Parkbeschränkungen',
  'tilda_parkings_no--condition_category_primary=assumed_private': 'Sehr wahrscheinlich privat',
  'tilda_parkings_no--condition_category_primary=bus_lane': 'Bussonderfahrstreifen',
  'tilda_parkings_no--condition_category_primary=car_sharing': 'Nur für Carsharing-Fahrzeuge',
  'tilda_parkings_no--condition_category_primary=charging': 'Laden von Elektrofahrzeugen',
  'tilda_parkings_no--condition_category_primary=default': 'Keine Zuordnung',
  'tilda_parkings_no--condition_category_primary=disabled': 'Behindertenparkplatz',
  'tilda_parkings_no--condition_category_primary=disabled_private':
    'Personenbezogener Behindertenparkplatz',
  'tilda_parkings_no--condition_category_primary=free': 'Keine Parkbeschränkungen',
  'tilda_parkings_no--condition_category_primary=invalid': 'Ungültige Angabe in OSM',
  'tilda_parkings_no--condition_category_primary=invalid--description':
    'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
  'tilda_parkings_no--condition_category_primary=loading': 'Ladezone',
  'tilda_parkings_no--condition_category_primary=maxweight': 'Gewichtsbegrenzung',
  'tilda_parkings_no--condition_category_primary=mixed':
    'Nur mit Parkschein oder Bewohnerparkausweis',
  'tilda_parkings_no--condition_category_primary=no_parking': 'Eingeschränktes Haltverbot',
  'tilda_parkings_no--condition_category_primary=no_standing': 'Nur kurzes Halten erlaubt',
  'tilda_parkings_no--condition_category_primary=no_stopping': 'Absolutes Haltverbot',
  'tilda_parkings_no--condition_category_primary=paid': 'Nur mit Parkschein',
  'tilda_parkings_no--condition_category_primary=private': 'Privat',
  'tilda_parkings_no--condition_category_primary=residents': 'Nur mit Bewohnerparkausweis',
  'tilda_parkings_no--condition_category_primary=taxi': 'Taxenstand',
  'tilda_parkings_no--condition_category_primary=time_limited': 'Höchstparkdauer',
  'tilda_parkings_no--condition_category_primary=unspecified': 'Unbestimmt',
  'tilda_parkings_no--condition_category_primary=vehicle_restriction':
    'Beschränkung auf Fahrzeugklassen',
  'tilda_parkings_no--condition_category--key': 'Parkbeschränkung',
  'tilda_parkings_no--condition_category=access_restriction': 'Zugangsbeschränkung',
  'tilda_parkings_no--condition_category=assumed_free': 'Wahrscheinlich keine Parkbeschränkungen',
  'tilda_parkings_no--condition_category=assumed_private': 'Sehr wahrscheinlich privat',
  'tilda_parkings_no--condition_category=bus_lane': 'Bussonderfahrstreifen',
  'tilda_parkings_no--condition_category=car_sharing': 'Nur für Carsharing-Fahrzeuge',
  'tilda_parkings_no--condition_category=charging': 'Laden von Elektrofahrzeugen',
  'tilda_parkings_no--condition_category=disabled': 'Behindertenparkplatz',
  'tilda_parkings_no--condition_category=disabled_private':
    'Personenbezogener Behindertenparkplatz',
  'tilda_parkings_no--condition_category=free': 'Keine Parkbeschränkungen',
  'tilda_parkings_no--condition_category=invalid': 'Ungültige Angabe in OSM',
  'tilda_parkings_no--condition_category=invalid--description':
    'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
  'tilda_parkings_no--condition_category=loading': 'Ladezone',
  'tilda_parkings_no--condition_category=maxweight': 'Gewichtsbegrenzung',
  'tilda_parkings_no--condition_category=mixed': 'Nur mit Parkschein oder Bewohnerparkausweis',
  'tilda_parkings_no--condition_category=no_parking': 'Eingeschränktes Haltverbot',
  'tilda_parkings_no--condition_category=no_standing': 'Nur kurzes Halten erlaubt',
  'tilda_parkings_no--condition_category=no_stopping': 'Absolutes Haltverbot',
  'tilda_parkings_no--condition_category=paid': 'Nur mit Parkschein',
  'tilda_parkings_no--condition_category=private': 'Privat',
  'tilda_parkings_no--condition_category=residents': 'Nur mit Bewohnerparkausweis',
  'tilda_parkings_no--condition_category=taxi': 'Taxenstand',
  'tilda_parkings_no--condition_category=time_limited': 'Höchstparkdauer',
  'tilda_parkings_no--condition_category=unspecified': 'Unbestimmt',
  'tilda_parkings_no--condition_category=vehicle_restriction': 'Beschränkung auf Fahrzeugklassen',
  'tilda_parkings_no--covered--key': 'Überdacht',
  'tilda_parkings_no--covered=partial': 'Teilweise überdacht',
  'tilda_parkings_no--covered=yes': 'Überdacht',
  'tilda_parkings_no--direction--key': 'Einparkrichtung',
  'tilda_parkings_no--direction=back_in': 'Rückwärts einparken',
  'tilda_parkings_no--direction=head_in': 'Vorwärts einparken',
  'tilda_parkings_no--geom_sources--key': '(Intern) OSM-IDs der Geometrien',
  'tilda_parkings_no--informal--key': 'Duldung',
  'tilda_parkings_no--informal=yes':
    'Parken im rechtlichen Graubereich oder etabliertes, geduldetes Falschparken.',
  'tilda_parkings_no--location--key': 'Lage im Straßenraum',
  'tilda_parkings_no--location=lane_centre': 'Fahrbahnmitte',
  'tilda_parkings_no--location=median': 'Mittelstreifen',
  'tilda_parkings_no--mapillary--key': 'Mapillary',
  'tilda_parkings_no--markings--key': 'Markierungen',
  'tilda_parkings_no--markings=no': 'Ohne Markierungen',
  'tilda_parkings_no--markings=yes': 'Mit Markierungen',
  'tilda_parkings_no--operator_type_confidence--key': 'Konfidenz des Betreibertyps',
  'tilda_parkings_no--operator_type_confidence=high': 'Hoch',
  'tilda_parkings_no--operator_type_confidence=low': 'Niedrig',
  'tilda_parkings_no--operator_type_confidence=medium': 'Mittel',
  'tilda_parkings_no--operator_type_source--key': 'Herkunft des Betreibertyps',
  'tilda_parkings_no--operator_type_source=default_fallback': 'Annahme bei fehlender Angabe.',
  'tilda_parkings_no--operator_type_source=driveway_inference':
    'Annahme bei fehlender Angabe wenn eine Einfahrt erkannt wurde.',
  'tilda_parkings_no--operator_type_source=manual_overwrite_list':
    'Anhand einer manuellen Korrekturliste in TILDA.',
  'tilda_parkings_no--operator_type_source=parent_highway_tag':
    'Explizite Angabe aus OSM an der zugeordneten Straße.',
  'tilda_parkings_no--operator_type_source=tag': 'Explizite Angabe aus OSM.',
  'tilda_parkings_no--operator_type--key': 'Betreibertyp',
  'tilda_parkings_no--operator_type=private': 'Privat',
  'tilda_parkings_no--operator_type=public': 'Öffentlich',
  'tilda_parkings_no--orientation--key': 'Ausrichtung',
  'tilda_parkings_no--orientation=diagonal': 'Schrägparken',
  'tilda_parkings_no--orientation=parallel': 'Parallelparken',
  'tilda_parkings_no--orientation=perpendicular': 'Querparken',
  'tilda_parkings_no--parking--key': 'Parkposition',
  'tilda_parkings_no--parking=half_on_kerb': 'Halb auf dem Gehweg',
  'tilda_parkings_no--parking=lane': 'Auf der Fahrbahn',
  'tilda_parkings_no--parking=missing': 'Daten in OSM fehlen',
  'tilda_parkings_no--parking=no': 'Kein Parken (Sonstiger/Unbekannter Grund)',
  'tilda_parkings_no--parking=no_parking': 'Eingeschränktes Haltverbot',
  'tilda_parkings_no--parking=no_standing': 'Nur kurzes Halten erlaubt',
  'tilda_parkings_no--parking=no_stopping': 'Absolutes Haltverbot',
  'tilda_parkings_no--parking=not_expected': 'Kein Parken zu erwarten',
  'tilda_parkings_no--parking=on_kerb': 'Ganz auf dem Gehweg',
  'tilda_parkings_no--parking=separate': 'Parkraum als separate Geometrie erfasst',
  'tilda_parkings_no--parking=shoulder': 'Auf dem Seitenstreifen',
  'tilda_parkings_no--parking=street_side': 'Parkbucht',
  'tilda_parkings_no--parking=yes': 'Nicht näher bestimmtes Straßenparken',
  'tilda_parkings_no--reason--key': 'Grund',
  'tilda_parkings_no--reason=bus_stop': 'Haltestelle',
  'tilda_parkings_no--reason=capacity_below_zero': 'Abschnitt zu klein für ein Fahrzeug',
  'tilda_parkings_no--reason=cycleway': 'Radverkehrsanlage',
  'tilda_parkings_no--reason=dual_carriage': 'Getrennte Richtungsfahrbahnen',
  'tilda_parkings_no--reason=junction': 'Knotenpunkt / Einmündung',
  'tilda_parkings_no--reason=missing_data': 'Keine Parkraum-Daten in OpenStreetMap erfasst',
  'tilda_parkings_no--reason=narrow': 'Zu schmale Fahrbahn',
  'tilda_parkings_no--reason=parking_tag': 'Explizite Angabe in den Daten',
  'tilda_parkings_no--reason=restriction_no_parking': 'Explizites Parkverbot aus OSM',
  'tilda_parkings_no--reason=restriction_no_standing': 'Eingeschränktes Halteverbot aus OSM',
  'tilda_parkings_no--reason=restriction_no_stopping': 'Explizites Halteverbot aus OSM',
  'tilda_parkings_no--road_name--key': 'Straßenname',
  'tilda_parkings_no--road_oneway--key': 'Einbahnstraße',
  'tilda_parkings_no--road_oneway=no': 'Nein (in beide Richtungen befahrbar)',
  'tilda_parkings_no--road_oneway=yes': 'Einbahnstraße',
  'tilda_parkings_no--road_oneway=yes_dual_carriageway':
    'Einbahnstraße (getrennte Richtungsfahrbahnen)',
  'tilda_parkings_no--road_width_confidence--key': 'Konfidenz der Fahrbahnbreite',
  'tilda_parkings_no--road_width_confidence=high': 'Hoch',
  'tilda_parkings_no--road_width_confidence=low': 'Niedrig',
  'tilda_parkings_no--road_width_confidence=medium': 'Mittel',
  'tilda_parkings_no--road_width_source--key': 'Herkunft der Fahrbahnbreite',
  'tilda_parkings_no--road_width_source=highway_default': 'Standard-Wert für diesen Straßentyp.',
  'tilda_parkings_no--road_width_source=highway_default_and_oneway':
    'Standard-Wert für diesen Straßentyp als Einbahnstraße.',
  'tilda_parkings_no--road_width_source=tag': 'Dieser Wert ist in OSM hinterlegt.',
  'tilda_parkings_no--road_width--key': 'Fahrbahnbreite',
  'tilda_parkings_no--road--key': 'Straßentyp',
  'tilda_parkings_no--road=bicycle_road': 'Fahrradstraße',
  'tilda_parkings_no--road=construction': 'Straße ist in Bau',
  'tilda_parkings_no--road=cycleway': 'Radweg',
  'tilda_parkings_no--road=cycleway_crossing': 'Straßenquerung (Radweg)',
  'tilda_parkings_no--road=footway': 'Fußweg',
  'tilda_parkings_no--road=footway_crossing': 'Straßenquerung (Fußweg)',
  'tilda_parkings_no--road=footway_cycleway_crossing': 'Straßenquerung (Fuß- und Radweg)',
  'tilda_parkings_no--road=footway_sidewalk': 'Gehweg',
  'tilda_parkings_no--road=footway_steps': 'Treppe',
  'tilda_parkings_no--road=living_street': 'Verkehrsberuhigter Bereich',
  'tilda_parkings_no--road=motorway': 'Autobahn',
  'tilda_parkings_no--road=motorway_link': 'Zufahrt einer Autobahn',
  'tilda_parkings_no--road=path': 'Weg / Pfad',
  'tilda_parkings_no--road=pedestrian': 'Fußgängerzone',
  'tilda_parkings_no--road=primary': 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'tilda_parkings_no--road=primary_link':
    'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'tilda_parkings_no--road=residential': 'Anwohnerstraße',
  'tilda_parkings_no--road=residential_priority_road': 'residential_priority_road',
  'tilda_parkings_no--road=secondary': 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
  'tilda_parkings_no--road=secondary_link':
    'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
  'tilda_parkings_no--road=service_alley': 'Gasse',
  'tilda_parkings_no--road=service_driveway': 'Grundstückszufahrt',
  'tilda_parkings_no--road=service_emergency_access': 'Rettungsweg',
  'tilda_parkings_no--road=service_parking_aisle': 'Parkplatzweg',
  'tilda_parkings_no--road=service_road': 'Zufahrtsweg',
  'tilda_parkings_no--road=service_uncategorized': 'Zufahrtsweg (unbekannte Klassifizierung)',
  'tilda_parkings_no--road=tertiary': 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
  'tilda_parkings_no--road=tertiary_link':
    'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
  'tilda_parkings_no--road=track': 'Wald- / Feldweg',
  'tilda_parkings_no--road=unclassified': 'Nebenstraße mit Verbindungscharakter',
  'tilda_parkings_no--road=unspecified_road': 'Unkategorisierte Straße',
  'tilda_parkings_no--side--key': 'Straßenseite',
  'tilda_parkings_no--side=left': 'Links',
  'tilda_parkings_no--side=right': 'Rechts',
  'tilda_parkings_no--source--key': 'Datenquelle',
  'tilda_parkings_no--source=parkings': 'Angaben an der Straßenlinie',
  'tilda_parkings_no--source=separate_parking_areas': 'Separat erfasste Flächendaten',
  'tilda_parkings_no--source=separate_parking_points': 'Separate erfasste Punktdaten',
  'tilda_parkings_no--staggered--key': 'Parkweise',
  'tilda_parkings_no--staggered=no': 'Nicht alternierend',
  'tilda_parkings_no--staggered=yes': 'Alternierendes Parken',
  'tilda_parkings_no--staggered=yes--description':
    'Auf diesem Abschnitt ist die Fahrbahn zu schmal, um auf beiden Seiten gleichzeitig zu parken. Es gibt keine Markierungen oder Schilder, die das Parken regeln. Häufig entwickeln sich örtliche Konventionen, in welchen Bereichen auf welcher Seite geparkt wird. In die Kapazitätsberechnung fließt das ein: Die Kapazität wird um 50% reduziert (da nur eine Seite genutzt werden kann) und zusätzlich wird für jeden 60m-Abschnitt ein Manövrierraumverlust von 10m (≈1,9 Fahrzeugplätze) abgezogen, da beim Seitenwechsel Manövrierraum benötigt wird. Diese Angaben basieren auf Erfahrungswerten und können lediglich eine Schätzung des tatsächlichen Parkgeschehens abbilden.',
  'tilda_parkings_no--surface_confidence--key': 'Konfidenz der Oberfläche',
  'tilda_parkings_no--surface_confidence=high': 'Hoch',
  'tilda_parkings_no--surface_confidence=low': 'Niedrig',
  'tilda_parkings_no--surface_confidence=medium': 'Mittel',
  'tilda_parkings_no--surface_source--key': 'Herkunft der Oberfläche',
  'tilda_parkings_no--surface_source=parent_highway_tag': 'Von zugeordneter Straße (OSM)',
  'tilda_parkings_no--surface_source=parent_highway_tag_transformed':
    'Von zugeordneter Straße, normalisiert',
  'tilda_parkings_no--surface_source=tag': 'Explizite Angabe aus OSM',
  'tilda_parkings_no--surface_source=tag_transformed': 'Aus OSM-Tag normalisiert',
  'tilda_parkings_no--surface--key': 'Oberfläche',
  'tilda_parkings_no--surface=asphalt': 'Asphalt',
  'tilda_parkings_no--surface=bricks': 'Ziegel',
  'tilda_parkings_no--surface=compacted': 'Verdichteter Untergrund',
  'tilda_parkings_no--surface=concrete': 'Beton',
  'tilda_parkings_no--surface=concrete:lanes': 'Betonstreifen / -bahnen',
  'tilda_parkings_no--surface=concrete:plates': 'Betonplatten',
  'tilda_parkings_no--surface=fine_gravel': 'Splitt',
  'tilda_parkings_no--surface=grass': 'Gras',
  'tilda_parkings_no--surface=grass_paver': 'Rasengitter / Grasgitter',
  'tilda_parkings_no--surface=gravel': 'Schotter',
  'tilda_parkings_no--surface=ground': 'Erde/Boden',
  'tilda_parkings_no--surface=large_sett': 'Großpflaster',
  'tilda_parkings_no--surface=metal': 'Metall',
  'tilda_parkings_no--surface=metal_grid': 'Metallgitter',
  'tilda_parkings_no--surface=mosaic_sett': 'Mosaikpflaster',
  'tilda_parkings_no--surface=paved': 'Befestigt (unspezifisch)',
  'tilda_parkings_no--surface=paving_stones': 'Verbund&shy;pflastersteine',
  'tilda_parkings_no--surface=paving_stones:lanes': 'Pflasterstein&shy;bahnen',
  'tilda_parkings_no--surface=pebblestone': 'Kieselsteine',
  'tilda_parkings_no--surface=plastic': 'Kunststoff',
  'tilda_parkings_no--surface=rubber': 'Gummi',
  'tilda_parkings_no--surface=sand': 'Sand',
  'tilda_parkings_no--surface=sett': 'Behauenes Pflaster / Natursteinpflaster',
  'tilda_parkings_no--surface=small_sett': 'Kleinpflaster',
  'tilda_parkings_no--surface=stone': 'Stein',
  'tilda_parkings_no--surface=unpaved': 'Unbefestigt',
  'tilda_parkings_no--surface=wood': 'Holz',
  'tilda_parkings_no--surface=woodchips': 'Hackschnitzel',
  'tilda_parkings_no--tag_sources--key': 'Tag-Quellen',
  'tilda_parkings_no--title': 'Kein Parken',
  'tilda_parkings_no--traffic_sign--key': 'Verkehrszeichen',
  'tilda_parkings_no--zone--key': 'Parkzone',
  'tilda_parkings_off_street--access--key': 'Zugang',
  'tilda_parkings_off_street--access=customers': 'Kund:innen',
  'tilda_parkings_off_street--access=delivery': 'Lieferverkehr',
  'tilda_parkings_off_street--access=destination':
    'Anlieger frei (Nicht-Durchgangsverkehr erlaubt)',
  'tilda_parkings_off_street--access=employees': 'Mitarbeiter',
  'tilda_parkings_off_street--access=no': 'Kein Zugang',
  'tilda_parkings_off_street--access=permissive': 'Öffentliche Nutzung geduldet',
  'tilda_parkings_off_street--access=permit': 'Mit Genehmigung',
  'tilda_parkings_off_street--access=private': 'Privat',
  'tilda_parkings_off_street--access=public': 'Öffentlich (explizit)',
  'tilda_parkings_off_street--access=residents': 'Nur mit Bewohnerparkausweis',
  'tilda_parkings_off_street--amenity--key': 'Einrichtung',
  'tilda_parkings_off_street--amenity=parking': 'Parkplatz',
  'tilda_parkings_off_street--area_confidence--key': 'Konfidenz der Flächenangabe',
  'tilda_parkings_off_street--area_confidence=high': 'Hoch',
  'tilda_parkings_off_street--area_confidence=low': 'Niedrig',
  'tilda_parkings_off_street--area_confidence=medium': 'Mittel',
  'tilda_parkings_off_street--area_source--key': 'Herkunft der Flächenangabe',
  'tilda_parkings_off_street--area_source=estimated':
    'Berechnet auf Basis der Länge der Liniengeometrie und Fahrzeugausrichtung.',
  'tilda_parkings_off_street--area_source=geometry':
    'Basiert auf dem Flächeninhalt der Geometrie aus OSM.',
  'tilda_parkings_off_street--area--key': 'Fläche',
  'tilda_parkings_off_street--capacity_confidence--key': 'Konfidenz der Stellplatzanzahl',
  'tilda_parkings_off_street--capacity_confidence=high': 'Hoch',
  'tilda_parkings_off_street--capacity_confidence=low': 'Niedrig',
  'tilda_parkings_off_street--capacity_confidence=medium': 'Mittel',
  'tilda_parkings_off_street--capacity_source--key': 'Herkunft der Stellplatzanzahl',
  'tilda_parkings_off_street--capacity_source=area': 'Berechnet auf Basis der Fläche.',
  'tilda_parkings_off_street--capacity_source=area_and_orientation_diagonal':
    'Berechnet auf Basis der Fläche und Parkausrichtung.',
  'tilda_parkings_off_street--capacity_source=area_and_orientation_diagonal_redistributed':
    'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings_off_street--capacity_source=area_and_orientation_fallback_parallel':
    'Berechnet auf Basis der Fläche und Parkausrichtung. Allerdings war die Parkausrichtung unbekannt, so dass Parallelparken angenommen wurde.',
  'tilda_parkings_off_street--capacity_source=area_and_orientation_parallel':
    'Berechnet auf Basis der Fläche und Parkausrichtung.',
  'tilda_parkings_off_street--capacity_source=area_and_orientation_parallel_redistributed':
    'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings_off_street--capacity_source=area_and_orientation_perpendicular':
    'Berechnet auf Basis der Fläche und Parkausrichtung.',
  'tilda_parkings_off_street--capacity_source=area_and_orientation_perpendicular_redistributed':
    'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings_off_street--capacity_source=assumed_default':
    'Keine explizite Angabe vorgefunden; dieser Wert ist eine Annahme.',
  'tilda_parkings_off_street--capacity_source=estimated': 'Berechnung',
  'tilda_parkings_off_street--capacity_source=estimated_from_area':
    'Berechnet auf Basis der Fläche und Ausrichtung.',
  'tilda_parkings_off_street--capacity_source=estimated_from_length':
    'Berechnet auf Basis der Linien-Länge und Ausrichtung.',
  'tilda_parkings_off_street--capacity_source=estimated_redistributed':
    'Geschätzt, Kapazität umverteilt',
  'tilda_parkings_off_street--capacity_source=tag': 'Explizite Angabe aus OSM.',
  'tilda_parkings_off_street--capacity_source=tag_estimation':
    'Explizite Angabe einer Schätzung aus OSM.',
  'tilda_parkings_off_street--capacity_source=tag_estimation_redistributed':
    'Explizite Angabe einer Schätzung aus OSM, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings_off_street--capacity_source=tag_redistributed':
    'Explizite Angabe aus OSM, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings_off_street--capacity--key': 'Stellplatzanzahl',
  'tilda_parkings_off_street--category--key': 'Kategorie',
  'tilda_parkings_off_street--category=carport': 'Carport',
  'tilda_parkings_off_street--category=garage': 'Garage',
  'tilda_parkings_off_street--category=multi-storey': 'Parkhaus',
  'tilda_parkings_off_street--category=outside': 'Außenparkplatz',
  'tilda_parkings_off_street--category=underground': 'Tiefgarage',
  'tilda_parkings_off_street--condition_category_primary--key': 'Primäre Parkbeschränkung',
  'tilda_parkings_off_street--condition_category_primary=access_restriction': 'Zugangsbeschränkung',
  'tilda_parkings_off_street--condition_category_primary=assumed_free':
    'Wahrscheinlich keine Parkbeschränkungen',
  'tilda_parkings_off_street--condition_category_primary=assumed_private':
    'Sehr wahrscheinlich privat',
  'tilda_parkings_off_street--condition_category_primary=bus_lane': 'Bussonderfahrstreifen',
  'tilda_parkings_off_street--condition_category_primary=car_sharing':
    'Nur für Carsharing-Fahrzeuge',
  'tilda_parkings_off_street--condition_category_primary=charging': 'Laden von Elektrofahrzeugen',
  'tilda_parkings_off_street--condition_category_primary=default': 'Keine Zuordnung',
  'tilda_parkings_off_street--condition_category_primary=disabled': 'Behindertenparkplatz',
  'tilda_parkings_off_street--condition_category_primary=disabled_private':
    'Personenbezogener Behindertenparkplatz',
  'tilda_parkings_off_street--condition_category_primary=free': 'Keine Parkbeschränkungen',
  'tilda_parkings_off_street--condition_category_primary=invalid': 'Ungültige Angabe in OSM',
  'tilda_parkings_off_street--condition_category_primary=invalid--description':
    'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
  'tilda_parkings_off_street--condition_category_primary=loading': 'Ladezone',
  'tilda_parkings_off_street--condition_category_primary=maxweight': 'Gewichtsbegrenzung',
  'tilda_parkings_off_street--condition_category_primary=mixed':
    'Nur mit Parkschein oder Bewohnerparkausweis',
  'tilda_parkings_off_street--condition_category_primary=no_parking': 'Eingeschränktes Haltverbot',
  'tilda_parkings_off_street--condition_category_primary=no_standing': 'Nur kurzes Halten erlaubt',
  'tilda_parkings_off_street--condition_category_primary=no_stopping': 'Absolutes Haltverbot',
  'tilda_parkings_off_street--condition_category_primary=paid': 'Nur mit Parkschein',
  'tilda_parkings_off_street--condition_category_primary=private': 'Privat',
  'tilda_parkings_off_street--condition_category_primary=residents': 'Nur mit Bewohnerparkausweis',
  'tilda_parkings_off_street--condition_category_primary=taxi': 'Taxenstand',
  'tilda_parkings_off_street--condition_category_primary=time_limited': 'Höchstparkdauer',
  'tilda_parkings_off_street--condition_category_primary=unspecified': 'Unbestimmt',
  'tilda_parkings_off_street--condition_category_primary=vehicle_restriction':
    'Beschränkung auf Fahrzeugklassen',
  'tilda_parkings_off_street--condition_category--key': 'Parkbeschränkung',
  'tilda_parkings_off_street--condition_category=access_restriction': 'Zugangsbeschränkung',
  'tilda_parkings_off_street--condition_category=assumed_free':
    'Wahrscheinlich keine Parkbeschränkungen',
  'tilda_parkings_off_street--condition_category=assumed_private': 'Sehr wahrscheinlich privat',
  'tilda_parkings_off_street--condition_category=bus_lane': 'Bussonderfahrstreifen',
  'tilda_parkings_off_street--condition_category=car_sharing': 'Nur für Carsharing-Fahrzeuge',
  'tilda_parkings_off_street--condition_category=charging': 'Laden von Elektrofahrzeugen',
  'tilda_parkings_off_street--condition_category=disabled': 'Behindertenparkplatz',
  'tilda_parkings_off_street--condition_category=disabled_private':
    'Personenbezogener Behindertenparkplatz',
  'tilda_parkings_off_street--condition_category=free': 'Keine Parkbeschränkungen',
  'tilda_parkings_off_street--condition_category=invalid': 'Ungültige Angabe in OSM',
  'tilda_parkings_off_street--condition_category=invalid--description':
    'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
  'tilda_parkings_off_street--condition_category=loading': 'Ladezone',
  'tilda_parkings_off_street--condition_category=maxweight': 'Gewichtsbegrenzung',
  'tilda_parkings_off_street--condition_category=mixed':
    'Nur mit Parkschein oder Bewohnerparkausweis',
  'tilda_parkings_off_street--condition_category=no_parking': 'Eingeschränktes Haltverbot',
  'tilda_parkings_off_street--condition_category=no_standing': 'Nur kurzes Halten erlaubt',
  'tilda_parkings_off_street--condition_category=no_stopping': 'Absolutes Haltverbot',
  'tilda_parkings_off_street--condition_category=paid': 'Nur mit Parkschein',
  'tilda_parkings_off_street--condition_category=private': 'Privat',
  'tilda_parkings_off_street--condition_category=residents': 'Nur mit Bewohnerparkausweis',
  'tilda_parkings_off_street--condition_category=taxi': 'Taxenstand',
  'tilda_parkings_off_street--condition_category=time_limited': 'Höchstparkdauer',
  'tilda_parkings_off_street--condition_category=unspecified': 'Unbestimmt',
  'tilda_parkings_off_street--condition_category=vehicle_restriction':
    'Beschränkung auf Fahrzeugklassen',
  'tilda_parkings_off_street--covered--key': 'Überdacht',
  'tilda_parkings_off_street--covered=partial': 'Teilweise überdacht',
  'tilda_parkings_off_street--covered=yes': 'Überdacht',
  'tilda_parkings_off_street--informal--key': 'Duldung',
  'tilda_parkings_off_street--informal=yes':
    'Parken im rechtlichen Graubereich oder etabliertes, geduldetes Falschparken.',
  'tilda_parkings_off_street--location--key': 'Lage im Straßenraum',
  'tilda_parkings_off_street--location=lane_centre': 'Fahrbahnmitte',
  'tilda_parkings_off_street--location=median': 'Mittelstreifen',
  'tilda_parkings_off_street--mapillary--key': 'Mapillary',
  'tilda_parkings_off_street--markings--key': 'Markierungen',
  'tilda_parkings_off_street--markings=no': 'Ohne Markierungen',
  'tilda_parkings_off_street--markings=yes': 'Mit Markierungen',
  'tilda_parkings_off_street--operator_type_confidence--key': 'Konfidenz des Betreibertyps',
  'tilda_parkings_off_street--operator_type_confidence=high': 'Hoch',
  'tilda_parkings_off_street--operator_type_confidence=low': 'Niedrig',
  'tilda_parkings_off_street--operator_type_confidence=medium': 'Mittel',
  'tilda_parkings_off_street--operator_type_source--key': 'Herkunft des Betreibertyps',
  'tilda_parkings_off_street--operator_type_source=default_fallback':
    'Annahme bei fehlender Angabe.',
  'tilda_parkings_off_street--operator_type_source=driveway_inference':
    'Annahme bei fehlender Angabe wenn eine Einfahrt erkannt wurde.',
  'tilda_parkings_off_street--operator_type_source=manual_overwrite_list':
    'Anhand einer manuellen Korrekturliste in TILDA.',
  'tilda_parkings_off_street--operator_type_source=parent_highway_tag':
    'Explizite Angabe aus OSM an der zugeordneten Straße.',
  'tilda_parkings_off_street--operator_type_source=tag': 'Explizite Angabe aus OSM.',
  'tilda_parkings_off_street--operator_type--key': 'Betreibertyp',
  'tilda_parkings_off_street--operator_type=private': 'Privat',
  'tilda_parkings_off_street--operator_type=public': 'Öffentlich',
  'tilda_parkings_off_street--orientation--key': 'Ausrichtung',
  'tilda_parkings_off_street--orientation=diagonal': 'Schrägparken',
  'tilda_parkings_off_street--orientation=parallel': 'Parallelparken',
  'tilda_parkings_off_street--orientation=perpendicular': 'Querparken',
  'tilda_parkings_off_street--parking--key': 'Parkplatztyp',
  'tilda_parkings_off_street--parking=carport': 'Carport',
  'tilda_parkings_off_street--parking=carports': 'Carports',
  'tilda_parkings_off_street--parking=garage': 'Garage',
  'tilda_parkings_off_street--parking=garage_boxes': 'Garagenboxen',
  'tilda_parkings_off_street--parking=multi-storey': 'Parkhaus',
  'tilda_parkings_off_street--parking=rooftop': 'Dachparkplatz',
  'tilda_parkings_off_street--parking=surface': 'Oberflächenparkplatz',
  'tilda_parkings_off_street--parking=underground': 'Tiefgarage',
  'tilda_parkings_off_street--surface_confidence--key': 'Konfidenz der Oberfläche',
  'tilda_parkings_off_street--surface_confidence=high': 'Hoch',
  'tilda_parkings_off_street--surface_confidence=low': 'Niedrig',
  'tilda_parkings_off_street--surface_confidence=medium': 'Mittel',
  'tilda_parkings_off_street--surface_source--key': 'Herkunft der Oberfläche',
  'tilda_parkings_off_street--surface_source=parent_highway_tag': 'Von zugeordneter Straße (OSM)',
  'tilda_parkings_off_street--surface_source=parent_highway_tag_transformed':
    'Von zugeordneter Straße, normalisiert',
  'tilda_parkings_off_street--surface_source=tag': 'Explizite Angabe aus OSM',
  'tilda_parkings_off_street--surface_source=tag_transformed': 'Aus OSM-Tag normalisiert',
  'tilda_parkings_off_street--surface--key': 'Oberfläche',
  'tilda_parkings_off_street--surface=asphalt': 'Asphalt',
  'tilda_parkings_off_street--surface=bricks': 'Ziegel',
  'tilda_parkings_off_street--surface=compacted': 'Verdichteter Untergrund',
  'tilda_parkings_off_street--surface=concrete': 'Beton',
  'tilda_parkings_off_street--surface=concrete:lanes': 'Betonstreifen / -bahnen',
  'tilda_parkings_off_street--surface=concrete:plates': 'Betonplatten',
  'tilda_parkings_off_street--surface=fine_gravel': 'Splitt',
  'tilda_parkings_off_street--surface=grass': 'Gras',
  'tilda_parkings_off_street--surface=grass_paver': 'Rasengitter / Grasgitter',
  'tilda_parkings_off_street--surface=gravel': 'Schotter',
  'tilda_parkings_off_street--surface=ground': 'Erde/Boden',
  'tilda_parkings_off_street--surface=large_sett': 'Großpflaster',
  'tilda_parkings_off_street--surface=metal': 'Metall',
  'tilda_parkings_off_street--surface=metal_grid': 'Metallgitter',
  'tilda_parkings_off_street--surface=mosaic_sett': 'Mosaikpflaster',
  'tilda_parkings_off_street--surface=paved': 'Befestigt (unspezifisch)',
  'tilda_parkings_off_street--surface=paving_stones': 'Verbund&shy;pflastersteine',
  'tilda_parkings_off_street--surface=paving_stones:lanes': 'Pflasterstein&shy;bahnen',
  'tilda_parkings_off_street--surface=pebblestone': 'Kieselsteine',
  'tilda_parkings_off_street--surface=plastic': 'Kunststoff',
  'tilda_parkings_off_street--surface=rubber': 'Gummi',
  'tilda_parkings_off_street--surface=sand': 'Sand',
  'tilda_parkings_off_street--surface=sett': 'Behauenes Pflaster / Natursteinpflaster',
  'tilda_parkings_off_street--surface=small_sett': 'Kleinpflaster',
  'tilda_parkings_off_street--surface=stone': 'Stein',
  'tilda_parkings_off_street--surface=unpaved': 'Unbefestigt',
  'tilda_parkings_off_street--surface=wood': 'Holz',
  'tilda_parkings_off_street--surface=woodchips': 'Hackschnitzel',
  'tilda_parkings_off_street--title': 'Parken abseits des Straßenraums',
  'tilda_parkings_off_street--traffic_sign--key': 'Verkehrszeichen',
  'tilda_parkings_off_street--zone--key': 'Parkzone',
  'tilda_parkings--_staggered_maneuvering_loss--key':
    '(Intern) Manövrierraumverlust (alternierendes Parken)',
  'tilda_parkings--_staggered_original_capacity--key':
    '(Intern) Ursprüngliche Kapazität (vor Staggered-Anpassung)',
  'tilda_parkings--access--key': 'Zugang',
  'tilda_parkings--access=customers': 'Kund:innen',
  'tilda_parkings--access=delivery': 'Lieferverkehr',
  'tilda_parkings--access=destination': 'Anlieger frei (Nicht-Durchgangsverkehr erlaubt)',
  'tilda_parkings--access=employees': 'Mitarbeiter',
  'tilda_parkings--access=no': 'Kein Zugang',
  'tilda_parkings--access=permissive': 'Öffentliche Nutzung geduldet',
  'tilda_parkings--access=permit': 'Mit Genehmigung',
  'tilda_parkings--access=private': 'Privat',
  'tilda_parkings--access=public': 'Öffentlich (explizit)',
  'tilda_parkings--access=residents': 'Nur mit Bewohnerparkausweis',
  'tilda_parkings--angle--key': 'Textwinkel',
  'tilda_parkings--area_confidence--key': 'Konfidenz der Flächenangabe',
  'tilda_parkings--area_confidence=high': 'Hoch',
  'tilda_parkings--area_confidence=low': 'Niedrig',
  'tilda_parkings--area_confidence=medium': 'Mittel',
  'tilda_parkings--area_source--key': 'Herkunft der Flächenangabe',
  'tilda_parkings--area_source=estimated':
    'Berechnet auf Basis der Länge der Liniengeometrie und Fahrzeugausrichtung.',
  'tilda_parkings--area_source=geometry': 'Basiert auf dem Flächeninhalt der Geometrie aus OSM.',
  'tilda_parkings--area--key': 'Fläche',
  'tilda_parkings--capacity_confidence--key': 'Konfidenz der Stellplatzanzahl',
  'tilda_parkings--capacity_confidence=high': 'Hoch',
  'tilda_parkings--capacity_confidence=low': 'Niedrig',
  'tilda_parkings--capacity_confidence=medium': 'Mittel',
  'tilda_parkings--capacity_left--key': 'Öffentliche Stellplätze links',
  'tilda_parkings--capacity_private_left--key': 'Private Stellplätze links',
  'tilda_parkings--capacity_private_right--key': 'Private Stellplätze rechts',
  'tilda_parkings--capacity_right--key': 'Öffentliche Stellplätze rechts',
  'tilda_parkings--capacity_source--key': 'Herkunft der Stellplatzanzahl',
  'tilda_parkings--capacity_source=area_and_orientation_diagonal':
    'Berechnet auf Basis der Fläche und Parkausrichtung.',
  'tilda_parkings--capacity_source=area_and_orientation_diagonal_redistributed':
    'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings--capacity_source=area_and_orientation_fallback_parallel':
    'Berechnet auf Basis der Fläche und Parkausrichtung. Allerdings war die Parkausrichtung unbekannt, so dass Parallelparken angenommen wurde.',
  'tilda_parkings--capacity_source=area_and_orientation_parallel':
    'Berechnet auf Basis der Fläche und Parkausrichtung.',
  'tilda_parkings--capacity_source=area_and_orientation_parallel_redistributed':
    'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings--capacity_source=area_and_orientation_perpendicular':
    'Berechnet auf Basis der Fläche und Parkausrichtung.',
  'tilda_parkings--capacity_source=area_and_orientation_perpendicular_redistributed':
    'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings--capacity_source=assumed_default':
    'Keine explizite Angabe vorgefunden; dieser Wert ist eine Annahme.',
  'tilda_parkings--capacity_source=estimated': 'Berechnung',
  'tilda_parkings--capacity_source=estimated_from_area':
    'Berechnet auf Basis der Fläche und Ausrichtung.',
  'tilda_parkings--capacity_source=estimated_from_length':
    'Berechnet auf Basis der Linien-Länge und Ausrichtung.',
  'tilda_parkings--capacity_source=estimated_redistributed': 'Geschätzt, Kapazität umverteilt',
  'tilda_parkings--capacity_source=tag': 'Explizite Angabe aus OSM.',
  'tilda_parkings--capacity_source=tag_estimation': 'Explizite Angabe einer Schätzung aus OSM.',
  'tilda_parkings--capacity_source=tag_estimation_redistributed':
    'Explizite Angabe einer Schätzung aus OSM, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings--capacity_source=tag_redistributed':
    'Explizite Angabe aus OSM, dann anteilig aufgeteilt nach Stanzung.',
  'tilda_parkings--capacity--key': 'Stellplatzanzahl',
  'tilda_parkings--category--key': 'Kategorie',
  'tilda_parkings--category=bus_stop': 'Bushaltestelle',
  'tilda_parkings--category=crossing_marked': 'Markierter Überweg',
  'tilda_parkings--category=tree': 'Baum',
  'tilda_parkings--condition_category_left--key': 'Parkbeschränkung links',
  'tilda_parkings--condition_category_left=access_restriction': 'Zugangsbeschränkung',
  'tilda_parkings--condition_category_left=assumed_free': 'Wahrscheinlich keine Parkbeschränkungen',
  'tilda_parkings--condition_category_left=assumed_private': 'Sehr wahrscheinlich privat',
  'tilda_parkings--condition_category_left=bus_lane': 'Bussonderfahrstreifen',
  'tilda_parkings--condition_category_left=car_sharing': 'Nur für Carsharing-Fahrzeuge',
  'tilda_parkings--condition_category_left=charging': 'Laden von Elektrofahrzeugen',
  'tilda_parkings--condition_category_left=default': 'Keine Zuordnung',
  'tilda_parkings--condition_category_left=disabled': 'Behindertenparkplatz',
  'tilda_parkings--condition_category_left=disabled_private':
    'Personenbezogener Behindertenparkplatz',
  'tilda_parkings--condition_category_left=free': 'Keine Parkbeschränkungen',
  'tilda_parkings--condition_category_left=invalid': 'Ungültige Angabe in OSM',
  'tilda_parkings--condition_category_left=invalid--description':
    'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
  'tilda_parkings--condition_category_left=loading': 'Ladezone',
  'tilda_parkings--condition_category_left=maxweight': 'Gewichtsbegrenzung',
  'tilda_parkings--condition_category_left=mixed': 'Nur mit Parkschein oder Bewohnerparkausweis',
  'tilda_parkings--condition_category_left=no_parking': 'Eingeschränktes Haltverbot',
  'tilda_parkings--condition_category_left=no_standing': 'Nur kurzes Halten erlaubt',
  'tilda_parkings--condition_category_left=no_stopping': 'Absolutes Haltverbot',
  'tilda_parkings--condition_category_left=paid': 'Nur mit Parkschein',
  'tilda_parkings--condition_category_left=private': 'Privat',
  'tilda_parkings--condition_category_left=residents': 'Nur mit Bewohnerparkausweis',
  'tilda_parkings--condition_category_left=taxi': 'Taxenstand',
  'tilda_parkings--condition_category_left=time_limited': 'Höchstparkdauer',
  'tilda_parkings--condition_category_left=unspecified': 'Unbestimmt',
  'tilda_parkings--condition_category_left=vehicle_restriction': 'Beschränkung auf Fahrzeugklassen',
  'tilda_parkings--condition_category_primary--key': 'Primäre Parkbeschränkung',
  'tilda_parkings--condition_category_primary=access_restriction': 'Zugangsbeschränkung',
  'tilda_parkings--condition_category_primary=assumed_free':
    'Wahrscheinlich keine Parkbeschränkungen',
  'tilda_parkings--condition_category_primary=assumed_private': 'Sehr wahrscheinlich privat',
  'tilda_parkings--condition_category_primary=bus_lane': 'Bussonderfahrstreifen',
  'tilda_parkings--condition_category_primary=car_sharing': 'Nur für Carsharing-Fahrzeuge',
  'tilda_parkings--condition_category_primary=charging': 'Laden von Elektrofahrzeugen',
  'tilda_parkings--condition_category_primary=default': 'Keine Zuordnung',
  'tilda_parkings--condition_category_primary=disabled': 'Behindertenparkplatz',
  'tilda_parkings--condition_category_primary=disabled_private':
    'Personenbezogener Behindertenparkplatz',
  'tilda_parkings--condition_category_primary=free': 'Keine Parkbeschränkungen',
  'tilda_parkings--condition_category_primary=invalid': 'Ungültige Angabe in OSM',
  'tilda_parkings--condition_category_primary=invalid--description':
    'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
  'tilda_parkings--condition_category_primary=loading': 'Ladezone',
  'tilda_parkings--condition_category_primary=maxweight': 'Gewichtsbegrenzung',
  'tilda_parkings--condition_category_primary=mixed': 'Nur mit Parkschein oder Bewohnerparkausweis',
  'tilda_parkings--condition_category_primary=no_parking': 'Eingeschränktes Haltverbot',
  'tilda_parkings--condition_category_primary=no_standing': 'Nur kurzes Halten erlaubt',
  'tilda_parkings--condition_category_primary=no_stopping': 'Absolutes Haltverbot',
  'tilda_parkings--condition_category_primary=paid': 'Nur mit Parkschein',
  'tilda_parkings--condition_category_primary=private': 'Privat',
  'tilda_parkings--condition_category_primary=residents': 'Nur mit Bewohnerparkausweis',
  'tilda_parkings--condition_category_primary=taxi': 'Taxenstand',
  'tilda_parkings--condition_category_primary=time_limited': 'Höchstparkdauer',
  'tilda_parkings--condition_category_primary=unspecified': 'Unbestimmt',
  'tilda_parkings--condition_category_primary=vehicle_restriction':
    'Beschränkung auf Fahrzeugklassen',
  'tilda_parkings--condition_category_right--key': 'Parkbeschränkung rechts',
  'tilda_parkings--condition_category_right=access_restriction': 'Zugangsbeschränkung',
  'tilda_parkings--condition_category_right=assumed_free':
    'Wahrscheinlich keine Parkbeschränkungen',
  'tilda_parkings--condition_category_right=assumed_private': 'Sehr wahrscheinlich privat',
  'tilda_parkings--condition_category_right=bus_lane': 'Bussonderfahrstreifen',
  'tilda_parkings--condition_category_right=car_sharing': 'Nur für Carsharing-Fahrzeuge',
  'tilda_parkings--condition_category_right=charging': 'Laden von Elektrofahrzeugen',
  'tilda_parkings--condition_category_right=default': 'Keine Zuordnung',
  'tilda_parkings--condition_category_right=disabled': 'Behindertenparkplatz',
  'tilda_parkings--condition_category_right=disabled_private':
    'Personenbezogener Behindertenparkplatz',
  'tilda_parkings--condition_category_right=free': 'Keine Parkbeschränkungen',
  'tilda_parkings--condition_category_right=invalid': 'Ungültige Angabe in OSM',
  'tilda_parkings--condition_category_right=invalid--description':
    'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
  'tilda_parkings--condition_category_right=loading': 'Ladezone',
  'tilda_parkings--condition_category_right=maxweight': 'Gewichtsbegrenzung',
  'tilda_parkings--condition_category_right=mixed': 'Nur mit Parkschein oder Bewohnerparkausweis',
  'tilda_parkings--condition_category_right=no_parking': 'Eingeschränktes Haltverbot',
  'tilda_parkings--condition_category_right=no_standing': 'Nur kurzes Halten erlaubt',
  'tilda_parkings--condition_category_right=no_stopping': 'Absolutes Haltverbot',
  'tilda_parkings--condition_category_right=paid': 'Nur mit Parkschein',
  'tilda_parkings--condition_category_right=private': 'Privat',
  'tilda_parkings--condition_category_right=residents': 'Nur mit Bewohnerparkausweis',
  'tilda_parkings--condition_category_right=taxi': 'Taxenstand',
  'tilda_parkings--condition_category_right=time_limited': 'Höchstparkdauer',
  'tilda_parkings--condition_category_right=unspecified': 'Unbestimmt',
  'tilda_parkings--condition_category_right=vehicle_restriction':
    'Beschränkung auf Fahrzeugklassen',
  'tilda_parkings--condition_category--key': 'Parkbeschränkung',
  'tilda_parkings--condition_category=access_restriction': 'Zugangsbeschränkung',
  'tilda_parkings--condition_category=assumed_free': 'Wahrscheinlich keine Parkbeschränkungen',
  'tilda_parkings--condition_category=assumed_private': 'Sehr wahrscheinlich privat',
  'tilda_parkings--condition_category=bus_lane': 'Bussonderfahrstreifen',
  'tilda_parkings--condition_category=car_sharing': 'Nur für Carsharing-Fahrzeuge',
  'tilda_parkings--condition_category=charging': 'Laden von Elektrofahrzeugen',
  'tilda_parkings--condition_category=disabled': 'Behindertenparkplatz',
  'tilda_parkings--condition_category=disabled_private': 'Personenbezogener Behindertenparkplatz',
  'tilda_parkings--condition_category=free': 'Keine Parkbeschränkungen',
  'tilda_parkings--condition_category=invalid': 'Ungültige Angabe in OSM',
  'tilda_parkings--condition_category=invalid--description':
    'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
  'tilda_parkings--condition_category=loading': 'Ladezone',
  'tilda_parkings--condition_category=maxweight': 'Gewichtsbegrenzung',
  'tilda_parkings--condition_category=mixed': 'Nur mit Parkschein oder Bewohnerparkausweis',
  'tilda_parkings--condition_category=no_parking': 'Eingeschränktes Haltverbot',
  'tilda_parkings--condition_category=no_standing': 'Nur kurzes Halten erlaubt',
  'tilda_parkings--condition_category=no_stopping': 'Absolutes Haltverbot',
  'tilda_parkings--condition_category=paid': 'Nur mit Parkschein',
  'tilda_parkings--condition_category=private': 'Privat',
  'tilda_parkings--condition_category=residents': 'Nur mit Bewohnerparkausweis',
  'tilda_parkings--condition_category=taxi': 'Taxenstand',
  'tilda_parkings--condition_category=time_limited': 'Höchstparkdauer',
  'tilda_parkings--condition_category=unspecified': 'Unbestimmt',
  'tilda_parkings--condition_category=vehicle_restriction': 'Beschränkung auf Fahrzeugklassen',
  'tilda_parkings--covered--key': 'Überdacht',
  'tilda_parkings--covered=partial': 'Teilweise überdacht',
  'tilda_parkings--covered=yes': 'Überdacht',
  'tilda_parkings--direction--key': 'Einparkrichtung',
  'tilda_parkings--direction=back_in': 'Rückwärts einparken',
  'tilda_parkings--direction=head_in': 'Vorwärts einparken',
  'tilda_parkings--end_node--key': 'Endknoten',
  'tilda_parkings--geom_sources--key': '(Intern) OSM-IDs der Geometrien',
  'tilda_parkings--highway--key': 'OSM-Straßentyp',
  'tilda_parkings--highway=construction': 'Straße ist in Bau',
  'tilda_parkings--highway=cycleway': 'Radweg',
  'tilda_parkings--highway=footway': 'Fußweg',
  'tilda_parkings--highway=living_street': 'Verkehrsberuhigter Bereich',
  'tilda_parkings--highway=motorway': 'Autobahn',
  'tilda_parkings--highway=motorway_link': 'Zufahrt einer Autobahn',
  'tilda_parkings--highway=path': 'Weg / Pfad',
  'tilda_parkings--highway=pedestrian': 'Fußgängerzone',
  'tilda_parkings--highway=primary': 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'tilda_parkings--highway=primary_link':
    'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'tilda_parkings--highway=residential': 'Anwohnerstraße',
  'tilda_parkings--highway=road': 'Unkategorisierte Straße',
  'tilda_parkings--highway=secondary': 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
  'tilda_parkings--highway=secondary_link':
    'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
  'tilda_parkings--highway=service': 'Zufahrtsweg',
  'tilda_parkings--highway=steps': 'Stufen',
  'tilda_parkings--highway=tertiary': 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
  'tilda_parkings--highway=tertiary_link':
    'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
  'tilda_parkings--highway=track': 'Wald- / Feldweg',
  'tilda_parkings--highway=trunk': 'Kraftfahrstraße',
  'tilda_parkings--highway=trunk_link': 'Kraftfahrstraßen-Anschluss',
  'tilda_parkings--highway=unclassified': 'Nebenstraße mit Verbindungscharakter',
  'tilda_parkings--informal--key': 'Duldung',
  'tilda_parkings--informal=yes':
    'Parken im rechtlichen Graubereich oder etabliertes, geduldetes Falschparken.',
  'tilda_parkings--length--key': 'Länge',
  'tilda_parkings--location--key': 'Lage im Straßenraum',
  'tilda_parkings--location=lane_centre': 'Fahrbahnmitte',
  'tilda_parkings--location=median': 'Mittelstreifen',
  'tilda_parkings--mapillary--key': 'Mapillary',
  'tilda_parkings--markings--key': 'Markierungen',
  'tilda_parkings--markings=no': 'Ohne Markierungen',
  'tilda_parkings--markings=yes': 'Mit Markierungen',
  'tilda_parkings--name--key': 'Straßenname',
  'tilda_parkings--operator_type_confidence--key': 'Konfidenz des Betreibertyps',
  'tilda_parkings--operator_type_confidence=high': 'Hoch',
  'tilda_parkings--operator_type_confidence=low': 'Niedrig',
  'tilda_parkings--operator_type_confidence=medium': 'Mittel',
  'tilda_parkings--operator_type_left--key': 'Operator links',
  'tilda_parkings--operator_type_left=private': 'Privat',
  'tilda_parkings--operator_type_left=public': 'Öffentlich',
  'tilda_parkings--operator_type_right--key': 'Operator rechts',
  'tilda_parkings--operator_type_right=private': 'Privat',
  'tilda_parkings--operator_type_right=public': 'Öffentlich',
  'tilda_parkings--operator_type_source--key': 'Herkunft des Betreibertyps',
  'tilda_parkings--operator_type_source=default_fallback': 'Annahme bei fehlender Angabe.',
  'tilda_parkings--operator_type_source=driveway_inference':
    'Annahme bei fehlender Angabe wenn eine Einfahrt erkannt wurde.',
  'tilda_parkings--operator_type_source=manual_overwrite_list':
    'Anhand einer manuellen Korrekturliste in TILDA.',
  'tilda_parkings--operator_type_source=parent_highway_tag':
    'Explizite Angabe aus OSM an der zugeordneten Straße.',
  'tilda_parkings--operator_type_source=tag': 'Explizite Angabe aus OSM.',
  'tilda_parkings--operator_type--key': 'Betreibertyp',
  'tilda_parkings--operator_type=private': 'Privat',
  'tilda_parkings--operator_type=public': 'Öffentlich',
  'tilda_parkings--orientation--key': 'Ausrichtung',
  'tilda_parkings--orientation=diagonal': 'Schrägparken',
  'tilda_parkings--orientation=parallel': 'Parallelparken',
  'tilda_parkings--orientation=perpendicular': 'Querparken',
  'tilda_parkings--parking_left--key': 'Parkposition links',
  'tilda_parkings--parking_left=half_on_kerb': 'Halb auf dem Gehweg',
  'tilda_parkings--parking_left=lane': 'Auf der Fahrbahn',
  'tilda_parkings--parking_left=missing': 'Daten in OSM fehlen',
  'tilda_parkings--parking_left=no': 'Kein Parken (Sonstiger/Unbekannter Grund)',
  'tilda_parkings--parking_left=no_parking': 'Eingeschränktes Haltverbot',
  'tilda_parkings--parking_left=no_standing': 'Nur kurzes Halten erlaubt',
  'tilda_parkings--parking_left=no_stopping': 'Absolutes Haltverbot',
  'tilda_parkings--parking_left=not_expected': 'Kein Parken zu erwarten',
  'tilda_parkings--parking_left=on_kerb': 'Ganz auf dem Gehweg',
  'tilda_parkings--parking_left=separate': 'Parkraum als separate Geometrie erfasst',
  'tilda_parkings--parking_left=shoulder': 'Auf dem Seitenstreifen',
  'tilda_parkings--parking_left=street_side': 'Parkbucht',
  'tilda_parkings--parking_left=yes': 'Nicht näher bestimmtes Straßenparken',
  'tilda_parkings--parking_right--key': 'Parkposition rechts',
  'tilda_parkings--parking_right=half_on_kerb': 'Halb auf dem Gehweg',
  'tilda_parkings--parking_right=lane': 'Auf der Fahrbahn',
  'tilda_parkings--parking_right=missing': 'Daten in OSM fehlen',
  'tilda_parkings--parking_right=no': 'Kein Parken (Sonstiger/Unbekannter Grund)',
  'tilda_parkings--parking_right=no_parking': 'Eingeschränktes Haltverbot',
  'tilda_parkings--parking_right=no_standing': 'Nur kurzes Halten erlaubt',
  'tilda_parkings--parking_right=no_stopping': 'Absolutes Haltverbot',
  'tilda_parkings--parking_right=not_expected': 'Kein Parken zu erwarten',
  'tilda_parkings--parking_right=on_kerb': 'Ganz auf dem Gehweg',
  'tilda_parkings--parking_right=separate': 'Parkraum als separate Geometrie erfasst',
  'tilda_parkings--parking_right=shoulder': 'Auf dem Seitenstreifen',
  'tilda_parkings--parking_right=street_side': 'Parkbucht',
  'tilda_parkings--parking_right=yes': 'Nicht näher bestimmtes Straßenparken',
  'tilda_parkings--parking--key': 'Parkposition',
  'tilda_parkings--parking=half_on_kerb': 'Halb auf dem Gehweg',
  'tilda_parkings--parking=lane': 'Auf der Fahrbahn',
  'tilda_parkings--parking=missing': 'Daten in OSM fehlen',
  'tilda_parkings--parking=no': 'Kein Parken (Sonstiger/Unbekannter Grund)',
  'tilda_parkings--parking=no_parking': 'Eingeschränktes Haltverbot',
  'tilda_parkings--parking=no_standing': 'Nur kurzes Halten erlaubt',
  'tilda_parkings--parking=no_stopping': 'Absolutes Haltverbot',
  'tilda_parkings--parking=not_expected': 'Kein Parken zu erwarten',
  'tilda_parkings--parking=on_kerb': 'Ganz auf dem Gehweg',
  'tilda_parkings--parking=separate': 'Parkraum als separate Geometrie erfasst',
  'tilda_parkings--parking=shoulder': 'Auf dem Seitenstreifen',
  'tilda_parkings--parking=street_side': 'Parkbucht',
  'tilda_parkings--parking=yes': 'Nicht näher bestimmtes Straßenparken',
  'tilda_parkings--reason--key': 'Grund',
  'tilda_parkings--reason=bus_stop': 'Haltestelle',
  'tilda_parkings--reason=cycleway': 'Radverkehrsanlage',
  'tilda_parkings--reason=dual_carriage': 'Getrennte Richtungsfahrbahnen',
  'tilda_parkings--reason=junction': 'Knotenpunkt / Einmündung',
  'tilda_parkings--reason=missing_data': 'Keine Parkraum-Daten in OpenStreetMap erfasst',
  'tilda_parkings--reason=narrow': 'Zu schmale Fahrbahn',
  'tilda_parkings--reason=parking_tag': 'Explizite Angabe in den Daten',
  'tilda_parkings--reason=restriction_no_parking': 'Explizites Parkverbot aus OSM',
  'tilda_parkings--reason=restriction_no_standing': 'Eingeschränktes Halteverbot aus OSM',
  'tilda_parkings--reason=restriction_no_stopping': 'Explizites Halteverbot aus OSM',
  'tilda_parkings--road_name--key': 'Straßenname',
  'tilda_parkings--road_oneway--key': 'Einbahnstraße',
  'tilda_parkings--road_oneway=no': 'Nein (in beide Richtungen befahrbar)',
  'tilda_parkings--road_oneway=yes': 'Einbahnstraße',
  'tilda_parkings--road_oneway=yes_dual_carriageway':
    'Einbahnstraße (getrennte Richtungsfahrbahnen)',
  'tilda_parkings--road_width_confidence--key': 'Konfidenz der Fahrbahnbreite',
  'tilda_parkings--road_width_confidence=high': 'Hoch',
  'tilda_parkings--road_width_confidence=low': 'Niedrig',
  'tilda_parkings--road_width_confidence=medium': 'Mittel',
  'tilda_parkings--road_width_source--key': 'Herkunft der Fahrbahnbreite',
  'tilda_parkings--road_width_source=highway_default': 'Standard-Wert für diesen Straßentyp.',
  'tilda_parkings--road_width_source=highway_default_and_oneway':
    'Standard-Wert für diesen Straßentyp als Einbahnstraße.',
  'tilda_parkings--road_width_source=tag': 'Dieser Wert ist in OSM hinterlegt.',
  'tilda_parkings--road_width--key': 'Fahrbahnbreite',
  'tilda_parkings--road--key': 'Straßentyp',
  'tilda_parkings--road=bicycle_road': 'Fahrradstraße',
  'tilda_parkings--road=construction': 'Straße ist in Bau',
  'tilda_parkings--road=cycleway': 'Radweg',
  'tilda_parkings--road=cycleway_crossing': 'Straßenquerung (Radweg)',
  'tilda_parkings--road=footway': 'Fußweg',
  'tilda_parkings--road=footway_crossing': 'Straßenquerung (Fußweg)',
  'tilda_parkings--road=footway_cycleway_crossing': 'Straßenquerung (Fuß- und Radweg)',
  'tilda_parkings--road=footway_sidewalk': 'Gehweg',
  'tilda_parkings--road=footway_steps': 'Treppe',
  'tilda_parkings--road=living_street': 'Verkehrsberuhigter Bereich',
  'tilda_parkings--road=motorway': 'Autobahn',
  'tilda_parkings--road=motorway_link': 'Zufahrt einer Autobahn',
  'tilda_parkings--road=path': 'Weg / Pfad',
  'tilda_parkings--road=pedestrian': 'Fußgängerzone',
  'tilda_parkings--road=primary': 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'tilda_parkings--road=primary_link':
    'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
  'tilda_parkings--road=residential': 'Anwohnerstraße',
  'tilda_parkings--road=residential_priority_road': 'residential_priority_road',
  'tilda_parkings--road=secondary': 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
  'tilda_parkings--road=secondary_link':
    'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
  'tilda_parkings--road=service_alley': 'Gasse',
  'tilda_parkings--road=service_driveway': 'Grundstückszufahrt',
  'tilda_parkings--road=service_emergency_access': 'Rettungsweg',
  'tilda_parkings--road=service_parking_aisle': 'Parkplatzweg',
  'tilda_parkings--road=service_road': 'Zufahrtsweg',
  'tilda_parkings--road=service_uncategorized': 'Zufahrtsweg (unbekannte Klassifizierung)',
  'tilda_parkings--road=tertiary': 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
  'tilda_parkings--road=tertiary_link':
    'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
  'tilda_parkings--road=track': 'Wald- / Feldweg',
  'tilda_parkings--road=unclassified': 'Nebenstraße mit Verbindungscharakter',
  'tilda_parkings--road=unspecified_road': 'Unkategorisierte Straße',
  'tilda_parkings--side--key': 'Straßenseite',
  'tilda_parkings--side=left': 'Links',
  'tilda_parkings--side=right': 'Rechts',
  'tilda_parkings--source--key': 'Datenquelle',
  'tilda_parkings--source=parkings': 'Angaben an der Straßenlinie',
  'tilda_parkings--source=separate_parking_areas': 'Separat erfasste Flächendaten',
  'tilda_parkings--source=separate_parking_points': 'Separate erfasste Punktdaten',
  'tilda_parkings--staggered--key': 'Parkweise',
  'tilda_parkings--staggered=no': 'Nicht alternierend',
  'tilda_parkings--staggered=yes': 'Alternierendes Parken',
  'tilda_parkings--staggered=yes--description':
    'Auf diesem Abschnitt ist die Fahrbahn zu schmal, um auf beiden Seiten gleichzeitig zu parken. Es gibt keine Markierungen oder Schilder, die das Parken regeln. Häufig entwickeln sich örtliche Konventionen, in welchen Bereichen auf welcher Seite geparkt wird. In die Kapazitätsberechnung fließt das ein: Die Kapazität wird um 50% reduziert (da nur eine Seite genutzt werden kann) und zusätzlich wird für jeden 60m-Abschnitt ein Manövrierraumverlust von 10m (≈1,9 Fahrzeugplätze) abgezogen, da beim Seitenwechsel Manövrierraum benötigt wird. Diese Angaben basieren auf Erfahrungswerten und können lediglich eine Schätzung des tatsächlichen Parkgeschehens abbilden.',
  'tilda_parkings--start_node--key': 'Startknoten',
  'tilda_parkings--surface_confidence--key': 'Konfidenz der Oberfläche',
  'tilda_parkings--surface_confidence=high': 'Hoch',
  'tilda_parkings--surface_confidence=low': 'Niedrig',
  'tilda_parkings--surface_confidence=medium': 'Mittel',
  'tilda_parkings--surface_left--key': 'Oberfläche links',
  'tilda_parkings--surface_left=asphalt': 'Asphalt',
  'tilda_parkings--surface_left=bricks': 'Ziegel',
  'tilda_parkings--surface_left=compacted': 'Verdichteter Untergrund',
  'tilda_parkings--surface_left=concrete': 'Beton',
  'tilda_parkings--surface_left=concrete:lanes': 'Betonstreifen / -bahnen',
  'tilda_parkings--surface_left=concrete:plates': 'Betonplatten',
  'tilda_parkings--surface_left=fine_gravel': 'Splitt',
  'tilda_parkings--surface_left=grass': 'Gras',
  'tilda_parkings--surface_left=grass_paver': 'Rasengitter / Grasgitter',
  'tilda_parkings--surface_left=gravel': 'Schotter',
  'tilda_parkings--surface_left=ground': 'Erde/Boden',
  'tilda_parkings--surface_left=large_sett': 'Großpflaster',
  'tilda_parkings--surface_left=metal': 'Metall',
  'tilda_parkings--surface_left=metal_grid': 'Metallgitter',
  'tilda_parkings--surface_left=mosaic_sett': 'Mosaikpflaster',
  'tilda_parkings--surface_left=paved': 'Befestigt (unspezifisch)',
  'tilda_parkings--surface_left=paving_stones': 'Verbund&shy;pflastersteine',
  'tilda_parkings--surface_left=paving_stones:lanes': 'Pflasterstein&shy;bahnen',
  'tilda_parkings--surface_left=pebblestone': 'Kieselsteine',
  'tilda_parkings--surface_left=plastic': 'Kunststoff',
  'tilda_parkings--surface_left=rubber': 'Gummi',
  'tilda_parkings--surface_left=sand': 'Sand',
  'tilda_parkings--surface_left=sett': 'Behauenes Pflaster / Natursteinpflaster',
  'tilda_parkings--surface_left=small_sett': 'Kleinpflaster',
  'tilda_parkings--surface_left=stone': 'Stein',
  'tilda_parkings--surface_left=unpaved': 'Unbefestigt',
  'tilda_parkings--surface_left=wood': 'Holz',
  'tilda_parkings--surface_left=woodchips': 'Hackschnitzel',
  'tilda_parkings--surface_right--key': 'Oberfläche rechts',
  'tilda_parkings--surface_right=asphalt': 'Asphalt',
  'tilda_parkings--surface_right=bricks': 'Ziegel',
  'tilda_parkings--surface_right=compacted': 'Verdichteter Untergrund',
  'tilda_parkings--surface_right=concrete': 'Beton',
  'tilda_parkings--surface_right=concrete:lanes': 'Betonstreifen / -bahnen',
  'tilda_parkings--surface_right=concrete:plates': 'Betonplatten',
  'tilda_parkings--surface_right=fine_gravel': 'Splitt',
  'tilda_parkings--surface_right=grass': 'Gras',
  'tilda_parkings--surface_right=grass_paver': 'Rasengitter / Grasgitter',
  'tilda_parkings--surface_right=gravel': 'Schotter',
  'tilda_parkings--surface_right=ground': 'Erde/Boden',
  'tilda_parkings--surface_right=large_sett': 'Großpflaster',
  'tilda_parkings--surface_right=metal': 'Metall',
  'tilda_parkings--surface_right=metal_grid': 'Metallgitter',
  'tilda_parkings--surface_right=mosaic_sett': 'Mosaikpflaster',
  'tilda_parkings--surface_right=paved': 'Befestigt (unspezifisch)',
  'tilda_parkings--surface_right=paving_stones': 'Verbund&shy;pflastersteine',
  'tilda_parkings--surface_right=paving_stones:lanes': 'Pflasterstein&shy;bahnen',
  'tilda_parkings--surface_right=pebblestone': 'Kieselsteine',
  'tilda_parkings--surface_right=plastic': 'Kunststoff',
  'tilda_parkings--surface_right=rubber': 'Gummi',
  'tilda_parkings--surface_right=sand': 'Sand',
  'tilda_parkings--surface_right=sett': 'Behauenes Pflaster / Natursteinpflaster',
  'tilda_parkings--surface_right=small_sett': 'Kleinpflaster',
  'tilda_parkings--surface_right=stone': 'Stein',
  'tilda_parkings--surface_right=unpaved': 'Unbefestigt',
  'tilda_parkings--surface_right=wood': 'Holz',
  'tilda_parkings--surface_right=woodchips': 'Hackschnitzel',
  'tilda_parkings--surface_source--key': 'Herkunft der Oberfläche',
  'tilda_parkings--surface_source=parent_highway_tag': 'Von zugeordneter Straße (OSM)',
  'tilda_parkings--surface_source=parent_highway_tag_transformed':
    'Von zugeordneter Straße, normalisiert',
  'tilda_parkings--surface_source=tag': 'Explizite Angabe aus OSM',
  'tilda_parkings--surface_source=tag_transformed': 'Aus OSM-Tag normalisiert',
  'tilda_parkings--surface--key': 'Oberfläche',
  'tilda_parkings--surface=asphalt': 'Asphalt',
  'tilda_parkings--surface=bricks': 'Ziegel',
  'tilda_parkings--surface=compacted': 'Verdichteter Untergrund',
  'tilda_parkings--surface=concrete': 'Beton',
  'tilda_parkings--surface=concrete:lanes': 'Betonstreifen / -bahnen',
  'tilda_parkings--surface=concrete:plates': 'Betonplatten',
  'tilda_parkings--surface=fine_gravel': 'Splitt',
  'tilda_parkings--surface=grass': 'Gras',
  'tilda_parkings--surface=grass_paver': 'Rasengitter / Grasgitter',
  'tilda_parkings--surface=gravel': 'Schotter',
  'tilda_parkings--surface=ground': 'Erde/Boden',
  'tilda_parkings--surface=large_sett': 'Großpflaster',
  'tilda_parkings--surface=metal': 'Metall',
  'tilda_parkings--surface=metal_grid': 'Metallgitter',
  'tilda_parkings--surface=mosaic_sett': 'Mosaikpflaster',
  'tilda_parkings--surface=paved': 'Befestigt (unspezifisch)',
  'tilda_parkings--surface=paving_stones': 'Verbund&shy;pflastersteine',
  'tilda_parkings--surface=paving_stones:lanes': 'Pflasterstein&shy;bahnen',
  'tilda_parkings--surface=pebblestone': 'Kieselsteine',
  'tilda_parkings--surface=plastic': 'Kunststoff',
  'tilda_parkings--surface=rubber': 'Gummi',
  'tilda_parkings--surface=sand': 'Sand',
  'tilda_parkings--surface=sett': 'Behauenes Pflaster / Natursteinpflaster',
  'tilda_parkings--surface=small_sett': 'Kleinpflaster',
  'tilda_parkings--surface=stone': 'Stein',
  'tilda_parkings--surface=unpaved': 'Unbefestigt',
  'tilda_parkings--surface=wood': 'Holz',
  'tilda_parkings--surface=woodchips': 'Hackschnitzel',
  'tilda_parkings--tag_sources--key': 'Tag-Quellen',
  'tilda_parkings--title': 'Straßenparken',
  'tilda_parkings--traffic_sign--key': 'Verkehrszeichen',
  'tilda_parkings--way_ids--key': 'OSM-Way-IDs',
  'tilda_parkings--way_reversed--key': 'Way-Richtung',
  'tilda_parkings--zone--key': 'Parkzone',
} as const satisfies Record<string, string>

export default data
